import React from "react";
import * as Icon from 'ubs-icons';
import {getMobileOperatingSystem, isInApp} from "ubs-framework/src/common/function";
import { ROUTES } from './modules'

export const ON_BOARDING = false // true, false
export const PRODUCT_ACCESS = {HRMS: true, PMS: true, CHAT: true, PAYROLL: true, SURVEY: true, RECRUIT: true}

export const ALLOCATION = {
    USER_ID: ["5f3e0cf283e9801a80bbca0e", "65cf576bce79b0bbd26e2618", "65e01145ee624871073361cd", "65d5b62232fca434884a219f", "65d5b7434e768ba62a16aaa7", "65d5b62332fca434884a225c", "65d5b62132fca434884a210a", "65d5b62432fca434884a22b8", "65d5b62232fca434884a21a1"],
    LOCATION_TROUBLESHOOT : ['zNYAa9SchX', 'jLZvhEb123', 'xP96hWNsUo', 'yr0QhYDkd5', 'XwySYhNV1N', "YzmEWqaBTO", "ULTr8amPw7"],
    CHAT_BOT: ["NLgyWdldGw", "bPofRIJ9xE", "eJge0TupOo", "zNYAa9SchX", "xP96hWNsUo", "ZcFtZ8ToN9"],
    PROFILE_REQUEST: ['EbNnixCoZL', 'NLgyWdldGw', 'xP96hWNsUo', 'E63OGGMoBU', 'lAFrCdJqGQ'],
    WHATSAPP_NOTIFICATION:['ZbgbTg0qMu'],
    LOCATION_WISE_ATTENDANCE: ['CIe6kMPcaI', 'avaONEQCQY', 'F4u87vQw4x'],
    CUSTOM_SABBATICAL_LEAVE: ['lAFrCdJqGQ','xP96hWNsUo'],
    CUSTOM_PUNCH_REPORT:['PveDkR7qXY','xP96hWNsUo'],
    SLOT_SYSTEM_SETTING:['Bo3kAygtRd', 'o2n4mGJr6J', 'xP96hWNsUo']
}
/**
 * =============== Live ===============
 * 5u4smyVEC1 : Mettcover
 * Yr0QhYDkd5 : Stratefix
 * xP96hWNsUo : Superworks QA
 * NLgyWdldGw : Superworks
 * E63OGGMoBU : Superworks Developers
 * jmogDzzXuI : Mahakal Agro
 * Dd6nifGFhA : Shivam Stock
 * pxCn8AijmI : Superworks Demo
 * MjBOJrgyuq : Dolphy India
 * w4nC3JiqCQ : OneData Software Solutions
 * ni7VBAUj8N : PHN Technology Pvt. Ltd.
 * L8KCSNSEEk : Shree Hari Coal Corporation
 * 43KtmSZznm : Prakash Hospital And Trauma Centre
 * RddeXmIfZX : LinkMiles
 * XwySYhNV1N : Arham Share Pvt Ltd
 * mnMeYw4ABc : WEA DESIGN Pvt Ltd
 * YqPX9iuq4G : Black Mangos
 * RMdy90FKg4 : The Managers
 * Nd3EWPCcQw : Colatch Media Pvt Ltd
 * ogi4D1i6VD : A.D. FINANCIAL SERVICES
 *
 * EbNnixCoZL : DP World
 * lAFrCdJqGQ : Hindustan Ports Private Limited
 * 9qD2nowvjA : Stellar Value Chain
 * =============== Live ===============
 *
 * =============== Staging ===============
 * zNYAa9SchX :
 * 4oRZRrnKo3 : Time zone
 * bPofRIJ9xE : hiren test ats
 * eJge0TupOo : Alphabets
 * =============== Staging ===============
 *
 * =============== Development ===============
 * =============== Development ===============
 * */
export const APP = {
    COOKIE_DAYS: 90,
};
export const REGEX = {
    AT: /(\<@(.*?)\|(.*?)\>)/gim,
    OBJECT_ID: /^[a-f0-9]{24}$/,
    EMOJI: /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g,
    ACTIVITY: /(\<\$(.*?)\|(.*?)\>)/gim,
    EMOJI_SKIN: /(?:\:([^\:]+)\:)(?:\:skin-tone-(\d)\:)/gim,
    ALPHANUMERIC: /^[a-zA-Z0-9 -]{1,25}$/i,
    NAME: /^([a-zA-Z ' -]{1,100})$/i,
    EMAIL: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}$/i,
    PHONE: /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/i,
    ADDRESS_DEPARTMENT: /^[a-zA-Z0-9 ' , . & -]{1,100}$/i,
    CITY: /^[a-zA-Z]+(?:[\s-][a-zA-Z]{1,100})*$/i,
    COMPANY: /^([-a-zA-Z0-9 ' , . & !]{1,100})$/i,
    POSTCODE: /^\d{6}(?:[-\s]\d{4})?$/i,
    IFSCCODE: /^[a-zA-Z0-9 -]{3,18}$/i,  /*/^[A-Z]{4}0[A-Z0-9]{6}$/i*/
    NUMBER: /^\d{3,50}$/i,
    BANK: /^([a-zA-Z]{1,50})$/i,
    number: /\d/, // /^(?=.*?[0-9])/,
    upperCase: /[A-Z]/, // /^(?=.*?[A-Z])/,
    lowerCase: /[a-z]/, // /^(?=.*?[a-z])/,
    specialChar: /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/
};
export const FILE = {
    IMAGES: /\.(svg|png|apng|jpeg|jpg|ico|hdr|bmp|webp|gif|tiff|tif|jp2|rgb|dds|cur|tga|heic|jfif|pgm|jpe|xpm|exr|map|ppm|g3|wbmp|jbg|pcx|pdb|avif|jps|rgba|heif|fax|xbm|yuv|pcd|pict|xwd|pal|vips|pgx|pbm|jbig|picon|ras|pct|fts|hrz|ipl|mng|mtv|otb|palm|pam|pfm|pnm|rgbo|sgi|sun|uyvy|viff|xv|g4|rgf|six|sixel|jif|jfi)$/i,
    VIDEO: /\.(avi|wmv|mpeg|webm|mov|mpg|divx|mpeg-2|3gp|flv|swf|m4v|ogv|mkv|mjpeg|vob|xvid|mts|av1|ts|avchd|hevc|asf|mxf|m2v|3g2|rmvb|m2ts|wtv|f4v|rm|mp4)$/i,
    AUDIO: /\.(mp3|wav|ogg|wma|m4a|flac|mp2|aac|aiff|m4r|amr|ac3|opus|gsm|wve|w64|caf|fssd|vox|dts|amb|txw|au|spx|wv|voc|tta|ra|oga|pvf|prc|maud|8svx|snd|sndr|sndt|avr|cdda|cvs|cvsd|cvu|dvms|vms|fap|paf|sou|gsrt|hcom|htk|ima|ircam|sln|sph|nist|smp|sd2)$/i,
    EXCLUDES: ['exe', 'EXE', 'dmg', 'msi'],
    DOCS: /\.(doc|docx|DOC|DOCX|pdf|PDF|js)$/i,
    // MIXFILES: /\.(svg|png|apng|jpeg|jpg|ico|hdr|bmp|webp|gif|tiff|tif|jp2|rgb|dds|cur|tga|heic|jfif|pgm|jpe|xpm|exr|map|ppm|g3|wbmp|jbg|pcx|pdb|avif|jps|rgba|heif|fax|xbm|yuv|pcd|pict|xwd|pal|vips|pgx|pbm|jbig|picon|ras|pct|fts|hrz|ipl|mng|mtv|otb|palm|pam|pfm|pnm|rgbo|sgi|sun|uyvy|viff|xv|g4|rgf|six|sixel|jif|jfi|doc|docx|DOC|DOCX|pdf|PDF)$/i,
    MIXFILES: /\.(png|apng|jpeg|jpg|pdf|PDF)$/i,
    MIXDOC: /\.(png|apng|jpeg|jpg|pdf|PDF|doc|docx|DOC|DOCX|xlsx|xls|rtf)$/i,
    ELSXFILES: /\.(xlsx|XLSX)$/i,
};
export const FORMAT = {
    TIME: 'hh:mm A',
    MONTH: 'MM/YYYY',
    DATE: 'DD/MM/YYYY',
    DUE_DATE: 'DD MMM, YY',
    TICKET_DATE: 'DD MMM, YYYY',
    TICKET_DATE_TIME: 'DD MMM, YYYY hh:mm A',
    DAY_TIME: 'dddd hh:mm A',
    DATE_TIME: 'DD/MM/YYYY hh:mm A',
    FULL_DATE: 'dddd, MMMM D, YYYY',
    YEAR_MONTH: 'MMMM, YYYY',
    MONTH_DATE: 'MMM DD, YYYY',
    MONTH_DATE_TIME: 'MMM DD, YYYY, hh:mm A',
    DAY_DATE: 'ddd, MMM DD, YYYY',
    DOC_DATE_FORMAT: 'do, MMM yyyy',
    DAY_DATE_MONTH: 'ddd DD MMM, YYYY',
    FULL_DATE_TIME: 'ddd DD MMM, YYYY hh:mm A',
    FULL_DATE_KIT_TIME: 'DD MMM YYYY (dddd)',
    DAYS_DATE_MONTH: 'ddd DD MMM',
};
export const GLOBAL_COMMENT = {
    ATTENDANCE: 1001,
    LEAVE: 1002,
    OVERTIME: 1003,
    PROFILE_REQUEST: 1004,
    COMP_OFF: 1005,
    LOAN: 1006,
    TICKET: 1007,
    AGREEMENT: 1008,
    INCREMENT: 1009,
    EXIT: 1010,
    ONBOARDING: 1015
}
export const COLOR = {
    u_title: '#1e2538',
    u_font: '#73788b',
    u_blue: '#007AFF',
    u_lightfont: '#c7c7c7',
    u_gray: '#e4e4e4',
    u_dark_gray: '#7b849e',
    u_datepicker_bg: '#fafbff',
    u_thead_bg: '#fafafb',
    u_icon_bg: '#4E525F',
    u_lightgreen: '#F8FDF8',
    u_darkfont: '#5D6372',
    u_semilight_gray: '#F8F9FE',
    u_white: '#FFFFFF',
    u_green: '#60B158',
    u_orange: '#FFA700',
    u_pastelred: '#FF6961',
    u_black: '#000000',
    u_red: '#FF6961',
    u_purple: '#9A5BFF',
    u_lightblue: '#33D6FA',
    //for monthly calender
    u_present: '#60B158',
    u_weekend: '#2F7CF6',
    u_onlyIn: '#B58883',
    u_absent: '#FF6961',
    u_leave: '#9A5BFF',
    u_holiday: '#1EB2E1',
    u_nwd: '#FFA700',
    u_presentD: '#FF04A9',
    u_cwd: '#12CDB7',
    u_lateIn: '#007AFF',
    u_earlyOut: '#FF6961',
    u_pink: '#FF04A9',
    u_maroon: '#A0153E',
    u_greyMissing: '#B58883',
    u_cyan: '#804A00',
    u_orangelight: '#DD761C',
    u_wine: '#640D5F',
    u_brown: "#CF7C55",
}
export const LIMIT = {
    SEARCH_CHARACTER: 3,
    TOAST_TIME_OUT: 5000,
    DE_BOUNCING_TIME_OUT: 500,
    DE_BOUNCING_TIME_OUT_TICKET: 1000,
};
export const PAGINATION = {
    CURRENT_PAGE: 1,
    LIMIT: 40,
    LIMIT100: 100,
}
export const RECORDPERPAGE = [
    {value: 20, label: '20'},
    {value: 40, label: '40'},
    {value: 60, label: '60'},
    {value: 80, label: '80'},
    {value: 100, label: '100'},
];
export const MASTER_DATA_ACTION = {
    REPLACE: 0,
    ADD: 1,
    UPDATE: 2,
    DELETE: 3,
}
export const ALLOW_DUPLICATE_EVENTS = [
    "hrms|leave|calendar",
    "hrms|timeSheet|getCurrentTiming",
    "hrms|master|reason|fetch",
    "hrms|documents|placeholder",
    "hrms|attendance|dailyReport|fetch",
    "hrms|queryBuilder|report|read",
    "hrms|customFields|read",
]
export const FETCH_TRACKER_EVENTS = [
    "hrms|india|state|list",
    "hrms|master|organizationStructure|List",
    "hrms|shift|read|list",
    "readProductVideo"
]
export const STORED_TRACKER_EVENTS = [
    "master|paymentbar|content|get",
    "getLatestVersion"
]

export const WORKFLOW_STATUS = [
    {label: 'Initiated', color: '#FFA700', value: 1},
    {label: 'Kit Sent', color: '#33D6FA', value: 2},
    {label: 'In Progress', color: '#9A5BFF', value: 3},
    {label: 'Completed', color: '#60B158', value: 4},
    {label: 'Onboarded', color: '#007AFF', value: 5},
]

export const ONBOARDING_EMPLOYEE_STATUS = [
    {label: 'Deleted Employee', value: true},
]

export const ONBOARDING_STATUS = [
    {label: 'All', value: 0},
    {label: 'Onboarding Not Started', value: 1},
    {label: 'Unassigned Welcome Kit', value: 2},
    {label: 'Onboarding Started', value: 3},
    {label: 'Welcome Kit Sent', value: 4},
]

export const DEDUCTION_POLICY_LIMIT = {
    NO: 1,
    MINIMUM: 2,
    MAXIMUM: 3,
    BOTH: 4
}

export const LOGIN_METHOD = {
    WEB: 1,
    MOBILE: 2,
    DESKTOP: 3,
    FACE_CLOCK_IN: 4,
    BIOMETRIC: 5,
    GEO_TAGGING: 6,
    CLOCK_IN_WITH_SELFIE: 7,
    LIVE_TRACKING: 8,
    1: 'Web',
    2: 'Mobile',
    3: 'Desktop App',
    4: 'Face App',
    5: 'Biometrics Device',
    6: 'Geo Location',
    7: 'Clock-In with in Selfie',
    8: 'Route Map Tracking',
}
export const ATTENDANCE_ACTION = {
    REPLACE: 0,
    ADD: 1,
    UPDATE: 2,
    DELETE: 3,
    APPROVED: 4,
    REJECTED: 5,
    0: 'Replace',
    1: 'Add',
    2: 'Update',
    3: 'Delete',
    4: 'Approve',
    5: 'Reject',
}

export const ATTENDANCE_REGULARIZATION_FROM = {
    MY_ATTENDANCE:1,
    EMPLOYEE_ATTENDANCE:2,
    ATTENDANCE_VERIFICATION:3,
    SHIFT_CALENDAR:4,
    IMPORT_ATTENDANCE:5,
    INBOX: 6,
    REGULARIZATION: 7,
    MY_LATE_IN: 8,
    MY_EARLY_OUT: 9,
    EMPLOYEE_LATE_IN: 10,
    EMPLOYEE_EARLY_OUT: 11,
    EMPLOYEE_SETTING: 12,
    SHIFT_CALANDER_IMPORT: 13,
    SHIFT_CHANGE_REQUEST: 14,
    MY_ATTENDANCE_REQUEST: 15,
    WEEKEND_IMPORT: 16,
    PAYROLL: 17,
    1: 'My Attendance',
    2: 'Employee Attendance',
    3: 'Attendance Verification',
    4: 'Shift Calendar',
    5: 'Import Attendance',
    6: "Inbox",
    7: "Attendance Regularization",
    8: "My Late In",
    9: "My Early Out",
    10: "Employee Late In",
    11: "Employee Early Out",
    12: "Employee Settings",
    13: "Shift Calendar Import",
    14: "Shift Change Request",
    15: "My Attendance Request",
    16: "Weekend Import",
    17: "Payroll",
}
export const OVERTIME_ROUND_OFF_TYPE = {
    NEAREST: 1,
    UP_TO: 2,
    DOWN_TO: 3
}
export const OVERTIME_CALCULATION_BASED_ON = {
    EFFECTIVE_HOURS: 1,
    GROSS_HOURS: 2
}
export const CONSUCATIVE_ROUND_OFF_TYPE = [
    {label: 'Minimum', value: 1},
    {label: 'Maximum', value: 2}
]
export const CONSIDER_OVERTIME = {
    ALL_ADDITIONAL_HOURS: 1,
    BEFORE_SHIFT_STARTS: 2,
    AFTER_SHIFT_END: 3,
}
export const ATTENDANCE_TYPE = {
    SHIFT_CHANGE: 1,
    VERIFICATION_CHANGE: 3,
    TIMESHEET_DELETE: 4,
    REPORT_DELETE: 5,
    EDIT_REQUEST: 6,
    ATTENDANCE_REQUEST: 7,
    ACTION_TAKEN: 8,
    1: 'Shift Change',
    3: 'Verification Change',
    4: 'Timesheet delete',
    5: 'Report Delete',
    6: 'Edit Request',
    7: 'Attendance Request',
    8: 'Action Taken',
}
export const BIOMETRIC_DEVICE = [
    {label: 'Biomax', value: 1},
    {label: 'ESSL', value: 2},
    {label: 'Server Integration', value: 3},
]
export const HRMS_STATUS = {
    HOLIDAY: {
        FULL_DAY: 1,
        FIRST_HALF: 2,
        SECOND_HALF: 3,
    },
    WEEK_DAY: {
        SUNDAY: 0,
        MONDAY: 1,
        TUESDAY: 2,
        WEDNESDAY: 3,
        THURSDAY: 4,
        FRIDAY: 5,
        SATURDAY: 6,
    },
    WEEK_NUMBER: [
        "SUNDAY",
        "MONDAY",
        "TUESDAY",
        "WEDNESDAY",
        "THURSDAY",
        "FRIDAY",
        "SATURDAY",
    ],
    TAG_CODES: ["st", "nd", "rd", "th", "th", "th"],
    WEEKEND_TYPE: {
        WORK: 0,
        FIRSTHALF: 1,
        SECONDHALF: 2,
        FULLDAY: 3
    },
    DAY_NUMBER: {
        FIRST: 1,
        SECOND: 2,
        THIRD: 3,
        FOURTH: 4,
        FIFTH: 5,
    },
    TIME_SHEET_TYPE: {
        WORK: 1,
        BREAK: 2,
    },
    TIME_SHEET_REQUEST_STATUS: {
        PENDING: 1,
        APPROVED: 2,
        REJECTED: 3,
        CANCELLED: 4,
    },
    TIME_SHEET_REQUEST_TYPE: {
        ADD: 1,
        UPDATE: 2,
    },
    DAILY_REPORT_TIME_STATUS: {
        INITIAL: 1,
        WORK: 2,
        BREAK: 3,
        END: 4,
    },
    DAILY_REPORT_STATUS: {
        PENDING: 1,
        COMPLETE: 2,
        REQUESTED: 3,
        LEAVE_REQUESTED: 4,

        /** Attendance Popup Constants */
        LEAVE_EARLY_OUT: 5,
        EARLY_OUT: 6,
    },
    DAILY_REPORT_DAY_STATUS: {
        HOLIDAY: 1,
        WEEKEND: 2,
        WORKING: 3,
        FIRST_HALF_WORKING: 4,
        SECOND_HALF_WORKING: 5,
        FULL_DAY_LEAVE: 6,
        FIRST_HALF_LEAVE: 7,
        SECOND_HALF_LEAVE: 8,
        PRESENT_BY_DEFAULT: 9,
        NON_WORKING: 10,
        FIRST_HALF_NON_WORKING: 11,
        SECOND_HALF_NON_WORKING: 12,
        FIRST_HALF: 13,
        SECOND_HALF: 14,
        WORKING_DAY: 15,
    },
    LEAVE_TYPE: {
        FULL_DAY: 1,
        FIRST_HALF: 2,
        SECOND_HALF: 3,
        HOURLY: 4,
        SHORT: 5,
    },
    ROUND_OFF_TO: [
        {label: 'Nearest', value: 1},
        {label: 'Minimum', value: 2},
        {label: 'Maximum', value: 3},
    ],
    ROUND_OFF_DAY: [
        {label: 'Day', value: 1},
        {label: 'Half Day', value: 2},
        {label: 'Quarter Day', value: 3},
    ],
    ROUND_OFF_HOUR: [
        {label: 'Hour', value: 1},
        {label: '30 Min', value: 2},
        {label: '15 Min', value: 3},
    ],
    DROPDOWN_LIST_TYPE: {
        PROJECT: 1,
        TASK: 2,
        ACTIVITY: 3,
        USER: 4,
    },
    FINAL_OUT_TYPE: {
        MANUAL: 1,
        AUTO: 2,
    },
    TIME_SHEET_ADDED_TYPE: {
        MANUAL: 1,
        AUTO: 2,
    },
    PROJECT_WORK_LOG_ADDED_TYPE: {
        MANUAL: 1,
        AUTO: 2,
    },
    SEARCH_IN_TYPE: {
        PROJECT: 1,
        PROJECT_TASK: 2,
        PROJECT_ACTIVITY_TYPE: 3,
    },
    SHIFT_TOTAL_HOUR_CALCULATION_TYPE: {
        FIRST_LAST_CHECK_OUT: 1,
        EVERY_CHECK_OUT: 2,
    },
    OVER_TIME_PAY_TYPE: {
        HOURS: 1,
        FIXED: 2
    },
    OVER_TIME_LEVEL1: {
        USER: 1,
        UAC: 2
    },
    FF_REQUEST_STATUS: {
        PENDING: 1,
        APPROVED: 2,
        REJECTED: 3,
        CANCELLED: 4,
    },
};

export const DAY_FILTER = [
    {label: 'Holiday', value: 'HOLIDAY'},
    {label: 'Present By Default', value: 'PRESENT_BY_DEFAULT'},
    {label: 'Weekend', value: 'WEEKEND'},
    {label: 'Working Day', value: 'WORKING'},
    {label: 'Non Working Day', value: 'NON_WORKING'}
]

export const SHIFT_NOT_START = [
    {label: 'Shift Not start', value: true},
]
export const TYPE_FILTER = [
    {label: 'Employee Absent', value: 'ABSENT'},
    {label: 'Employee On Leave', value: 'LEAVE'},
    {label: 'Employee Present', value: 'PRESENT'},
    {label: 'Employee Clock-Out Missing', value: 'MISSING'},
    {label: 'Employee Early Out', value: 'EARLYOUT'},
    {label: 'Employee Late In', value: 'LATEIN'},
    {label: 'Employee OD & Remote Work', value: 'REMOTE_WORK'},
    {label: 'Auto Clock Out', value: 'AUTO_CLOCK_OUT'}
]
export const BIO_VIEW = [
    {label: 'All', value: 1},
    {label: 'Assigned', value: 2},
    {label: 'Not Assigned', value: 3},
    {label: 'Mismatched', value: 4}
]

export const ATTENDANCE_STATUS = {
    ABSENT: '#FF6961',
    PAID_LEAVE: '#9A5BFF',
    UNPAID_LEAVE: '#FF00A8',
    WEEKEND: '#007AFF',
    HOLIDAY: '#33D6FA',
    OD: '#A0153E',
    WFH: '#804A00'
}
export const PROFILE_STATUS= {
    STATUSONE: '#FF6961',
    STATUSTWO: '#FFA700',
    STATUSTHREE: '#60B158',
}
export const ROUTE_MAP_STATUS = {
    CLOCK_IN: '#60B158',
    CLOCK_OUT: '#FF6961',
    BREAK : '#FFA700'
}
export const EARLY_OUT_SETTLE_TYPE = {
    1: 'Auto Settle',
    2: 'Manual Settle',
    3: 'Force Settle',
}
    export const BANK_INFO_COUNTRY = [
    {value: 'INDIA', label: 'India ', type : 1},
    {value: 'UAE', label: 'United Arab Emirates',type : 2},
    {value: 'SINGAPORE', label: 'Singapore', type : 3},
    {value: 'EGYPT', label: ' Egypt', type : 4},
]

export const ATTENDANCE_STATUS_OPTIONS = [
    {value: 'ABSENT', label: 'Absent', abbr: 'AB', color: '#FF6961', BgColor: '#fff7f7', dayStatus: 3, timeStatus: 1},
    {value: 'WEEKEND', label: 'Weekend', abbr: 'WK', color: '#007AFF', BgColor: '#f2f8ff', dayStatus: 2, timeStatus: 1},
    {value: 'FIRST_HALF_WORKING', label: '1st Half Working', abbr: 'FH', color: '#60B158', BgColor: '#faf6ff', dayStatus: 4, timeStatus: 1},
    {value: 'FULL_DAY', label: 'Full Day Working Day', abbr: 'FD', color: '#60B158'},
    {value: 'WORKING_DAY', label: 'Working Day', abbr: 'WD', color: '#12CDB7'},
    {value: 'FIRST_HALF', label: 'First Half', abbr: 'FHWD', color: '#12CDB7'},
    {value: "SECOND_HALF", label: 'Second Half', abbr: 'SHWD', color: '#12CDB7'},
    {value: 'SECOND_HALF_WORKING', label: '2nd Half Working', abbr: 'SH', color: '#60B158', BgColor: '#faf6ff', dayStatus: 5, timeStatus: 1},
    {value: 'PRESENT_BY_DEFAULT', label: 'Present By Default', abbr: 'PD', color: '#FF00A8', BgColor: '#fff2fb', dayStatus: 9, timeStatus: 1},
    {value: 'HOLIDAY', label: 'Holiday', abbr: 'HL', color: '#33D6FA', BgColor: '#f4fdff', dayStatus: 1, timeStatus: 1},
    {value: 'NON_WORKING', label: 'Non Working Day', abbr: 'NWD', color: '#FFA700', BgColor: '#fffbf2', dayStatus: 10, timeStatus: 1},
    {value: 'FIRST_HALF_NON_WORKING', label: 'First Half Non Working', abbr: 'FNWD', color: '#FFA700', BgColor: '#fffbf2', dayStatus: 11, timeStatus: 1},
    {value: 'SECOND_HALF_NON_WORKING', label: 'Second Half Non Working', abbr: 'SNWD', color: '#FFA700', BgColor: '#fffbf2', dayStatus: 12, timeStatus: 1},
    {value: 'FULL_DAY_ON_DUTY', label: 'On Duty', abbr: 'OD', color: '#A0153E', typeOfRemoteWork: 1},
    {value: 'FULL_DAY_WFH', label: 'Work From Home', abbr: 'WFH', color: '#804A00', typeOfRemoteWork: 2},
    {value: 'FIRST_HALF_ON_DUTY', label: 'First Half On Duty', abbr: 'FHOD', color: '#008080'},
    {value: 'SECOND_HALF_ON_DUTY', label: 'Second Half On Duty', abbr: 'SHOD', color: '#008080'},
];
export const ATTENDANCE_DAY_OPTION = [
    {value: 3, label: 'Full Day'},
    {value: 4, label: 'First Half'},
    {value: 5, label: 'Second Half'},
]
export const ABSENT_PRESENT_STATUS_OPTION = [
    {value: 'P', label: 'Present (P)'},
    {value: 'AB', label: 'Absent (AB)'},
    {value: 'FP', label: 'First Half Present (FP)'},
    {value: 'SP', label: 'Second Half Present (SP)'},
]
export const NON_WORKING_DAY_OPTION = [
    {value: 10, label: 'Full Day'},
    {value: 11, label: 'First Half'},
    {value: 12, label: 'Second Half'},
]
export const STATUS_OPTIONS = [
    {label: 'Pending', status: 'pending', color: '#FFA700', value: 1},
    {label: 'Approved', status: 'approved', color: '#60B158', value: 2},
    {label: 'Rejected', status: 'rejected', color: '#FF6961', value: 3},
    {label: 'Cancelled', status: 'cancelled', color: '#1E2538', value: 4},
];
export const PAID_STATUS = [
    {label: 'Pending', status: 'pending', color: '#FFA700', value: 1},
    {label: 'Processing', status: 'processing', color: '#60B158', value: 2},
    {label: 'Paid', status: 'paid', color: '#9A5BFF', value: 3},
];
export const ADAVANCE_STATUS_OPTIONS = [
    {label: 'Pending', status: 'pending', color: '#FFA700', value: 1},
    {label: 'Approved', status: 'approved', color: '#60B158', value: 2},
    {label: 'Rejected', status: 'rejected', color: '#FF6961', value: 3},
    {label: 'Cancelled', status: 'cancelled', color: '#1E2538', value: 4},
    {label: 'Paid', status: 'paid', color: '#9A5BFF', value: 5},
    {label: 'Pending Refund', status: 'pendingRefund', color: '#9A5BFF', value: 6},
    {label: 'Refund', status: 'Refund', color: '#9A5BFF', value: 7},
];
export const TRANSACTION_TYPE = {
    1: 'Paid',
    2: 'Reimbursement',
    3: 'Refund',
};
export const REVOKE_STATUS_OPTIONS_ALL = [
    {label: 'Revoked Pending', status: 'revoked pending', color: '#FFA700', value: 1},
    {label: 'Revoked Approved', status: 'revoked approved', color: '#60B158', value: 2},
    {label: 'Revoked Rejected', status: 'revoked rejected', color: '#FF6961', value: 3},
    {label: 'Revoked cancelled', status: 'revoked cancelled', color: '#1E2538', value: 4},
];
export const REVOKE_STATUS_OPTIONS = [
    {label: 'Revoked Pending', status: 'revoked pending', color: '#FFA700', value: 1},
    {label: 'Revoked Approved', status: 'revoked approved', color: '#60B158', value: 2},
    {label: 'Revoked Rejected', status: 'revoked rejected', color: '#FF6961', value: 3},
    {label: 'Revoked cancelled', status: 'revoked cancelled', color: '#1E2538', value: 4},
];
export const APPROVAL_STATUS = {
    PENDING: 1,
    APPROVED: 2,
    REJECTED: 3,
    CANCELLED: 4,
};
export const STATUS_PRODUCTIVITY_OPTIONS = [
    {label: 'Pending', status: 'pending', color: '#FFA700', value: 1},
    {label: 'Approved', status: 'approved', color: '#60B158', value: 2},
    {label: 'Request For Edit', status: 'request_for_edit', color: '#FF6961', value: 3},
    {label: 'Draft', status: 'draft', color: '#1E2538', value: 4},
    {label: 'Rejected', status: 'rejected', color: '#FF6961', value: 5},
];
export const PRODUCTIVITY_REQUEST_ACTION = {
    APPROVE: 1,
    REQUESTED_FOR_EDIT: 2,
    REJECT: 3
};
export const REMOTE_TYPE = [
    {label: 'On Duty', color: '#FFA700', value: 1},
    {label: 'Work From Home', color: '#60B158', value: 2},
];
export const PENALISATION_TYPE = [
    {label: 'Late In', value: 1},
    {label: 'Early Out', value: 2},
    {label: 'Club', value: 3},
];
export const MODULE_LIST = [
    {label: 'Attendance', value: 1},
    {label: 'Leave', value: 2},
    {label: 'Overtime', value: 3},
    {label: 'Profile Request', value: 4},
    {label: 'Comp Off', value: 5},
];
export const STATUS_OPTIONS_ALL = [
    {label: 'Pending', status: 'pending', color: '#FFA700', value: 1},
    {label: 'Approved', status: 'approved', color: '#60B158', value: 2},
    {label: 'Rejected', status: 'rejected', color: '#FF6961', value: 3},
];
export const MAIL_STATUS = [
    {label: 'Success', status: 'success', color: '#FFA700', value: 1},
    {label: 'Failed', status: 'failed', color: '#60B158', value: 2},
];
export const EMPLOYEE_EXIT_STATUS_OPTIONS_ALL = [
    {label: 'Pending', status: 'pending', color: '#FFA700', value: 1},
    {label: 'Approved', status: 'approved', color: '#60B158', value: 2},
    {label: 'Rejected', status: 'rejected', color: '#FF6961', value: 3},
    {label: 'Revoked', status: 'revoked', color: '#60B158', value: 4},
];
export const EXIT_EMPLOYEE_STATUS = [
    {label: 'Pending', status: 'pending', color: '#FFA700', value: 1},
    {label: 'Approved', status: 'approved', color: '#60B158', value: 2},
    {label: 'Rejected', status: 'rejected', color: '#FF6961', value: 3},
    {label: 'Revoked', status: 'revoked', color: '#60B158', value: 4},
    {label: 'Revoked Pending', status: 'revoked pending', color: '#FFA700', value: 5},
    {label: 'Revoked Approved', status: 'revoked approved', color: '#60B158', value: 6},
    {label: 'Revoked Rejected', status: 'revoked rejected', color: '#FF6961', value: 7},
]
export const OVERTIME_STATUS_OPTIONS_ALL = [
    {label: 'Pending', status: 'pending', color: '#FFA700', value: 1},
    {label: 'Approved', status: 'approved', color: '#60B158', value: 2},
    {label: 'Rejected', status: 'rejected', color: '#FF6961', value: 3},
    {label: 'No Action Taken', status: 'no_action_token', color: '#1E2538', value: 5},
];
export const VERIFICATION_STATUS_OPTIONS = [
    {label: 'All', value: 0},
    {label: 'Pending', value: 1},
    {label: 'Approved', value: 2},
];
export const DOWNLOAD_REPORT_STATUS_OPTIONS = [
    {label: 'Pending', value: 1},
    {label: 'Failed', value: 2},
    {label: 'Success', value: 3}
];
export const SALARY_MODE = [
    {label: 'Cash', value: 1},
    {label: 'Cheque', value: 2},
    {label: 'Bank', value: 3},
]
{/** Bonus Benefit Type for compensation*/
}
export const BONUS_BENEFIT_TYPE = [
    {label: 'Fix Amount', value: 1},
    {label: 'Based on per day', value: 2},
    {label: 'Formula', value: 3},
]
export const SALARY_BONUS_BENEFIT_LEAVE = [
    {label: 'Comp-off', value: 1},
    {label: 'Short Leave', value: 2},
    {label: 'Paid', value: 3},
    {label: 'Unpaid', value: 4},
    {label: 'Hourly Paid', value: 5},
    {label: 'Hourly Unpaid', value: 6},
]
export const REGIME = [
    {label: 'Old', value: 1},
    {label: 'New', value: 2},
]
export const LOAN_OPTIONS = [
    {label: 'Pending', status: 'pending', color: '#FFA700', value: 1},
    {label: 'Not Started', status: 'not_started', color: '#FF6961', value: 2},
    {label: 'Rejected', status: 'rejected', color: '#FF6961', value: 3},
    {label: 'Running', status: 'running', color: '#FFA700', value: 4},
    {label: 'Paid', status: 'paid', color: '#60B158', value: 5},
];
export const EARLY_TIME_OPTIONS = [
    {label: 'Early Out time', value: 'eo'},
    {label: 'My Extra Hours', value: 'ot'},
];
export const STATUS_REPORT_OPTIONS = [
    {label: 'All', value: 0},
    {label: 'Absent', value: 1},
    {label: 'Present', value: 2},
];
export const ABSENT_PRESENT_OPTIONS = [
    {label: 'Absent', value: 1},
    {label: 'On Leave', value: 2},
    {label: 'Present', value: 3},
];

export const TRACKING_USERS_OPTIONS = {
    ALL: 'all',
    PRESENT: 'present',
    ABSENT: 'absent',
    LEAVE: 'leave',
    CLOCK_OUT: 'clockOut',
    options: [
    {label: 'Present', value: 'present'},
    {label: 'Absent', value: 'absent'},
    {label: 'Leave', value: 'leave'},
   ]
}

export const TIME_SHEET_STATUS_OPTIONS = [
    {label: 'Working Hour', value: HRMS_STATUS.TIME_SHEET_TYPE.WORK},
    {label: 'Break', value: HRMS_STATUS.TIME_SHEET_TYPE.BREAK}
]
export const ASSIGNEE_TYPE_OPTIONS = [
    {name: 'Employee', _id: 1, label: 'Employee', value: 1},
    {name: 'Employee Group', _id: 2, label: 'Employee Group', value: 2},
    {name: 'Reporting Manager', _id: 3, label: 'Reporting Manager', value: 3},
    {name: 'Access Level', _id: 4, label: 'Access Level', value: 4}
]
export const TRIP_STATUS = [
    {label: 'Open Trip', value: 1},
    {label: 'Close Trip', value: 2},
]
export const ATTENDANCE = {
    ATTENDANCE_USER: 1,
    ATTENDANCE_SINGLE_USER: 2,
    ATTENDANCE_MY_EARLY_OUT: 3,
    ATTENDANCE_MY_LATE_IN: 4,
    ATTENDANCE_MY_WORK_LOG: 5,
    ATTENDANCE_WORK_LOG: 6,
    ATTENDANCE_VERIFICATION_USER: 7,
    ATTENDANCE_VERIFICATION_SINGLE_USER: 8
}
export const SETTLEMENT_OPTIONS = [
    {label: 'Completed', value: 2},
    {label: 'Remain', value: 1},
];

export const ASSETS_STATUS_LIST = [
    {value: 1, label: 'Pending', color: '#FFA700'},
    {value: 2, label: 'Assigned', color: '#60B158'},
    {value: 3, label: 'Rejected', color: '#FF6961'},
    {value: 4, label: 'Cancelled', color: '#1E2538'},
]

export const ON_DUTY_REQUEST_PERIOD = [
    {label: "Week", value: 1},
    {label: "Month", value: 2},
    {label: "Year", value: 3},
    {label: "Quarterly", value: 4},
    {label: "Half Yearly", value: 5},
]

export const ON_DUTY_REQUEST_IN_DAYS = [
    {label: "Holidays Only", value: 1},
    {label: "Weekly Offs Only", value: 2},
    {label: "Holidays & Weekly Offs", value: 3},
]

export const REMOTE_WORK_CLOCK_IN_OUT = [
    {label: "On Duty Only", value: 1},
    {label: "WFH Only", value: 2},
    {label: "On Duty & WFH", value: 3},
]
export const ICONS = [
    {label: <Icon.Kite size={20} fill={COLOR.u_font}/>, value: 'kite'},
    {label: <Icon.Holi size={20} fill={COLOR.u_font}/>, value: 'holi'},
    {label: <Icon.Diwali size={20} fill={COLOR.u_font}/>, value: 'diwali'},
    {label: <Icon.Christmas size={20} fill={COLOR.u_font}/>, value: 'christmas'},
    {label: <Icon.SportsDay size={20} fill={COLOR.u_font}/>, value: 'sportsDay'},
    {label: <Icon.RakshaBandhan size={20} fill={COLOR.u_font}/>, value: 'rakshaBandhan'},
    {label: <Icon.Janmashtami size={20} fill={COLOR.u_font}/>, value: 'janmashtami'},
    {label: <Icon.Ganesh size={20} fill={COLOR.u_font}/>, value: 'ganesh'},
    {label: <Icon.Dussehra size={20} fill={COLOR.u_font}/>, value: 'dussehra'},
    {label: <Icon.Navratri size={20} fill={COLOR.u_font}/>, value: 'navratri'},
    {label: <Icon.Independence size={20} fill={COLOR.u_font}/>, value: 'independence'},
    {label: <Icon.Republic size={20} fill={COLOR.u_font}/>, value: 'republic'},
];
export const LEAVE_ICONS = [
    {label: <Icon.Annual size={20} fill={COLOR.u_font}/>, value: 'AnnualLeaveIcon'},
    {label: <Icon.Paid size={20} fill={COLOR.u_font}/>, value: 'PaidLeaveIcon'},
    {label: <Icon.Casual size={20} fill={COLOR.u_font}/>, value: 'CasualLeaveIcon'},
    {label: <Icon.Sick size={20} fill={COLOR.u_font}/>, value: 'SickLeaveIcon'},
    {label: <Icon.Lwp size={20} fill={COLOR.u_font}/>, value: 'LwpIcon'},
    {label: <Icon.Maternity size={20} fill={COLOR.u_font}/>, value: 'MaternityLeaveIcon'},
    {label: <Icon.Marriage size={20} fill={COLOR.u_font}/>, value: 'MarriageleaveIcon'},
    {label: <Icon.Bereavement size={20} fill={COLOR.u_font}/>, value: 'BereavementLeaveIcon'},
    {label: <Icon.Compensatory size={20} fill={COLOR.u_font}/>, value: 'CompensatoryLeaveIcon'},
    {label: <Icon.Paternity size={20} fill={COLOR.u_font}/>, value: 'PaternityLeaveIcon'},
];

export const BADGE_ICONS = [
    {label: <Icon.Crown size={20} fill={COLOR.u_font}/>, value: 'TopPerformerIcon'},
    {label: <Icon.LeaderShip size={20} fill={COLOR.u_font}/>, value: 'LeaderShipIcon'},
    {label: <Icon.Customer size={20} fill={COLOR.u_font}/>, value: 'CustomerHeroIcon'},
    {label: <Icon.Beyond size={20} fill={COLOR.u_font}/>, value: 'AboveAndBeyondIcon'},
    {label: <Icon.RockStar size={20} fill={COLOR.u_font}/>, value: 'RockstarIcon'},
    {label: <Icon.UserStar size={20} fill={COLOR.u_font}/>, value: 'GoodEmployeeIcon'},
];
export const FEEDBACK_ICONS = [
    {label: <Icon.Crown size={20} fill={COLOR.u_font}/>, value: 'TopPerformerIcon'},
    {label: <Icon.DisLike size={20} fill={COLOR.u_font}/>, value: 'DisLikePerformerIcon'},
    {label: <Icon.Like size={20} fill={COLOR.u_font}/>, value: "GoodIcon"},
    {label: <Icon.LeaderShip size={20} fill={COLOR.u_font}/>, value: 'LeaderShipIcon'},
    {label: <Icon.Customer size={20} fill={COLOR.u_font}/>, value: 'CustomerHeroIcon'},
    {label: <Icon.Beyond size={20} fill={COLOR.u_font}/>, value: 'AboveAndBeyondIcon'},
    {label: <Icon.RockStar size={20} fill={COLOR.u_font}/>, value: "GrateIcon"},
    {label: <Icon.UserStar size={20} fill={COLOR.u_font}/>, value: 'GoodEmployeeIcon'},
    {label: <Icon.Warning size={20} fill={COLOR.u_font}/>, value: 'WarningIcon'},
    {label: <Icon.PerformanceGraph size={20} fill={COLOR.u_font}/>, value: "improvedIcon"},
];
export const SCHEDULER_ICONS = [
    {label: <Icon.Morning size={20} fill={COLOR.u_green}/>, value: 'morning'},
    {label: <Icon.Day size={20} fill={COLOR.u_orange}/>, value: 'day'},
    {label: <Icon.Evening size={20} fill={COLOR.u_blue}/>, value: 'evening'},
    {label: <Icon.Night size={20} fill={COLOR.u_purple}/>, value: 'night'},
];
export const SCHEDULER = {
    interval: [
        {label: "Weekly", value: 1},
        {label: "Monthly", value: 2},
        {label: "Custom", value: 3},
    ],
    rotation: [
        {label: "2", value: 2},
        {label: "3", value: 3},
        {label: "4", value: 4},
    ]
}
export const ACTIVITY_TYPE = {
    "createRequest": "Create",
    "editRequest": "Edit",
    "updateRequest": "Update",
    1: "Pending",
    2: "Approve",
    3: "Reject",
    4: "Cancel"
}
export const LEAVE = {
    adjustmentType: [
        {label: "Credit", value: 1},
        {label: "Debit", value: 2},
    ],
    effectivePeriod: [
        {label: "Days", value: 1},
        {label: "Months", value: 2},
        // {label: "Years", value: 3},
    ],
    grantPeriodsDay: [
        {label: "Previous Month", value: 2},
        {label: "Current Month", value: 1},
    ],
    allowInPresentDay: [
        {label: "WEEKEND", value: 1},
        {label: "LEAVE", value: 2},
        {label: "HOLIDAY", value: 3},
        {label: "NON_WORKING_DAY", value: 4},
        {label: "MISSING_ATTENDANCE", value: 5},
    ],
    grantMode: [
        {label: "Range Of Work Day", value: 1},
        {label: "Base On Formula", value: 2},
    ],
    allowInPeriod: [
        {label: "Week", value: 1},
        {label: "Months", value: 2},
        {label: "Years", value: 3},
        {label: "Day", value: 4},
    ],
    restrictionAllowInPeriod: [
        {label: "Week", value: 1},
        {label: "Months", value: 2},
        {label: "Years", value: 3},
        {label: "Day", value: 4},
        {label: "Quarter", value: 5},
    ],
    effectiveFrom: [
        {label: "Date of Joining", value: 2},
        {label: "After Internship End", value: 3},
        {label: "After Probation End", value: 1}
    ],
    interval: [
        {label: "Monthly", value: 2},
        {label: "Yearly", value: 1},
    ],
    newInterval: [
        {label: "Yearly", value: 1},
        {label: "Monthly", value: 2},
        {label: "Quarterly", value: 3},
        {label: "Half Yearly", value: 4},
        {label: "One Time", value: 5},
    ],
    month: [
        {label: "January", value: 1, shortName: "Jan"},
        {label: "February", value: 2, shortName: "Feb"},
        {label: "March", value: 3, shortName: "Mar"},
        {label: "April", value: 4, shortName: "Apr"},
        {label: "May", value: 5, shortName: "May"},
        {label: "June", value: 6, shortName: "Jun"},
        {label: "July", value: 7, shortName: "Jul"},
        {label: "August", value: 8, shortName: "Aug"},
        {label: "September", value: 9, shortName: "Sep"},
        {label: "October", value: 10, shortName: "Oct"},
        {label: "November", value: 11, shortName: "Nov"},
        {label: "December", value: 12, shortName: "Dec"}
    ],
    factor: [
        {label: "Percentage", value: 1},
        {label: "Unit", value: 2},
    ],
    encashmentFactor: [
        {label: "Percentage", value: 1},
        {label: "Unit", value: 2},
        {label: "Maintaining Leave Days", value: 3},
    ],

    dayOptions: [
        {value: 1, label: 'Full Day'},
        {value: 2, label: '1st Half'},
        {value: 3, label: '2nd Half'},
        {value: 5, label: 'Short Leave'},
    ],
    leaveStatus: [
        {value: 1, label: 'Pending', color: '#FFA700'},
        {value: 2, label: 'Approved', color: '#60B158'},
        {value: 3, label: 'Rejected', color: '#60B158'},
        {value: 4, label: 'Cancelled', color: '#60B158'},
    ],
    activity: [
        {value: 1, label: 'Created'},
        {value: 2, label: 'Modified'},
    ],
    payRollStatus: [
        {value: 1, label: 'UNPAID'},
        {value: 2, label: 'PAID'},
    ],
    payRollStatusHistory: [
        {value: 2, label: 'UNPAID'},
        {value: 5, label: 'PAID'},
    ],
    payRollType: [
        {value: 1, label: 'REGULAR'},
        {value: 2, label: 'PARK'},
        {value: 3, label: 'ROLLBACK'},
        {value: 4, label: 'IMPORT'},
    ],
    dayStatus: [
        {label: 'HOLIDAY', value: 1},
        {label: 'WEEKEND', value: 2},
        {label: 'WORKING', value: 3},
        {label: 'FIRST_HALF_WORKING', value: 4},
        {label: 'SECOND_HALF_WORKING', value: 5},
        {label: 'FULL_DAY_LEAVE', value: 6},
        {label: 'FIRST_HALF_LEAVE', value: 7},
        {label: 'SECOND_HALF_LEAVE', value: 8},
    ],
    CALCULATION_TYPE: [
        {label: 'FIXED', value: 1},
        {label: 'FORMULA', value: 2},
    ],
    earnGrantType :[
        {label: 'Custom', value: 1},
        {label: 'Total Month Days', value: 2},
    ],
    encashmentType: [
        {label: 'All Days', value: 1},
        {label: 'Custom', value: 2},
    ]
}
export const EMPLOYEE_EXIT = {
    1: 'Company decides to relieve',
    2: 'Employee wants to resign',
    3: 'Absconding',
    4: 'Employee Passed Away',
}
export const EMPLOYEE_EXIT_TYPE_LIST = [
    {label: "Company decides to relieve", value: 1},
    {label: "Employee wants to resign", value: 2},
    {label: "Absconding ", value: 3},
    {label: "Employee Passed Away", value: 4},
];

export const EMPLOYEE_PASSED_AWAY = [
    {value: 1, label: 'Home'},
    {value: 2, label: 'Office'},
    {value: 3, label: 'Other'},
]
export const ACTIVE_INACTIVE_STATUS = [
    {value: 'all', label: 'All'},
    {value: 'active', label: 'Active'},
    {value: 'inactive', label: 'Inactive'},
];
export const EMP_STATUS = [
    {value: 'all', label: 'All Employees'},
    {value: 'active', label: 'Active Employees'},
    {value: 'inactive', label: 'Inactive Employees'},
];
export const NOMINEE_STATUS = [
    {value: 'esi', label: 'ESI'},
    {value: 'gratuity', label: 'Gratuity'},
    {value: 'group insurance', label: 'Group Insurance'},
    {value: 'provident fund', label: 'Provident Fund'},
];
export const MAP_DASHBOARD = [
    {value: 2, label: 'Clock In'},
    {value: 3, label: 'In Break'},
    {value: 4, label: 'Clock OUT'},
];
export const CLOCK_IN_METHOD = [
    {value: 1, label: 'Clock In'},
    {value: 2, label: 'Clock OUT'},
];
export const ALL_TYPE_CLOCK_IN = [
    {value: 1, label: 'Web'},
    {value: 2, label: 'Mobile'},
    {value: 3, label: 'Desktop App'},
    {value: 4, label: 'Face Clock-In'},
    {value: 5, label: 'Biometrics Device'},
];
export const ACTIVE_COMPLETE = [
    {value: 1, label: 'Active'},
    {value: 2, label: 'Completed'},
];

export const EMP_LOGIN = [
    {value: 0, label: 'Logged In'},
    {value: 1, label: 'Not Logged In '},
    {value: 2, label: 'All'},
];
export const APP_LIST = [
    {label: 'HRMS', value: 'HRMS'},
    {label: 'CHAT', value: 'CHAT'},
    {label: 'PMS', value: 'PMS'},
    {label: 'PAYROLL', value: 'PAYROLL'},
    {label: 'RECRUIT', value: 'RECRUIT'},
    {label: 'PERFORMANCE', value: 'PERFORMANCE'},
    {label: 'ASSET', value: 'ASSET'},
    {label: 'SURVEY', value: 'SURVEY'},
]
export const TAX_REGIME = [
    {value: '', label: 'All'},
    {value: 2, label: 'New Regime'},
    {value: 1, label: 'Old Regime'},
];
export const MINIMUM_WAGES_TYPE = [
    {label: 'All', value: 1},
    {label: 'Below minimum wage', value: 2},
    {label: 'Above/equal minimum wage', value: 3},
]
export const DEVICE_STATUS = [
    {value: 'active', label: 'Active Device'},
    {value: 'inactive', label: 'Inactive Device'},
    {value: 'stop', label: 'Not Working'},
];
export const EMP_GROUP_BY = [
    {value: 'location', label: 'Location'},
    {value: 'shift', label: 'Shift'},
    {value: 'department', label: 'Department'},
    {value: 'companyId', label: 'Sub Company'},
    {value: 'jobTitle', label: 'Job Title'},
    {value: 'category', label: 'Category'},
    {value: 'employeeStatus', label: 'Employee Status'},
    {value: 'province', label: 'Employee State'},
    {value: 'locationProvince', label: 'Location State'},
    {value: 'businessUnit', label: 'BusinessUnit'},
    {value: 'costCenter', label: 'CostCenter'},
    {value: 'grade', label: 'Grade'},
    {value: 'bands', label: 'Bands'},
    {value: 'segment', label: 'Segment'},
    {value: 'hub', label: 'Hub'},
    {value: 'territory', label: 'Territory'},
    {value: 'region', label: 'Region'},
    {value: 'workArea', label: 'WorkArea'}
];
export const DOC_EMP_STATUS = [
    {value: 'all', label: 'All Employees'},
    {value: 'active', label: 'Active Employees'},
    {value: 'inactive', label: 'Inactive Employees'},
    {value: 'guest', label: 'Guest Employees'},
];
export const COMP_OFF_DAYS = [
    {value: 1, label: 'Calendar Days'},
    {value: 2, label: 'Business Days'},
];
export const BANK_FORMAT_TYPE = {
    XSL: 1, CSV: 2, PDF: 3, NOTEPAD: 4
}
export const DOCUMENT_FORMAT = [
    {label: 'A3', pageSize: '(29.7 x 42cm)', value: 'A3', width: 29.7, height: 42},
    {label: 'A4', pageSize: '(21 x 29.7cm)', value: 'A4', width: 21, height: 29.7},
    {label: 'A5', pageSize: '(14.8 x 21cm)', value: 'A5', width: 14.8, height: 21},
    {label: 'Legal', pageSize: '(21.59 x 35.56cm)', value: 'Legal', width: 21.59, height: 35.56},
    {label: 'Letter', pageSize: '(21.59 x 27.94cm)', value: 'Letter', width: 21.59, height: 27.94},
]
export const DOCUMENT_BORDER_SIZE = [
    {label: 'None', value: 0},
    {label: '1mm', value: 3},
    {label: '2mm', value: 6},
    {label: '3mm', value: 9},
    {label: '5mm', value: 15},
    {label: '10mm', value: 30},
]

export const STATUTORY_TYPE = [
    {label: 'All', value: 1},
    {label: 'EPF', value: 2},
    {label: 'ABRY', value: 3},
    {label: 'ESIC', value: 4},
    {label: 'Workers Compensation Insurance', value: 5},
    {label: 'Aadhar Card', value: 6},
    {label: 'PAN card', value: 7},
]
export const UAC_CONSTANT = {
    HOLIDAY: "HOLIDAY",
    IPBLOCKING: "IPBLOCKING",
    OVERTIME: "OVERTIME",
    COMP_OFF: "COMPOFF",
    GEO: "GEO",
    PBD: "PBD",
    SHIFT: "SHIFT",
    SHIFT_REQUEST: "SHIFT_REQUEST",
    WEEKEND: "WEEKEND",
    PENALISATION: "PENALISATION",
    PAYROLL_SALARY_TEMPLATE: "PAYROLL_SALARY_TEMPLATE",
    UAC: "UAC",
    WD: "WD",
    NWD: "NWD",
    LEAVE: "LEAVE",
    CLOCK_IN_SETTING: "CLOCK_IN_SETTING",
    POLICY_DOC: "POLICY_DOCUMENT",
    REFERRAL_POLICY: "REFERRAL_POLICY",
    SHIFT_SCHEDULER: "SHIFT_SCHEDULER",
    PRODUCT_ACCESS: "PRODUCT_ACCESS",
    REIMBURSEMENT: 'REIMBURSEMENT_TYPE',
    BIOMETRICS: "BIOMETRICS"
}
export const MONTH = {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec',
}
export const MONTHS_DAYS = [
    {label: '1', value: 1},
    {label: '2', value: 2},
    {label: '3', value: 3},
    {label: '4', value: 4},
    {label: '5', value: 5},
    {label: '6', value: 6},
    {label: '7', value: 7},
    {label: '8', value: 8},
    {label: '9', value: 9},
    {label: '10', value: 10},
    {label: '11', value: 11},
    {label: '12', value: 12},
    {label: '13', value: 13},
    {label: '14', value: 14},
    {label: '15', value: 15},
    {label: '16', value: 16},
    {label: '17', value: 17},
    {label: '18', value: 18},
    {label: '19', value: 19},
    {label: '20', value: 20},
    {label: '21', value: 21},
    {label: '22', value: 22},
    {label: '23', value: 23},
    {label: '24', value: 24},
    {label: '25', value: 25},
    {label: '26', value: 26},
    {label: '27', value: 27},
    {label: '28', value: 28},
    {label: '29', value: 29},
    {label: '30', value: 30},
    {label: '31', value: 31},
];
export const AFTER_BEFORE = [
    {label: 'Before', value: 2},
    {label: 'Same', value: 3},
    {label: 'After', value: 1},

]
export const CONSTANT = {
    PLATFORM: (isInApp() && ['Android', 'iOS'].includes(getMobileOperatingSystem())) ? getMobileOperatingSystem()?.toLowerCase() : 'web',
    COLORS: [
        '#1d873f',
        '#0f7fff',
        '#ffa801',
        '#fe6f5e',
        '#747880',
        '#8e3b99',
        '#618b8c',
        '#ff55a3',
        '#009e60',
        '#DF73FF',
        '#ffb871',
        '#6495ed',
        '#45b1e8',
        '#77dd77',
        '#9c8e8e',
        '#7F5417',
        '#2377a2',
        '#f3ac76',
        '#917214',
        '#96ded1',
        '#000000',
        '#167f71',
        '#191970',
        '#fe6f5e',
        '#747880',
        '#507389',
        '#FFA700'],
    COLOR_ARRAY: [
        {label: '#1d873f', value: '#1d873f'},
        {label: '#0f7fff', value: '#0f7fff'},
        {label: '#ffa801', value: '#ffa801'},
        {label: '#fe6f5e', value: '#fe6f5e'},
        {label: '#747880', value: '#747880'},
        {label: '#8e3b99', value: '#8e3b99'},
        {label: '#618b8c', value: '#618b8c'},
        {label: '#ff55a3', value: '#ff55a3'},
        {label: '#009e60', value: '#009e60'},
        {label: '#DF73FF', value: '#DF73FF'},
        {label: '#ffb871', value: '#ffb871'},
        {label: '#6495ed', value: '#6495ed'},
        {label: '#45b1e8', value: '#45b1e8'},
        {label: '#77dd77', value: '#77dd77'},
        {label: '#9c8e8e', value: '#9c8e8e'},
        {label: '#7F5417', value: '#7F5417'},
        {label: '#2377a2', value: '#2377a2'},
        {label: '#f3ac76', value: '#f3ac76'},
        {label: '#917214', value: '#917214'},
        {label: '#96ded1', value: '#96ded1'},
        {label: '#000000', value: '#000000'},
        {label: '#167f71', value: '#167f71'},
        {label: '#191970', value: '#191970'},
        {label: '#fe6f5e', value: '#fe6f5e'},
        {label: '#747880', value: '#747880'},
        {label: '#507389', value: '#507389'},
        {label: '#FFA700', value: '#FFA700'},
        {label: '#007AFF', value: '#007AFF'},

        ],
        COUNTRY_CODE: [
            {"name": "Afghanistan", "label": "Afghanistan", "dial_code": "+93", "code": "AF"},
            {"name": "Aland Islands", "label": "Aland Islands", "dial_code": "+358", "code": "AX"},
            {"name": "Albania", "label": "Albania", "dial_code": "+355", "code": "AL"},
            {"name": "Algeria", "label": "Algeria", "dial_code": "+213", "code": "DZ"},
            {"name": "Canada", "label": "Canada", "dial_code": "+1", "code": "CA"},
            {"name": "AmericanSamoa", "label": "AmericanSamoa", "dial_code": "+1684", "code": "AS"},
            {"name": "Andorra", "label": "Andorra", "dial_code": "+376", "code": "AD"},
            {"name": "Angola", "label": "Angola", "dial_code": "+244", "code": "AO"},
            {"name": "Anguilla", "label": "Anguilla", "dial_code": "+1264", "code": "AI"},
            {"name": "Antarctica", "label": "Antarctica", "dial_code": "+672", "code": "AQ"},
            {"name": "Antigua and Barbuda", "label": "Antigua and Barbuda", "dial_code": "+1268", "code": "AG"},
            {"name": "Argentina", "label": "Argentina", "dial_code": "+54", "code": "AR"},
            {"name": "Armenia", "label": "Armenia", "dial_code": "+374", "code": "AM"},
            {"name": "Aruba", "label": "Aruba", "dial_code": "+297", "code": "AW"},
            {"name": "Australia", "label": "Australia", "dial_code": "+61", "code": "AU"},
            {"name": "Austria", "label": "Austria", "dial_code": "+43", "code": "AT"},
            {"name": "Azerbaijan", "label": "Azerbaijan", "dial_code": "+994", "code": "AZ"},
            {"name": "Bahamas", "label": "Bahamas", "dial_code": "+1242", "code": "BS"},
            {"name": "Bahrain", "label": "Bahrain", "dial_code": "+973", "code": "BH"},
            {"name": "Bangladesh", "label": "Bangladesh", "dial_code": "+880", "code": "BD"},
            {"name": "Barbados", "label": "Barbados", "dial_code": "+1246", "code": "BB"},
            {"name": "Belarus", "label": "Belarus", "dial_code": "+375", "code": "BY"},
            {"name": "Belgium", "label": "Belgium", "dial_code": "+32", "code": "BE"},
            {"name": "Belize", "label": "Belize", "dial_code": "+501", "code": "BZ"},
            {"name": "Benin", "label": "Benin", "dial_code": "+229", "code": "BJ"},
            {"name": "Bermuda", "label": "Bermuda", "dial_code": "+1441", "code": "BM"},
            {"name": "Bhutan", "label": "Bhutan", "dial_code": "+975", "code": "BT"},
            {
                "name": "Bolivia, Plurinational State of",
                "label": "Bolivia, Plurinational State of",
                "dial_code": "+591",
                "code": "BO"
            },
            {"name": "Bosnia and Herzegovina", "label": "Bosnia and Herzegovina", "dial_code": "+387", "code": "BA"},
            {"name": "Botswana", "label": "Botswana", "dial_code": "+267", "code": "BW"},
            {"name": "Brazil", "label": "Brazil", "dial_code": "+55", "code": "BR"},
            {
                "name": "British Indian Ocean Territory",
                "label": "British Indian Ocean Territory",
                "dial_code": "+246",
                "code": "IO"
            },
            {"name": "Brunei Darussalam", "label": "Brunei Darussalam", "dial_code": "+673", "code": "BN"},
            {"name": "Bulgaria", "label": "Bulgaria", "dial_code": "+359", "code": "BG"},
            {"name": "Burkina Faso", "label": "Burkina Faso", "dial_code": "+226", "code": "BF"},
            {"name": "Burundi", "label": "Burundi", "dial_code": "+257", "code": "BI"},
            {"name": "Cambodia", "label": "Cambodia", "dial_code": "+855", "code": "KH"},
            {"name": "Cameroon", "label": "Cameroon", "dial_code": "+237", "code": "CM"},

            {"name": "Cape Verde", "label": "Cape Verde", "dial_code": "+238", "code": "CV"},
            {"name": "Cayman Islands", "label": "Cayman Islands", "dial_code": "+ 345", "code": "KY"},
            {"name": "Central African Republic", "label": "Central African Republic", "dial_code": "+236", "code": "CF"},
            {"name": "Chad", "label": "Chad", "dial_code": "+235", "code": "TD"},
            {"name": "Chile", "label": "Chile", "dial_code": "+56", "code": "CL"},
            {"name": "China", "label": "China", "dial_code": "+86", "code": "CN"},
            {"name": "Christmas Island", "label": "Christmas Island", "dial_code": "+61", "code": "CX"},
            {"name": "Cocos (Keeling) Islands", "label": "Cocos (Keeling) Islands", "dial_code": "+61", "code": "CC"},
            {"name": "Colombia", "label": "Colombia", "dial_code": "+57", "code": "CO"},
            {"name": "Comoros", "label": "Comoros", "dial_code": "+269", "code": "KM"},
            {"name": "Congo", "label": "Congo", "dial_code": "+242", "code": "CG"},
            {
                "name": "Congo, The Democratic Republic of the Congo",
                "label": "Congo, The Democratic Republic of the Congo",
                "dial_code": "+243",
                "code": "CD"
            },
            {"name": "Cook Islands", "label": "Cook Islands", "dial_code": "+682", "code": "CK"},
            {"name": "Costa Rica", "label": "Costa Rica", "dial_code": "+506", "code": "CR"},
            {"name": "Cote d'Ivoire", "label": "Cote d'Ivoire", "dial_code": "+225", "code": "CI"},
            {"name": "Croatia", "label": "Croatia", "dial_code": "+385", "code": "HR"},
            {"name": "Cuba", "label": "Cuba", "dial_code": "+53", "code": "CU"},
            {"name": "Cyprus", "label": "Cyprus", "dial_code": "+357", "code": "CY"},
            {"name": "Czech Republic", "label": "Czech Republic", "dial_code": "+420", "code": "CZ"},
            {"name": "Denmark", "label": "Denmark", "dial_code": "+45", "code": "DK"},
            {"name": "Djibouti", "label": "Djibouti", "dial_code": "+253", "code": "DJ"},
            {"name": "Dominica", "label": "Dominica", "dial_code": "+1767", "code": "DM"},
            {"name": "Dominican Republic", "label": "Dominican Republic", "dial_code": "+1849", "code": "DO"},
            {"name": "Ecuador", "label": "Ecuador", "dial_code": "+593", "code": "EC"},
            {"name": "Egypt", "label": "Egypt", "dial_code": "+20", "code": "EG"},
            {"name": "El Salvador", "label": "El Salvador", "dial_code": "+503", "code": "SV"},
            {"name": "Equatorial Guinea", "label": "Equatorial Guinea", "dial_code": "+240", "code": "GQ"},
            {"name": "Eritrea", "label": "Eritrea", "dial_code": "+291", "code": "ER"},
            {"name": "Estonia", "label": "Estonia", "dial_code": "+372", "code": "EE"},
            {"name": "Ethiopia", "label": "Ethiopia", "dial_code": "+251", "code": "ET"},
            {
                "name": "Falkland Islands (Malvinas)",
                "label": "Falkland Islands (Malvinas)",
                "dial_code": "+500",
                "code": "FK"
            },
            {"name": "Faroe Islands", "label": "Faroe Islands", "dial_code": "+298", "code": "FO"},
            {"name": "Fiji", "label": "Fiji", "dial_code": "+679", "code": "FJ"},
            {"name": "Finland", "label": "Finland", "dial_code": "+358", "code": "FI"},
            {"name": "France", "label": "France", "dial_code": "+33", "code": "FR"},
            {"name": "French Guiana", "label": "French Guiana", "dial_code": "+594", "code": "GF"},
            {"name": "French Polynesia", "label": "French Polynesia", "dial_code": "+689", "code": "PF"},
            {"name": "Gabon", "label": "Gabon", "dial_code": "+241", "code": "GA"},
            {"name": "Gambia", "label": "Gambia", "dial_code": "+220", "code": "GM"},
            {"name": "Georgia", "label": "Georgia", "dial_code": "+995", "code": "GE"},
            {"name": "Germany", "label": "Germany", "dial_code": "+49", "code": "DE"},
            {"name": "Ghana", "label": "Ghana", "dial_code": "+233", "code": "GH"},
            {"name": "Gibraltar", "label": "Gibraltar", "dial_code": "+350", "code": "GI"},
            {"name": "Greece", "label": "Greece", "dial_code": "+30", "code": "GR"},
            {"name": "Greenland", "label": "Greenland", "dial_code": "+299", "code": "GL"},
            {"name": "Grenada", "label": "Grenada", "dial_code": "+1473", "code": "GD"},
            {"name": "Guadeloupe", "label": "Guadeloupe", "dial_code": "+590", "code": "GP"},
            {"name": "Guam", "label": "Guam", "dial_code": "+1671", "code": "GU"},
            {"name": "Guatemala", "label": "Guatemala", "dial_code": "+502", "code": "GT"},
            {"name": "Guernsey", "label": "Guernsey", "dial_code": "+44", "code": "GG"},
            {"name": "Guinea", "label": "Guinea", "dial_code": "+224", "code": "GN"},
            {"name": "Guinea-Bissau", "label": "Guinea-Bissau", "dial_code": "+245", "code": "GW"},
            {"name": "Guyana", "label": "Guyana", "dial_code": "+595", "code": "GY"},
            {"name": "Haiti", "label": "Haiti", "dial_code": "+509", "code": "HT"},
            {
                "name": "Holy See (Vatican City State)",
                "label": "Holy See (Vatican City State)",
                "dial_code": "+379",
                "code": "VA"
            },
            {"name": "Honduras", "label": "Honduras", "dial_code": "+504", "code": "HN"},
            {"name": "Hong Kong", "label": "Hong Kong", "dial_code": "+852", "code": "HK"},
            {"name": "Hungary", "label": "Hungary", "dial_code": "+36", "code": "HU"},
            {"name": "Iceland", "label": "Iceland", "dial_code": "+354", "code": "IS"},
            {"name": "India", "label": "India", "dial_code": "+91", "code": "IN"},
            {"name": "Indonesia", "label": "Indonesia", "dial_code": "+62", "code": "ID"},
            {
                "name": "Iran, Islamic Republic of Persian Gulf",
                "label": "Iran, Islamic Republic of Persian Gulf",
                "dial_code": "+98",
                "code": "IR"
            },
            {"name": "Iraq", "label": "Iraq", "dial_code": "+964", "code": "IQ"},
            {"name": "Ireland", "label": "Ireland", "dial_code": "+353", "code": "IE"},
            {"name": "Isle of Man", "label": "Isle of Man", "dial_code": "+44", "code": "IM"},
            {"name": "Israel", "label": "Israel", "dial_code": "+972", "code": "IL"},
            {"name": "Italy", "label": "Italy", "dial_code": "+39", "code": "IT"},
            {"name": "Jamaica", "label": "Jamaica", "dial_code": "+1876", "code": "JM"},
            {"name": "Japan", "label": "Japan", "dial_code": "+81", "code": "JP"},
            {"name": "Jersey", "label": "Jersey", "dial_code": "+44", "code": "JE"},
            {"name": "Jordan", "label": "Jordan", "dial_code": "+962", "code": "JO"},
            {"name": "Kazakhstan", "label": "Kazakhstan", "dial_code": "+77", "code": "KZ"},
            {"name": "Kenya", "label": "Kenya", "dial_code": "+254", "code": "KE"},
            {"name": "Kiribati", "label": "Kiribati", "dial_code": "+686", "code": "KI"},
            {
                "name": "Korea, Democratic People's Republic of Korea",
                "label": "Korea, Democratic People's Republic of Korea",
                "dial_code": "+850",
                "code": "KP"
            },
            {
                "name": "Korea, Republic of South Korea",
                "label": "Korea, Republic of South Korea",
                "dial_code": "+82",
                "code": "KR"
            },
            {"name": "Kuwait", "label": "Kuwait", "dial_code": "+965", "code": "KW"},
            {"name": "Kyrgyzstan", "label": "Kyrgyzstan", "dial_code": "+996", "code": "KG"},
            {"name": "Laos", "label": "Laos", "dial_code": "+856", "code": "LA"},
            {"name": "Latvia", "label": "Latvia", "dial_code": "+371", "code": "LV"},
            {"name": "Lebanon", "label": "Lebanon", "dial_code": "+961", "code": "LB"},
            {"name": "Lesotho", "label": "Lesotho", "dial_code": "+266", "code": "LS"},
            {"name": "Liberia", "label": "Liberia", "dial_code": "+231", "code": "LR"},
            {"name": "Libyan Arab Jamahiriya", "label": "Libyan Arab Jamahiriya", "dial_code": "+218", "code": "LY"},
            {"name": "Liechtenstein", "label": "Liechtenstein", "dial_code": "+423", "code": "LI"},
            {"name": "Lithuania", "label": "Lithuania", "dial_code": "+370", "code": "LT"},
            {"name": "Luxembourg", "label": "Luxembourg", "dial_code": "+352", "code": "LU"},
            {"name": "Macao", "label": "Macao", "dial_code": "+853", "code": "MO"},
            {"name": "Macedonia", "label": "Macedonia", "dial_code": "+389", "code": "MK"},
            {"name": "Madagascar", "label": "Madagascar", "dial_code": "+261", "code": "MG"},
            {"name": "Malawi", "label": "Malawi", "dial_code": "+265", "code": "MW"},
            {"name": "Malaysia", "label": "Malaysia", "dial_code": "+60", "code": "MY"},
            {"name": "Maldives", "label": "Maldives", "dial_code": "+960", "code": "MV"},
            {"name": "Mali", "label": "Mali", "dial_code": "+223", "code": "ML"},
            {"name": "Malta", "label": "Malta", "dial_code": "+356", "code": "MT"},
            {"name": "Marshall Islands", "label": "Marshall Islands", "dial_code": "+692", "code": "MH"},
            {"name": "Martinique", "label": "Martinique", "dial_code": "+596", "code": "MQ"},
            {"name": "Mauritania", "label": "Mauritania", "dial_code": "+222", "code": "MR"},
            {"name": "Mauritius", "label": "Mauritius", "dial_code": "+230", "code": "MU"},
            {"name": "Mayotte", "label": "Mayotte", "dial_code": "+262", "code": "YT"},
            {"name": "Mexico", "label": "Mexico", "dial_code": "+52", "code": "MX"},
            {
                "name": "Micronesia, Federated States of Micronesia",
                "label": "Micronesia, Federated States of Micronesia",
                "dial_code": "+691",
                "code": "FM"
            },
            {"name": "Moldova", "label": "Moldova", "dial_code": "+373", "code": "MD"},
            {"name": "Monaco", "label": "Monaco", "dial_code": "+377", "code": "MC"},
            {"name": "Mongolia", "label": "Mongolia", "dial_code": "+976", "code": "MN"},
            {"name": "Montenegro", "label": "Montenegro", "dial_code": "+382", "code": "ME"},
            {"name": "Montserrat", "label": "Montserrat", "dial_code": "+1664", "code": "MS"},
            {"name": "Morocco", "label": "Morocco", "dial_code": "+212", "code": "MA"},
            {"name": "Mozambique", "label": "Mozambique", "dial_code": "+258", "code": "MZ"},
            {"name": "Myanmar", "label": "Myanmar", "dial_code": "+95", "code": "MM"},
            {"name": "Namibia", "label": "Namibia", "dial_code": "+264", "code": "NA"},
            {"name": "Nauru", "label": "Nauru", "dial_code": "+674", "code": "NR"},
            {"name": "Nepal", "label": "Nepal", "dial_code": "+977", "code": "NP"},
            {"name": "Netherlands", "label": "Netherlands", "dial_code": "+31", "code": "NL"},
            {"name": "Netherlands Antilles", "label": "Netherlands Antilles", "dial_code": "+599", "code": "AN"},
            {"name": "New Caledonia", "label": "New Caledonia", "dial_code": "+687", "code": "NC"},
            {"name": "New Zealand", "label": "New Zealand", "dial_code": "+64", "code": "NZ"},
            {"name": "Nicaragua", "label": "Nicaragua", "dial_code": "+505", "code": "NI"},
            {"name": "Niger", "label": "Niger", "dial_code": "+227", "code": "NE"},
            {"name": "Nigeria", "label": "Nigeria", "dial_code": "+234", "code": "NG"},
            {"name": "Niue", "label": "Niue", "dial_code": "+683", "code": "NU"},
            {"name": "Norfolk Island", "label": "Norfolk Island", "dial_code": "+672", "code": "NF"},
            {"name": "Northern Mariana Islands", "label": "Northern Mariana Islands", "dial_code": "+1670", "code": "MP"},
            {"name": "Norway", "label": "Norway", "dial_code": "+47", "code": "NO"},
            {"name": "Oman", "label": "Oman", "dial_code": "+968", "code": "OM"},
            {"name": "Pakistan", "label": "Pakistan", "dial_code": "+92", "code": "PK"},
            {"name": "Palau", "label": "Palau", "dial_code": "+680", "code": "PW"},
            {
                "name": "Palestinian Territory, Occupied",
                "label": "Palestinian Territory, Occupied",
                "dial_code": "+970",
                "code": "PS"
            },
            {"name": "Panama", "label": "Panama", "dial_code": "+507", "code": "PA"},
            {"name": "Papua New Guinea", "label": "Papua New Guinea", "dial_code": "+675", "code": "PG"},
            {"name": "Paraguay", "label": "Paraguay", "dial_code": "+595", "code": "PY"},
            {"name": "Peru", "label": "Peru", "dial_code": "+51", "code": "PE"},
            {"name": "Philippines", "label": "Philippines", "dial_code": "+63", "code": "PH"},
            {"name": "Pitcairn", "label": "Pitcairn", "dial_code": "+872", "code": "PN"},
            {"name": "Poland", "label": "Poland", "dial_code": "+48", "code": "PL"},
            {"name": "Portugal", "label": "Portugal", "dial_code": "+351", "code": "PT"},
            {"name": "Puerto Rico", "label": "Puerto Rico", "dial_code": "+1939", "code": "PR"},
            {"name": "Qatar", "label": "Qatar", "dial_code": "+974", "code": "QA"},
            {"name": "Romania", "label": "Romania", "dial_code": "+40", "code": "RO"},
            {"name": "Russia", "label": "Russia", "dial_code": "+7", "code": "RU"},
            {"name": "Rwanda", "label": "Rwanda", "dial_code": "+250", "code": "RW"},
            {"name": "Reunion", "label": "Reunion", "dial_code": "+262", "code": "RE"},
            {"name": "Saint Barthelemy", "label": "Saint Barthelemy", "dial_code": "+590", "code": "BL"},
            {
                "name": "Saint Helena, Ascension and Tristan Da Cunha",
                "label": "Saint Helena, Ascension and Tristan Da Cunha",
                "dial_code": "+290",
                "code": "SH"
            },
            {"name": "Saint Kitts and Nevis", "label": "Saint Kitts and Nevis", "dial_code": "+1869", "code": "KN"},
            {"name": "Saint Lucia", "label": "Saint Lucia", "dial_code": "+1758", "code": "LC"},
            {"name": "Saint Martin", "label": "Saint Martin", "dial_code": "+590", "code": "MF"},
            {"name": "Saint Pierre and Miquelon", "label": "Saint Pierre and Miquelon", "dial_code": "+508", "code": "PM"},
            {
                "name": "Saint Vincent and the Grenadines",
                "label": "Saint Vincent and the Grenadines",
                "dial_code": "+1784",
                "code": "VC"
            },
            {"name": "Samoa", "label": "Samoa", "dial_code": "+685", "code": "WS"},
            {"name": "San Marino", "label": "San Marino", "dial_code": "+378", "code": "SM"},
            {"name": "Sao Tome and Principe", "label": "Sao Tome and Principe", "dial_code": "+239", "code": "ST"},
            {"name": "Saudi Arabia", "label": "Saudi Arabia", "dial_code": "+966", "code": "SA"},
            {"name": "Senegal", "label": "Senegal", "dial_code": "+221", "code": "SN"},
            {"name": "Serbia", "label": "Serbia", "dial_code": "+381", "code": "RS"},
            {"name": "Seychelles", "label": "Seychelles", "dial_code": "+248", "code": "SC"},
            {"name": "Sierra Leone", "label": "Sierra Leone", "dial_code": "+232", "code": "SL"},
            {"name": "Singapore", "label": "Singapore", "dial_code": "+65", "code": "SG"},
            {"name": "Slovakia", "label": "Slovakia", "dial_code": "+421", "code": "SK"},
            {"name": "Slovenia", "label": "Slovenia", "dial_code": "+386", "code": "SI"},
            {"name": "Solomon Islands", "label": "Solomon Islands", "dial_code": "+677", "code": "SB"},
            {"name": "Somalia", "label": "Somalia", "dial_code": "+252", "code": "SO"},
            {"name": "South Africa", "label": "South Africa", "dial_code": "+27", "code": "ZA"},
            {"name": "South Sudan", "label": "South Sudan", "dial_code": "+211", "code": "SS"},
            {
                "name": "South Georgia and the South Sandwich Islands",
                "label": "South Georgia and the South Sandwich Islands",
                "dial_code": "+500",
                "code": "GS"
            },
            {"name": "Spain", "label": "Spain", "dial_code": "+34", "code": "ES"},
            {"name": "Sri Lanka", "label": "Sri Lanka", "dial_code": "+94", "code": "LK"},
            {"name": "Sudan", "label": "Sudan", "dial_code": "+249", "code": "SD"},
            {"name": "Suriname", "label": "Suriname", "dial_code": "+597", "code": "SR"},
            {"name": "Svalbard and Jan Mayen", "label": "Svalbard and Jan Mayen", "dial_code": "+47", "code": "SJ"},
            {"name": "Swaziland", "label": "Swaziland", "dial_code": "+268", "code": "SZ"},
            {"name": "Sweden", "label": "Sweden", "dial_code": "+46", "code": "SE"},
            {"name": "Switzerland", "label": "Switzerland", "dial_code": "+41", "code": "CH"},
            {"name": "Syrian Arab Republic", "label": "Syrian Arab Republic", "dial_code": "+963", "code": "SY"},
            {"name": "Taiwan", "label": "Taiwan", "dial_code": "+886", "code": "TW"},
            {"name": "Tajikistan", "label": "Tajikistan", "dial_code": "+992", "code": "TJ"},
            {
                "name": "Tanzania, United Republic of Tanzania",
                "label": "Tanzania, United Republic of Tanzania",
                "dial_code": "+255",
                "code": "TZ"
            },
            {"name": "Thailand", "label": "Thailand", "dial_code": "+66", "code": "TH"},
            {"name": "Timor-Leste", "label": "Timor-Leste", "dial_code": "+670", "code": "TL"},
            {"name": "Togo", "label": "Togo", "dial_code": "+228", "code": "TG"},
            {"name": "Tokelau", "label": "Tokelau", "dial_code": "+690", "code": "TK"},
            {"name": "Tonga", "label": "Tonga", "dial_code": "+676", "code": "TO"},
            {"name": "Trinidad and Tobago", "label": "Trinidad and Tobago", "dial_code": "+1868", "code": "TT"},
            {"name": "Tunisia", "label": "Tunisia", "dial_code": "+216", "code": "TN"},
            {"name": "Turkey", "label": "Turkey", "dial_code": "+90", "code": "TR"},
            {"name": "Turkmenistan", "label": "Turkmenistan", "dial_code": "+993", "code": "TM"},
            {"name": "Turks and Caicos Islands", "label": "Turks and Caicos Islands", "dial_code": "+1649", "code": "TC"},
            {"name": "Tuvalu", "label": "Tuvalu", "dial_code": "+688", "code": "TV"},
            {"name": "Uganda", "label": "Uganda", "dial_code": "+256", "code": "UG"},
            {"name": "Ukraine", "label": "Ukraine", "dial_code": "+380", "code": "UA"},
            {"name": "United Arab Emirates", "label": "United Arab Emirates", "dial_code": "+971", "code": "AE"},
            {"name": "United Kingdom", "label": "United Kingdom", "dial_code": "+44", "code": "GB"},
            {"name": "United States", "label": "United States", "dial_code": "+1", "code": "US"},
            {"name": "Uruguay", "label": "Uruguay", "dial_code": "+598", "code": "UY"},
            {"name": "Uzbekistan", "label": "Uzbekistan", "dial_code": "+998", "code": "UZ"},
            {"name": "Vanuatu", "label": "Vanuatu", "dial_code": "+678", "code": "VU"},
            {
                "name": "Venezuela, Bolivarian Republic of Venezuela",
                "label": "Venezuela, Bolivarian Republic of Venezuela",
                "dial_code": "+58",
                "code": "VE"
            },
            {"name": "Vietnam", "label": "Vietnam", "dial_code": "+84", "code": "VN"},
            {"name": "Virgin Islands, British", "label": "Virgin Islands, British", "dial_code": "+1284", "code": "VG"},
            {"name": "Virgin Islands, U.S.", "label": "Virgin Islands, U.S.", "dial_code": "+1340", "code": "VI"},
            {"name": "Wallis and Futuna", "label": "Wallis and Futuna", "dial_code": "+681", "code": "WF"},
            {"name": "Yemen", "label": "Yemen", "dial_code": "+967", "code": "YE"},
            {"name": "Zambia", "label": "Zambia", "dial_code": "+260", "code": "ZM"},
            {"name": "Zimbabwe", "label": "Zimbabwe", "dial_code": "+263", "code": "ZW"}
        ],
        COUNTRIES: ['Afghanistan', 'land Islands', 'Albania', 'Algeria', 'American Samoa', 'AndorrA', 'Angola', 'Anguilla', 'Antarctica', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Bouvet Island', 'Brazil', 'British Indian Ocean Territory', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo', 'Congo, The Democratic Republic of the', 'Cook Islands', 'Costa Rica', 'Cote D\'Ivoire', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands (Malvinas)', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Guiana', 'French Polynesia', 'French Southern Territories', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Heard Island and Mcdonald Islands', 'Holy See (Vatican City State)', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran, Islamic Republic Of', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Korea, Democratic People\'S Republic of', 'Korea, Republic of', 'Kuwait', 'Kyrgyzstan', 'Lao People\'S Democratic Republic', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libyan Arab Jamahiriya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macao', 'Macedonia, The Former Yugoslav Republic of', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia, Federated States of', 'Moldova, Republic of', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern Mariana Islands', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestinian Territory, Occupied', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russian Federation', 'RWANDA', 'Saint Helena', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Pierre and Miquelon', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia and the South Sandwich Islands', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard and Jan Mayen', 'Swaziland', 'Sweden', 'Switzerland', 'Syrian Arab Republic', 'Taiwan, Province of China', 'Tajikistan', 'Tanzania, United Republic of', 'Thailand', 'Timor-Leste', 'Togo', 'Tokelau', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks and Caicos Islands', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'United States Minor Outlying Islands', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Venezuela', 'Viet Nam', 'Virgin Islands, British', 'Virgin Islands, U.S.', 'Wallis and Futuna', 'Western Sahara', 'Yemen', 'Zambia', 'Zimbabwe'],
        LANGUAGES: [
            {code: "ab", name: "Abkhaz", nativeName: "аҧсуа"},
            {code: "aa", name: "Afar", nativeName: "Afaraf"},
            {code: "af", name: "Afrikaans", nativeName: "Afrikaans"},
            {code: "ak", name: "Akan", nativeName: "Akan"},
            {code: "sq", name: "Albanian", nativeName: "Shqip"},
            {code: "am", name: "Amharic", nativeName: "አማርኛ"},
            {code: "ar", name: "Arabic", nativeName: "العربية"},
            {code: "an", name: "Aragonese", nativeName: "Aragonés"},
            {code: "hy", name: "Armenian", nativeName: "Հայերեն"},
            {code: "as", name: "Assamese", nativeName: "অসমীয়া"},
            {code: "av", name: "Avaric", nativeName: "авар мацӀ, магӀарул мацӀ"},
            {code: "ae", name: "Avestan", nativeName: "avesta"},
            {code: "ay", name: "Aymara", nativeName: "aymar aru"},
            {code: "az", name: "Azerbaijani", nativeName: "azərbaycan dili"},
            {code: "bm", name: "Bambara", nativeName: "bamanankan"},
            {code: "ba", name: "Bashkir", nativeName: "башҡорт теле"},
            {code: "eu", name: "Basque", nativeName: "euskara, euskera"},
            {code: "be", name: "Belarusian", nativeName: "Беларуская"},
            {code: "bn", name: "Bengali", nativeName: "বাংলা"},
            {code: "bh", name: "Bihari", nativeName: "भोजपुरी"},
            {code: "bi", name: "Bislama", nativeName: "Bislama"},
            {code: "bs", name: "Bosnian", nativeName: "bosanski jezik"},
            {code: "br", name: "Breton", nativeName: "brezhoneg"},
            {code: "bg", name: "Bulgarian", nativeName: "български език"},
            {code: "my", name: "Burmese", nativeName: "ဗမာစာ"},
            {code: "ca", name: "Catalan; Valencian", nativeName: "Català"},
            {code: "ch", name: "Chamorro", nativeName: "Chamoru"},
            {code: "ce", name: "Chechen", nativeName: "нохчийн мотт"},
            {
                code: "ny",
                name: "Chichewa; Chewa; Nyanja",
                nativeName: "chiCheŵa, chinyanja",
            },
            {code: "zh", name: "Chinese", nativeName: "中文 (Zhōngwén), 汉语, 漢語"},
            {code: "cv", name: "Chuvash", nativeName: "чӑваш чӗлхи"},
            {code: "kw", name: "Cornish", nativeName: "Kernewek"},
            {code: "co", name: "Corsican", nativeName: "corsu, lingua corsa"},
            {code: "cr", name: "Cree", nativeName: "ᓀᐦᐃᔭᐍᐏᐣ"},
            {code: "hr", name: "Croatian", nativeName: "hrvatski"},
            {code: "cs", name: "Czech", nativeName: "česky, čeština"},
            {code: "da", name: "Danish", nativeName: "dansk"},
            {code: "dv", name: "Divehi; Dhivehi; Maldivian;", nativeName: "ދިވެހި"},
            {code: "nl", name: "Dutch", nativeName: "Nederlands, Vlaams"},
            {code: "en", name: "English", nativeName: "English"},
            {code: "eo", name: "Esperanto", nativeName: "Esperanto"},
            {code: "et", name: "Estonian", nativeName: "eesti, eesti keel"},
            {code: "ee", name: "Ewe", nativeName: "Eʋegbe"},
            {code: "fo", name: "Faroese", nativeName: "føroyskt"},
            {code: "fj", name: "Fijian", nativeName: "vosa Vakaviti"},
            {code: "fi", name: "Finnish", nativeName: "suomi, suomen kieli"},
            {code: "fr", name: "French", nativeName: "français, langue française"},
            {
                code: "ff",
                name: "Fula; Fulah; Pulaar; Pular",
                nativeName: "Fulfulde, Pulaar, Pular",
            },
            {code: "gl", name: "Galician", nativeName: "Galego"},
            {code: "ka", name: "Georgian", nativeName: "ქართული"},
            {code: "de", name: "German", nativeName: "Deutsch"},
            {code: "el", name: "Greek, Modern", nativeName: "Ελληνικά"},
            {code: "gn", name: "Guaraní", nativeName: "Avañeẽ"},
            {code: "gu", name: "Gujarati", nativeName: "ગુજરાતી"},
            {
                code: "ht",
                name: "Haitian; Haitian Creole",
                nativeName: "Kreyòl ayisyen",
            },
            {code: "ha", name: "Hausa", nativeName: "Hausa, هَوُسَ"},
            {code: "he", name: "Hebrew (modern)", nativeName: "עברית"},
            {code: "hz", name: "Herero", nativeName: "Otjiherero"},
            {code: "hi", name: "Hindi", nativeName: "हिन्दी, हिंदी"},
            {code: "ho", name: "Hiri Motu", nativeName: "Hiri Motu"},
            {code: "hu", name: "Hungarian", nativeName: "Magyar"},
            {code: "ia", name: "Interlingua", nativeName: "Interlingua"},
            {code: "id", name: "Indonesian", nativeName: "Bahasa Indonesia"},
            {
                code: "ie",
                name: "Interlingue",
                nativeName: "Originally called Occidental; then Interlingue after WWII",
            },
            {code: "ga", name: "Irish", nativeName: "Gaeilge"},
            {code: "ig", name: "Igbo", nativeName: "Asụsụ Igbo"},
            {code: "ik", name: "Inupiaq", nativeName: "Iñupiaq, Iñupiatun"},
            {code: "io", name: "Ido", nativeName: "Ido"},
            {code: "is", name: "Icelandic", nativeName: "Íslenska"},
            {code: "it", name: "Italian", nativeName: "Italiano"},
            {code: "iu", name: "Inuktitut", nativeName: "ᐃᓄᒃᑎᑐᑦ"},
            {
                code: "ja",
                name: "Japanese",
                nativeName: "日本語 (にほんご／にっぽんご)",
            },
            {code: "jv", name: "Javanese", nativeName: "basa Jawa"},
            {
                code: "kl",
                name: "Kalaallisut, Greenlandic",
                nativeName: "kalaallisut, kalaallit oqaasii",
            },
            {code: "kn", name: "Kannada", nativeName: "ಕನ್ನಡ"},
            {code: "kr", name: "Kanuri", nativeName: "Kanuri"},
            {code: "ks", name: "Kashmiri", nativeName: "कश्मीरी, كشميري‎"},
            {code: "kk", name: "Kazakh", nativeName: "Қазақ тілі"},
            {code: "km", name: "Khmer", nativeName: "ភាសាខ្មែរ"},
            {code: "ki", name: "Kikuyu, Gikuyu", nativeName: "Gĩkũyũ"},
            {code: "rw", name: "Kinyarwanda", nativeName: "Ikinyarwanda"},
            {code: "ky", name: "Kirghiz, Kyrgyz", nativeName: "кыргыз тили"},
            {code: "kv", name: "Komi", nativeName: "коми кыв"},
            {code: "kg", name: "Kongo", nativeName: "KiKongo"},
            {
                code: "ko",
                name: "Korean",
                nativeName: "한국어 (韓國語), 조선말 (朝鮮語)",
            },
            {code: "ku", name: "Kurdish", nativeName: "Kurdî, كوردی‎"},
            {code: "kj", name: "Kwanyama, Kuanyama", nativeName: "Kuanyama"},
            {code: "la", name: "Latin", nativeName: "latine, lingua latina"},
            {
                code: "lb",
                name: "Luxembourgish, Letzeburgesch",
                nativeName: "Lëtzebuergesch",
            },
            {code: "lg", name: "Luganda", nativeName: "Luganda"},
            {
                code: "li",
                name: "Limburgish, Limburgan, Limburger",
                nativeName: "Limburgs",
            },
            {code: "ln", name: "Lingala", nativeName: "Lingála"},
            {code: "lo", name: "Lao", nativeName: "ພາສາລາວ"},
            {code: "lt", name: "Lithuanian", nativeName: "lietuvių kalba"},
            {code: "lu", name: "Luba-Katanga", nativeName: ""},
            {code: "lv", name: "Latvian", nativeName: "latviešu valoda"},
            {code: "gv", name: "Manx", nativeName: "Gaelg, Gailck"},
            {code: "mk", name: "Macedonian", nativeName: "македонски јазик"},
            {code: "mg", name: "Malagasy", nativeName: "Malagasy fiteny"},
            {code: "ms", name: "Malay", nativeName: "bahasa Melayu, بهاس ملايو‎"},
            {code: "ml", name: "Malayalam", nativeName: "മലയാളം"},
            {code: "mt", name: "Maltese", nativeName: "Malti"},
            {code: "mi", name: "Māori", nativeName: "te reo Māori"},
            {code: "mr", name: "Marathi (Marāṭhī)", nativeName: "मराठी"},
            {code: "mh", name: "Marshallese", nativeName: "Kajin M̧ajeļ"},
            {code: "mn", name: "Mongolian", nativeName: "монгол"},
            {code: "na", name: "Nauru", nativeName: "Ekakairũ Naoero"},
            {
                code: "nv",
                name: "Navajo, Navaho",
                nativeName: "Diné bizaad, Dinékʼehǰí",
            },
            {code: "nb", name: "Norwegian Bokmål", nativeName: "Norsk bokmål"},
            {code: "nd", name: "North Ndebele", nativeName: "isiNdebele"},
            {code: "ne", name: "Nepali", nativeName: "नेपाली"},
            {code: "ng", name: "Ndonga", nativeName: "Owambo"},
            {code: "nn", name: "Norwegian Nynorsk", nativeName: "Norsk nynorsk"},
            {code: "no", name: "Norwegian", nativeName: "Norsk"},
            {code: "ii", name: "Nuosu", nativeName: "ꆈꌠ꒿ Nuosuhxop"},
            {code: "nr", name: "South Ndebele", nativeName: "isiNdebele"},
            {code: "oc", name: "Occitan", nativeName: "Occitan"},
            {code: "oj", name: "Ojibwe, Ojibwa", nativeName: "ᐊᓂᔑᓈᐯᒧᐎᓐ"},
            {
                code: "cu",
                name:
                    "Old Church Slavonic",
                nativeName: "ѩзыкъ словѣньскъ",
            },
            {code: "om", name: "Oromo", nativeName: "Afaan Oromoo"},
            {code: "or", name: "Oriya", nativeName: "ଓଡ଼ିଆ"},
            {code: "os", name: "Ossetian, Ossetic", nativeName: "ирон æвзаг"},
            {code: "pa", name: "Panjabi, Punjabi", nativeName: "ਪੰਜਾਬੀ, پنجابی‎"},
            {code: "pi", name: "Pāli", nativeName: "पाऴि"},
            {code: "fa", name: "Persian", nativeName: "فارسی"},
            {code: "pl", name: "Polish", nativeName: "polski"},
            {code: "ps", name: "Pashto, Pushto", nativeName: "پښتو"},
            {code: "pt", name: "Portuguese", nativeName: "Português"},
            {code: "qu", name: "Quechua", nativeName: "Runa Simi, Kichwa"},
            {code: "rm", name: "Romansh", nativeName: "rumantsch grischun"},
            {code: "rn", name: "Kirundi", nativeName: "kiRundi"},
            {code: "ro", name: "Romanian, Moldavian, Moldovan", nativeName: "română"},
            {code: "ru", name: "Russian", nativeName: "русский язык"},
            {code: "sa", name: "Sanskrit (Saṁskṛta)", nativeName: "संस्कृतम्"},
            {code: "sc", name: "Sardinian", nativeName: "sardu"},
            {code: "sd", name: "Sindhi", nativeName: "सिन्धी, سنڌي، سندھی‎"},
            {code: "se", name: "Northern Sami", nativeName: "Davvisámegiella"},
            {code: "sm", name: "Samoan", nativeName: "gagana faa Samoa"},
            {code: "sg", name: "Sango", nativeName: "yângâ tî sängö"},
            {code: "sr", name: "Serbian", nativeName: "српски језик"},
            {code: "gd", name: "Scottish Gaelic; Gaelic", nativeName: "Gàidhlig"},
            {code: "sn", name: "Shona", nativeName: "chiShona"},
            {code: "si", name: "Sinhala, Sinhalese", nativeName: "සිංහල"},
            {code: "sk", name: "Slovak", nativeName: "slovenčina"},
            {code: "sl", name: "Slovene", nativeName: "slovenščina"},
            {code: "so", name: "Somali", nativeName: "Soomaaliga, af Soomaali"},
            {code: "st", name: "Southern Sotho", nativeName: "Sesotho"},
            {
                code: "es",
                name: "Spanish; Castilian",
                nativeName: "español, castellano",
            },
            {code: "su", name: "Sundanese", nativeName: "Basa Sunda"},
            {code: "sw", name: "Swahili", nativeName: "Kiswahili"},
            {code: "ss", name: "Swati", nativeName: "SiSwati"},
            {code: "sv", name: "Swedish", nativeName: "svenska"},
            {code: "ta", name: "Tamil", nativeName: "தமிழ்"},
            {code: "te", name: "Telugu", nativeName: "తెలుగు"},
            {code: "tg", name: "Tajik", nativeName: "тоҷикӣ, toğikī, تاجیکی‎"},
            {code: "th", name: "Thai", nativeName: "ไทย"},
            {code: "ti", name: "Tigrinya", nativeName: "ትግርኛ"},
            {
                code: "bo",
                name: "Tibetan Standard, Tibetan, Central",
                nativeName: "བོད་ཡིག",
            },
            {code: "tk", name: "Turkmen", nativeName: "Türkmen, Түркмен"},
            {code: "tl", name: "Tagalog", nativeName: "Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔"},
            {code: "tn", name: "Tswana", nativeName: "Setswana"},
            {code: "to", name: "Tonga (Tonga Islands)", nativeName: "faka Tonga"},
            {code: "tr", name: "Turkish", nativeName: "Türkçe"},
            {code: "ts", name: "Tsonga", nativeName: "Xitsonga"},
            {code: "tt", name: "Tatar", nativeName: "татарча, tatarça, تاتارچا‎"},
            {code: "tw", name: "Twi", nativeName: "Twi"},
            {code: "ty", name: "Tahitian", nativeName: "Reo Tahiti"},
            {code: "ug", name: "Uighur, Uyghur", nativeName: "Uyƣurqə, ئۇيغۇرچە‎"},
            {code: "uk", name: "Ukrainian", nativeName: "українська"},
            {code: "ur", name: "Urdu", nativeName: "اردو"},
            {code: "uz", name: "Uzbek", nativeName: "zbek, Ўзбек, أۇزبېك‎"},
            {code: "ve", name: "Venda", nativeName: "Tshivenḓa"},
            {code: "vi", name: "Vietnamese", nativeName: "Tiếng Việt"},
            {code: "vo", name: "Volapük", nativeName: "Volapük"},
            {code: "wa", name: "Walloon", nativeName: "Walon"},
            {code: "cy", name: "Welsh", nativeName: "Cymraeg"},
            {code: "wo", name: "Wolof", nativeName: "Wollof"},
            {code: "fy", name: "Western Frisian", nativeName: "Frysk"},
            {code: "xh", name: "Xhosa", nativeName: "isiXhosa"},
            {code: "yi", name: "Yiddish", nativeName: "ייִדיש"},
            {code: "yo", name: "Yoruba", nativeName: "Yorùbá"},
            {code: "za", name: "Zhuang, Chuang", nativeName: "Saɯ cueŋƅ, Saw cuengh"},
        ],
        STATES: [
            {"label": "Andhra Pradesh", "value": "Andhra Pradesh"},
            {"label": "Arunachal Pradesh", "value": "Arunachal Pradesh"},
            {"label": "Assam", "value": "Assam"},
            {"label": "Bihar", "value": "Bihar"},
            {"label": "Chhattisgarh", "value": "Chhattisgarh"},
            {"label": "Goa", "value": "Goa"},
            {"label": "Gujarat", "value": "Gujarat"},
            {"label": "Haryana", "value": "Haryana"},
            {"label": "Himachal Pradesh", "value": "Himachal Pradesh"},
            {"label": "Jammu and Kashmir", "value": "Jammu and Kashmir"},
            {"label": "Jharkhand", "value": "Jharkhand"},
            {"label": "Karnataka", "value": "Karnataka"},
            {"label": "Kerala", "value": "Kerala"},
            {"label": "Madhya Pradesh", "value": "Madhya Pradesh"},
            {"label": "Maharashtra", "value": "Maharashtra"},
            {"label": "Manipur", "value": "Manipur"},
            {"label": "Meghalaya", "value": "Meghalaya"},
            {"label": "Mizoram", "value": "Mizoram"},
            {"label": "Nagaland", "value": "Nagaland"},
            {"label": "Odisha", "value": "Odisha"},
            {"label": "Punjab", "value": "Punjab"},
            {"label": "Rajasthan", "value": "Rajasthan"},
            {"label": "Sikkim", "value": "Sikkim"},
            {"label": "Tamil Nadu", "value": "Tamil Nadu"},
            {"label": "Telangana", "value": "Telangana"},
            {"label": "Tripura", "value": "Tripura"},
            {"label": "Uttarakhand", "value": "Uttarakhand"},
            {"label": "Uttar Pradesh", "value": "Uttar Pradesh"},
            {"label": "West Bengal", "value": "West Bengal"},
            {"label": "Andaman and Nicobar Islands", "value": "Andaman and Nicobar Islands"},
            {"label": "Chandigarh", "value": "Chandigarh"},
            {"label": "Dadra and Nagar Haveli", "value": "Dadra and Nagar Haveli"},
            {"label": "Daman and Diu", "value": "Daman and Diu"},
            {"label": "Delhi", "value": "Delhi"},
            {"label": "Lakshadweep", "value": "Lakshadweep"},
            {"label": "Puducherry", "value": "Puducherry"},
        ],
        GENDER: [
            {"value": 1, "label": "Male"},
            {"value": 2, "label": "Female"},
            {"value": 3, "label": "Other"},
        ],
        GENDER_LIST: [
            {"value": 'male', "label": "Male"},
            {"value": 'female', "label": "Female"},
            {"value": 'other', "label": "Other"},
        ],
        IMPORT_ACTION_LIST: [
            {"value": 'isAddManager', "label": "Add Reporting Manager"},
            {"value": 'isReplaceManager', "label": "Replace Reporting Manager"},
            {"value": 'isRemoveManager', "label": "Remove Reporting Manager"},
        ],
        YES_NO: [
            {"value": 'YES', "label": "YES", type: true},
            {"value": 'NO', "label": "NO", type: false},
        ],
        TRUE_FALSE: [
            {"value": 'true', "label": "TRUE"},
            {"value": 'false', "label": "FALSE"},
        ],
        MARITAL_STATUS: [
            {label: "Married", value: 1},
            {label: "Unmarried", value: 2},
        ],
        EMPLOYEE_EXIT_TYPE: [ /** used in import employee fields */
            {label: "Resignation", value: "Resignation"},
            {label: "Termination", value: "Termination"},
        ],
        EMPLOYEE_EXIT_TYPE_2: [ /** used in import employee fields */
            {label: "Terminate", value: 'TERMINATE'},
            {label: "Resign", value: 'RESIGN'},
        ],
        REHIRE: [ /** used in import employee fields */
            {label: "TRUE", value: "TRUE"},
            {label: "FALSE", value: "FALSE"},
        ],
        REHIRE_FILTER: [ /** used in import employee fields */
            {label: "Yes", value: 1},
            {label: "No", value: 2},
        ],

    PAYROLL_TYPE: [
        {"value": 'REGULAR', "label": "Regular Payroll", type: 1},
        {"value": 'IMPORT', "label": "Import Payroll", type: 2},
    ],
    PAYMENT_TYPE: [
        {value: 1, label: "Inside Payroll"},
        {value: 2, label: "Outside Payroll"},
    ],
    PAID_MODE: [
        {value: 1, label: "Bank"},
        {value: 2, label: "Cash"},
        {value: 3, label: "Cheque"},
    ],
    REIMBURSE_PAID: [
        {value: 1, label: "Self"},
        {value: 2, label: "Client"},
    ],
    MARITAL_STATUS_LIST: [
        {label: "Married", value: "married"},
        {label: "Unmarried", value: "unmarried"},
    ],
    BLACKLIST_LIST : [
        {value: true, label: 'BlackList'},
    ],
    IS_HANDICAP : [
        {value: 1, label: 'Yes'},
        {value: 2, label: 'No'},
    ],
    IS_AADHAR_PAN_LINK : [
        {value: 1, label: 'Linked'},
        {value: 2, label: 'Not Linked'},
    ],
    ONDUTY_TYPE: [
        {label: "On Duty", value: 1},
        {label: "Work From Home", value: 2},
    ],
    SALARY_MODE: [
        {value: 'all', label: 'All'},
        {value: 'bank-transfer', label: 'Bank Transfer'},
        {value: 'cash', label: 'Cash'},
    ],
    SALARY_STATUS: [
        {value: 'all', label: 'All'},
        {value: 'regular', label: 'Regular'},
        {value: 'security-deposit', label: 'Security Deposit'},
    ],
    MATH_ACTION: [
        {label: 'Add', value: 1,},
        {label: 'Subtract', value: 2,}
    ],
    BLOOD_GROUP_LIST: [
        {value: 1, label: 'O-'},
        {value: 2, label: 'O+'},
        {value: 3, label: 'A-'},
        {value: 4, label: 'A+'},
        {value: 5, label: 'B-'},
        {value: 6, label: 'B+'},
        {value: 7, label: 'AB-'},
        {value: 8, label: 'AB+'},
    ],
    EMPLOYEE_GROUP: [
        {value: 'name', label: 'Name'},
        {value: 'department', label: 'Department'},
        {value: 'location', label: 'Location'},
    ],
    EMPLOYEE_ADD_TYPE: [
        {value: 'PERSONAL_INFO', label: 'Personal Info ', type : 9},
        {value: 'EMERGENCY_CONTACT', label: 'Emergency Contact',type : 16},
        {value: 'ORGANIZATION_STRUCTURE', label: 'Org Structure', type : 5},
        {value: 'JOB_INFO', label: ' Job Info', type : 10},
        {value: 'BLACKLIST', label: 'BlackList', type : 8},
        {value: 'AGREEMENT_INFO', label: ' Agreement info', type : 11},
        {value: 'COMPENSATION_INFO', label: ' Compensation info', type : 12},
        {value: 'RESIGNATION_INFO', label: 'Resignation info', type : 13},
        {value: 'BANK_INFO', label: 'Bank Information', type : 14},
        // {value: 'ACTIVE', label: 'Active', type : 1},
        // {value: 'INACTIVE', label: 'InActive', type : 1},

        ],
        ARCHIVE_LIST: [
            {label: 'Active', value: 'active'},
            {label: 'Archive', value: 'archive'},
        ],
        PAY_FREQUENCY: [
            {value: 1, label: 'Hourly'},
            {value: 2, label: 'Monthly'},
            {value: 3, label: 'Daily'},
            {value: 5, label: 'Daily Pay Hourly'},
            {value: 6, label: 'Monthly Pay Hourly'},
        ],
        // full & final settlement pending list
        ERROR_STEP2: [
            {label: 'Attendance ', value: 2},
            {label: 'Leave ', value: 2.1},
            {label: 'Missing Days', value: 2.2},
        ],
        ERROR_STEP3: [
            {label: 'Overtime ', value: 3},
            {label: 'Bonus ', value: 3.1},
            {label: 'Penalisation', value: 3.2},
            {label: 'Reimbursement', value: 3.3},
        ],
        REQUEST_PENDING_LIST: {
            GENERAL: 201,
            ATTENDANCE: 202,
            LEAVE: 203,
            ATTENDANCE_MISSING: 204,
            OVERTIME: 205,
            LATE_IN: 206,
            MONTHLY_BONUS: 207,
            REIMBURSEMENT: 208,
            PENALISATION: 211
        },
        BIOMETRIC_PUNCHES_FAILED_TYPE: [
            {label: 'Finger ID not matched with Biometrics device', value: 3},
            {label: 'You\'re not assigned with the Clock In Method Policy', value: 4}
        ],
        BANK_ACCOUNT_TYPE: [
            {value: 'saving', label: 'Savings'},
            {value: 'salary', label: 'Salary'},
            {value: 'current', label: 'Current'}
        ],
        ISACTIVE: [ /** used in import employee fields */
            {label: "TRUE", value: "TRUE"},
            {label: "FALSE", value: "FALSE"},
        ],
        TIME_FRAME: [
            {value: 'YEARLY', label: 'Yearly ', type: 1},
            {value: 'MONTHLY', label: 'Monthly', type: 2},
            {value: 'QUARTERLY', label: 'Quarterly ', type: 3},
            {value: 'CUSTOM', label: 'Custom', type: 4},
        ],
        QUARTER: [
            {value: 1, label: 'Q1'},
            {value: 2, label: 'Q2'},
            {value: 3, label: 'Q3'},
            {value: 4, label: 'Q4'},
        ],
        QUARTERLY :[
            {value: 1, label: 'Quarter 1'},
            {value: 2, label: 'Quarter 2'},
            {value: 3, label: 'Quarter 3'},
            {value: 4, label: 'Quarter 4'},
        ],
        BUDGET_GROUPBY: [
            {value: 'LOCATION', label: 'Location ', type: 1},
            {value: 'DEPARTMENT', label: 'Department', type: 2},
        ],
        BUDGET_STATUS: [
            {label: 'Draft', status: 'draft', color: '#FFA700', value: 1},
            {label: 'Active', status: 'active', color: '#60B158', value: 2},
            {label: 'Expired', status: 'expired', color: '#FF6961', value: 3},
        ]
    }
;

export const LATE_IN_STATUS = {
    PENDING: 1,
    APPROVED: 2,
    REJECTED: 3,
    1: "Pending",
    2: "Approved",
    3: "Rejected",
}
export const LATE_IN_PENALTY_TYPE = {
    AMOUNT: 1,
    LEAVE: 2,
    SLOT: 3,
}
export const PENALISATION_PENALTY_TYPE = [
    {label: 'After', value: 1},
    {label: 'Every', value: 2},
]
export const REIMBURSEMENT_STATUS = {
    PENDING: 1,
    APPROVED: 2,
    REJECTED: 3,
    CANCELLED: 3,
    1: "Pending",
    2: "Approved",
    3: "Rejected",
    4: "cancelled",
}

export const HELP_DESK = {
    TICKET_TYPE: {
        'my-tickets': 'myTickets',
        'assign-tickets': 'assignToMe',
        'follower-tickets': 'followerTicket',
        // 'companies-tickets': 'companiesTickets',
        'all-tickets': 'allTickets',
        'dashboard': 'dashboard',
    },
    TICKET_STATUS: [
        {label: 'All Tickets', value: 'allTicket'},
        {label: 'Open Tickets', value: 'openTicket'},
        {label: 'Resolved Tickets', value: 'resolvedTicket'},
    ],
    ACTION: {
        NEXT: 1,
        PREVIOUS: 2
    }
}

export const TIMELINE = {
    ACTIVITY: {
        CREATE: 1,
        UPDATE: 2,
        DELETE: 3,
        ARCHIVE: 4,
        UNARCHIVE: 5,
    },
    POST_TYPE: {
        PRAISE: 1,
        INTERNAL_NOTE: 2,
        FEEDBACK: 3,
        FEEDBACK_REQUEST: 7,
    },
}

export const ANNOUNCEMENT = {
    POST_TYPE: {
        PRAISE: 1,
        INTERNAL_NOTE: 2,
        FEEDBACK: 3,
        POST: 4,
        POLL: 5,
        WISH: 6,
        FEEDBACK_REQUEST: 7,
        ANNOUNCEMENT: 8,
        ALL: 9
    },
    WISH_TYPE: {
        BIRTHDAY: 1,
        ANNIVERSARY: 2,
        NEWJOINEE: 3
    },
    WISH_TYPE_: [
        {value: 'BIRTHDAY', label: 'Birthday Wish ', wishType : 1},
        {value: 'ANNIVERSARY', label: 'Work Anniversary',wishType : 2},
        {value: 'NEWJOINEE', label: ' New Joinee', wishType : 3},
    ],
        WISHBIRTHDAY: 1,
        WORKANNIVERSARY: 2,
        NEWJOINEE: 3
    ,
    POST_STATUS: {
        PUBLISH: 1,
        DRAFT: 2
    },
    MY_FEED_FILTER_TYPE: {
        ALL: 1,
        POST: 2,
        DRAFT: 3,
        BOOKMARK: 4,
        MENTIONS: 5,
        PRAISE: 6,
        ANNOUNCEMENT: 7,
        POLL: 8,
        WISH: 9
    },
    POLL_RESULT_TYPE: {
        AFTER_POLL_END: 1,
        AFTER_VOTE: 2
    },
    FEED_FILTER_TYPE: {
        ALL: 1,
        POST: 2,
        POLL: 3,
        WISH: 4,
        PRAISE: 5,
        ANNOUNCEMENT: 6
    },
    // TAG_LIST_TYPE: {
    //     USER: 1,
    //     UAC_ROLE: 2,
    //     DEPARTMENT: 3,
    //     JOB_TITLE: 4,
    //     LOCATION: 5,
    //     SUB_COMPANY: 6
    // },
    ACTIVITY: {
        CREATE: 1,
        UPDATE: 2,
    },
};

export const COMMENT_REACTION = [
    {
        reaction: 'grinning_face',
        title: 'Grinning Face',
        image: '😀',
        reactionGif: 'https://cdn.joypixels.com/products/previews/O6D7BMG8R2DMMNC4LLZH/2297_mDocsiylucSgq3Cg1FwLK8shgtGEMvP7.gif'
    },
    {
        reaction: 'thumbsup',
        title: 'Thumbs Up',
        image: '👍',
        reactionGif: 'https://cdn.joypixels.com/products/previews/O6D7BMG8R2DMMNC4LLZH/2402_F52AqOaPz52RLBTiwBtZUMhlkm4mahDl.gif'
    },
    {
        reaction: 'heart',
        title: 'Heart',
        image: '♥️',
        reactionGif: 'https://cdn.joypixels.com/products/previews/O6D7BMG8R2DMMNC4LLZH/3171_kv3bs3Yo250FnIc7stT1yL6HzBcjOYeE.gif'
    },
    {
        reaction: 'tada',
        title: 'Tada',
        image: '🎉',
        reactionGif: 'https://cdn.joypixels.com/products/previews/O6D7BMG8R2DMMNC4LLZH/3166_IlZBq7MYilwdaqfqnmEcTNOuppcpi2c6.gif'
    },
    {
        reaction: 'clap',
        title: 'Clapping',
        image: '👏',
        reactionGif: 'https://cdn.joypixels.com/products/previews/O6D7BMG8R2DMMNC4LLZH/2400_2JoADz74WYIcKBdYxLTTAboVaqCKEAbq.gif'
    },
    {
        reaction: 'fire',
        title: 'Fire',
        image: '🔥',
        reactionGif: 'https://cdn.joypixels.com/products/previews/O6D7BMG8R2DMMNC4LLZH/3106_9qTxA57k7StZYhBXKh2beVpviSqO5Anr.gif'
    },
    {
        reaction: '100',
        title: 'Hundred',
        image: '💯',
        reactionGif: 'https://cdn.joypixels.com/products/previews/O6D7BMG8R2DMMNC4LLZH/3175_BLC6JAod61dCgHY60MHi7ikIjY1OmwP4.gif'
    },
    {
        reaction: 'heart_eyes',
        title: 'Heart Eyes',
        image: '😍',
        reactionGif: 'https://cdn.joypixels.com/products/previews/O6D7BMG8R2DMMNC4LLZH/2304_q4MLtmc7BVILKnAWzHaf9RcRSZhkNNzi.gif'
    },
]

export const BANK_PLACEHOLDER = [
    {key: "employeeId", title: "Employee ID"},
    {key: "company_name", title: "Company Name"},
    {key: "emplyee_name", title: "Employee Name"},
    {key: "month_year", title: "Month Year"},
    {key: "salary", title: "Salary"},
    {key: "ledgerCode", title: "Ledger Code"}
]

export const MINUTE_HOUR = [
    {label: 'Minute', value: 'minute'},
    {label: 'Hour', value: 'hour'},
]

export const PMS_CLIENTS = {
    CURRENCY_TYPE: [
        {value: '$', label: '$'},
        {value: '₹', label: '₹'},
        {value: '€', label: '€'},
    ],
    CLIENT_TYPE: [
        {value: '', label: 'All Clients'},
        {value: false, label: 'Active Clients'},
        {value: true, label: 'Inactive Clients'},
    ],
}

export const ORGANIZATION_STRUCTURE_FIELDS = {
    BUSINESS_UNIT: 1,
    COST_CENTER: 2,
    BANDS: 3,
    SEGMENT: 4,
    HUB: 5,
    REGION: 6,
    TERRITORY: 7,
    ZONE: 8,
    GRADE: 9,
}

export const EMPLOYEE_FIELDS = {
    CATEGORY: 1,
    DEPARTMENT: 2,
    SUB_DEPARTMENT: 3,
    JOB_TITLE: 4,
    PERSONAL_DOCUMENTS: 5,
    DEGREE: 6,
    RELATIONSHIP: 7,
    EMPLOYMENT_STATUS: 8,
    EMPLOYEE_EXIT: 9,
    LOCATION_ACTIVITY: 10,
    LETTER_TYPE: 11
}

export const IMPORT_REPORT_TYPE = {
    ABSENT_PRESENT_ATTANDEANCE: 1,
    LEAVE_BALANCE: 2,
    EMOPLYEE_FIELDS_CATEGORY: 3,
    EMOPLYEE_FIELDS_DEPARTMENT: 4,
    EMOPLYEE_FIELDS_SUB_DEPARTMENT: 5,
    EMOPLYEE_FIELDS_JOB_TITLE: 6,
    EMOPLYEE_FIELDS_PERSONAL_DOCUMENTS: 7,
    EMOPLYEE_FIELDS_DEGREE: 8,
    EMOPLYEE_FIELDS_RELATIONSHIP: 9,
    EMOPLYEE_FIELDS_EMPLOYMENT_STATUS: 10,
    EMOPLYEE_FIELDS_EMPLOYEE_EXIT: 11,
    EMOPLYEE_FIELDS_LOCATION_ACTIVITY: 12,
    EMOPLYEE_FIELDS_LETTER_TYPE: 13,
    ORGANIZATION_STRUCTURE_BUSINESS_UNIT: 14,
    ORGANIZATION_STRUCTURE_COST_CENTER: 15,
    ORGANIZATION_STRUCTURE_BANDS: 16,
    ORGANIZATION_STRUCTURE_SEGMENT: 17,
    ORGANIZATION_STRUCTURE_HUB: 18,
    ORGANIZATION_STRUCTURE_REGION: 19,
    ORGANIZATION_STRUCTURE_TERRITORY: 20,
    ORGANIZATION_STRUCTURE_ZONE: 21,
    ORGANIZATION_STRUCTURE_GRADE: 41
}

export const IMPORT_STATUS = [
    {label: 'Pending', status: 'pending', color: '#FFA700', value: 1},
    {label: 'Failed', status: 'failed', color: '#60B158', value: 2},
    {label: 'Success', status: 'success', color: '#FF6961', value: 3},
];

export const EMP_COLUMN_LIST = [
    {label: 'Employee Name', value: 'employeeName', status: true},
    {label: 'Employee ID', value: 'employeeId', status: true},
    {label: 'Job Title', value: 'jobTitle', status: true},
    {label: 'Email', value: 'email', status: true},
    {label: 'Category', value: 'category', status: true},
    {label: 'Department', value: 'department', status: true},
    {label: 'Sub Department', value: 'subDepartment', status: false},
    {label: 'Company', value: 'companyId', status: false},
    {label: 'Gender', value: 'gender', status: false},
    {label: "Physical Handicap", value: 'isPhysicalHandicap', status: false},
    {label: "Aadhar & PAN Card Linked", value: 'isAadhaarPanVerified', status: false},
    {label: 'Location', value: 'location', status: false},
    {label: 'Location Wise Country', value: 'locationWiseCountry', status: false},
    {label: 'Location Wise State', value: 'locationWiseState', status: false},
    {label: 'Sub Location', value: 'subLocation', status: false},
    {label: 'Province/State', value: 'province', status: false},
    {label: 'Employment Status', value: 'employeeStatus', status: false},
    {label: 'Joining Date', value: 'joiningDate', status: false},
    {label: 'Date Of Birth', value: 'dob', status: false},
    {label: 'Marital Status', value: 'maritalStatus', status: false},
    {label: 'Phone Number', value: 'phoneNumber', status: false},
    {label: 'Agreement Start Date', value: 'bondStart', status: false},
    {label: 'Agreement End Date', value: 'bondEnd', status: false},
    {label: 'Line Manager', value: 'lineManager', status: false},
    {label: 'Line Manager 2', value: 'lineManager2', status: false},
    {label: 'Reporting Manager', value: 'reportingManager', status: false},
    {label: 'Last Login', value: 'lastActiveAt', status: false},
    {label: 'Business Unit', value: 'businessUnit', status: false},
    {label: 'Cost Center', value: 'costCenter', status: false},
    {label: 'Grade', value: 'grade', status: false},
    {label: 'Bands', value: 'bands', status: false},
    {label: 'Segment', value: 'segment', status: false},
    {label: 'Hub', value: 'hub', status: false},
    {label: 'Territory', value: 'territory', status: false},
    {label: 'Region', value: 'region', status: false},
    {label: 'WorkArea', value: 'workArea', status: false},
];

export const ATTENDANCE_COLUMN_LIST = [
    {label: 'Date', value: 'date', status: false},
    {label: 'Employee Name', value: 'employeeName', status: false},
    {label: 'Display Name', value: 'displayName', status: false},
    {label: 'Employee ID', value: 'employeeId', status: false},
    {label: 'Attendance Status', value: 'attendanceStatus', status: false},
    {label: 'Attendance Type', value: 'attendanceType', status: false},
    {label: 'Attendance Action', value: 'attendanceAction', status: false},
    {label: 'Clock IN', value: 'initialInTime', status: false},
    {label: 'Clock OUT', value: 'finalOutTime', status: false},
    {label: 'Total Time', value: 'totalHours', status: false},
    {label: 'Remote work Time', value: 'onDutyTime', status: false},
    {label: 'Break Hours', value: 'breakTime', status: false},
    {label: 'Productive Hours', value: 'productiveHours', status: false},
    {label: 'Extra Time', value: 'overTime', status: false},
    {label: 'Penalty', value: 'penalty', status: false},
    {label: 'Day Status', value: 'dayStatus', status: false},
    {label: 'Company', value: 'companyId', status: false},
    {label: 'Location', value: 'location', status: false},
    {label: ' Sub Location', value: 'subLocation', status: false},
    {label: 'Job Title', value: 'jobTitle', status: false},
    {label: 'Department', value: 'department', status: false},
    {label: 'Shift', value: 'shift', status: false},
    {label: 'Clock IN IP', value: 'inTimeIp', status: false},
    {label: 'Clock OUT IP', value: 'outTimeIp', status: false},
];

// Select Timezone Type options
export const TIMEZONE_OPTIONS = [
    {value: "Etc/GMT+12", label: "(GMT -12:00) International Date Line West ( Etc/GMT+12 )"},
    {value: "Pacific/Niue", label: "(GMT -11:00) Niue Time ( Pacific/Niue )"},
    {value: "Pacific/Pago_Pago", label: "(GMT -11:00) Samoa Standard Time ( Pacific/Pago_Pago )"},
    {value: "America/Adak", label: "(GMT -10:00) Hawaii-Aleutian Standard Time ( America/Adak )"},
    {value: "Pacific/Honolulu", label: "(GMT -10:00) Hawaii-Aleutian Standard Time ( Pacific/Honolulu )"},
    {value: "Pacific/Rarotonga", label: "(GMT -10:00) Cook Islands Standard Time ( Pacific/Rarotonga )"},
    {value: "Pacific/Tahiti", label: "(GMT -10:00) Tahiti Time ( Pacific/Tahiti )"},
    {value: "Pacific/Marquesas", label: "(GMT -09:30) Marquesas Time ( Pacific/Marquesas )"},
    {value: "America/Anchorage", label: "(GMT -09:00) Alaska Standard Time ( America/Anchorage )"},
    {value: "America/Juneau", label: "(GMT -09:00) Alaska Standard Time ( America/Juneau )"},
    {value: "America/Metlakatla", label: "(GMT -09:00) Alaska Standard Time ( America/Metlakatla )"},
    {value: "America/Nome", label: "(GMT -09:00) Alaska Standard Time ( America/Nome )"},
    {value: "America/Sitka", label: "(GMT -09:00) Alaska Standard Time ( America/Sitka )"},
    {value: "America/Yakutat", label: "(GMT -09:00) Alaska Standard Time ( America/Yakutat )"},
    {value: "Pacific/Gambier", label: "(GMT -09:00) Gambier Time ( Pacific/Gambier )"},
    {value: "America/Los_Angeles", label: "(GMT -08:00) Pacific Standard Time ( America/Los_Angeles )"},
    {value: "America/Tijuana", label: "(GMT -08:00) Pacific Standard Time ( America/Tijuana )"},
    {value: "America/Vancouver", label: "(GMT -08:00) Pacific Standard Time ( America/Vancouver )"},
    {value: "Pacific/Pitcairn", label: "(GMT -08:00) Pitcairn Time ( Pacific/Pitcairn )"},
    // {value: "PST", label: "(GMT -08:00) Pacific Standard Time ( PST )"},
    {value: "America/Boise", label: "(GMT -07:00) Mountain Standard Time ( America/Boise )"},
    {value: "America/Cambridge_Bay", label: "(GMT -07:00) Mountain Standard Time ( America/Cambridge_Bay )"},
    {value: "America/Ciudad_Juarez", label: "(GMT -07:00) Mountain Standard Time ( America/Ciudad_Juarez )"},
    {value: "America/Dawson", label: "(GMT -07:00) Pacific Standard Time ( America/Dawson )"},
    {value: "America/Dawson_Creek", label: "(GMT -07:00) Mountain Standard Time ( America/Dawson_Creek )"},
    {value: "America/Denver", label: "(GMT -07:00) Mountain Standard Time ( America/Denver )"},
    {value: "America/Edmonton", label: "(GMT -07:00) Mountain Standard Time ( America/Edmonton )"},
    {value: "America/Fort_Nelson", label: "(GMT -07:00) Mountain Standard Time ( America/Fort_Nelson )"},
    {value: "America/Hermosillo", label: "(GMT -07:00) Mexican Pacific Standard Time ( America/Hermosillo )"},
    {value: "America/Inuvik", label: "(GMT -07:00) Mountain Standard Time ( America/Inuvik )"},
    {value: "America/Mazatlan", label: "(GMT -07:00) Mexican Pacific Standard Time ( America/Mazatlan )"},
    {value: "America/Phoenix", label: "(GMT -07:00) Mountain Standard Time ( America/Phoenix )"},
    {value: "America/Whitehorse", label: "(GMT -07:00) Pacific Standard Time ( America/Whitehorse )"},
    {value: "MST", label: "(GMT -07:00) Mountain Standard Time ( MST )"},
    {value: "America/Bahia_Banderas", label: "(GMT -06:00) Central Standard Time ( America/Bahia_Banderas )"},
    {value: "America/Belize", label: "(GMT -06:00) Central Standard Time ( America/Belize )"},
    {value: "America/Chicago", label: "(GMT -06:00) Central Standard Time ( America/Chicago )"},
    {value: "America/Chihuahua", label: "(GMT -06:00) Central Standard Time ( America/Chihuahua )"},
    {value: "America/Costa_Rica", label: "(GMT -06:00) Central Standard Time ( America/Costa_Rica )"},
    {value: "America/El_Salvador", label: "(GMT -06:00) Central Standard Time ( America/El_Salvador )"},
    {value: "America/Guatemala", label: "(GMT -06:00) Central Standard Time ( America/Guatemala )"},
    {value: "America/Indiana/Knox", label: "(GMT -06:00) Central Standard Time ( America/Indiana/Knox )"},
    {value: "America/Indiana/Tell_City", label: "(GMT -06:00) Central Standard Time ( America/Indiana/Tell_City )"},
    {value: "America/Managua", label: "(GMT -06:00) Central Standard Time ( America/Managua )"},
    {value: "America/Matamoros", label: "(GMT -06:00) Central Standard Time ( America/Matamoros )"},
    {value: "America/Menominee", label: "(GMT -06:00) Central Standard Time ( America/Menominee )"},
    {value: "America/Merida", label: "(GMT -06:00) Central Standard Time ( America/Merida )"},
    {value: "America/Mexico_City", label: "(GMT -06:00) Central Standard Time ( America/Mexico_City )"},
    {value: "America/Monterrey", label: "(GMT -06:00) Central Standard Time ( America/Monterrey )"},
    {value: "America/North_Dakota/Beulah", label: "(GMT -06:00) Central Standard Time ( America/North_Dakota/Beulah )"},
    {value: "America/North_Dakota/Center", label: "(GMT -06:00) Central Standard Time ( America/North_Dakota/Center )"},
    {value: "America/North_Dakota/New_Salem", label: "(GMT -06:00) Central Standard Time ( America/North_Dakota/New_Salem )"},
    {value: "America/Ojinaga", label: "(GMT -06:00) Central Standard Time ( America/Ojinaga )"},
    {value: "America/Rankin_Inlet", label: "(GMT -06:00) Central Standard Time ( America/Rankin_Inlet )"},
    {value: "America/Regina", label: "(GMT -06:00) Central Standard Time ( America/Regina )"},
    {value: "America/Resolute", label: "(GMT -06:00) Central Standard Time ( America/Resolute )"},
    {value: "America/Swift_Current", label: "(GMT -06:00) Central Standard Time ( America/Swift_Current )"},
    {value: "America/Tegucigalpa", label: "(GMT -06:00) Central Standard Time ( America/Tegucigalpa )"},
    {value: "America/Winnipeg", label: "(GMT -06:00) Central Standard Time ( America/Winnipeg )"},
    {value: "CST6CDT", label: "(GMT -06:00) Central Standard Time ( CST6CDT )"},
    {value: "Pacific/Galapagos", label: "(GMT -06:00) Galapagos Time ( Pacific/Galapagos )"},
    {value: "America/Bogota", label: "(GMT -05:00) Colombia Standard Time ( America/Bogota )"},
    {value: "America/Cancun", label: "(GMT -05:00) Eastern Standard Time ( America/Cancun )"},
    {value: "America/Detroit", label: "(GMT -05:00) Eastern Standard Time ( America/Detroit )"},
    {value: "America/Eirunepe", label: "(GMT -05:00) Acre Standard Time ( America/Eirunepe )"},
    {value: "America/Grand_Turk", label: "(GMT -05:00) Eastern Standard Time ( America/Grand_Turk )"},
    {value: "America/Guayaquil", label: "(GMT -05:00) Ecuador Time ( America/Guayaquil )"},
    {value: "America/Havana", label: "(GMT -05:00) Cuba Standard Time ( America/Havana )"},
    {value: "America/Indiana/Indianapolis", label: "(GMT -05:00) Eastern Standard Time ( America/Indiana/Indianapolis )"},
    {value: "America/Indiana/Marengo", label: "(GMT -05:00) Eastern Standard Time ( America/Indiana/Marengo )"},
    {value: "America/Indiana/Petersburg", label: "(GMT -05:00) Eastern Standard Time ( America/Indiana/Petersburg )"},
    {value: "America/Indiana/Vevay", label: "(GMT -05:00) Eastern Standard Time ( America/Indiana/Vevay )"},
    {value: "America/Indiana/Vincennes", label: "(GMT -05:00) Eastern Standard Time ( America/Indiana/Vincennes )"},
    {value: "America/Indiana/Winamac", label: "(GMT -05:00) Eastern Standard Time ( America/Indiana/Winamac )"},
    {value: "America/Iqaluit", label: "(GMT -05:00) Eastern Standard Time ( America/Iqaluit )"},
    {value: "America/Jamaica", label: "(GMT -05:00) Eastern Standard Time ( America/Jamaica )"},
    {value: "America/Kentucky/Louisville", label: "(GMT -05:00) Eastern Standard Time ( America/Kentucky/Louisville )"},
    {value: "America/Kentucky/Monticello", label: "(GMT -05:00) Eastern Standard Time ( America/Kentucky/Monticello )"},
    {value: "America/Lima", label: "(GMT -05:00) Peru Standard Time ( America/Lima )"},
    {value: "America/New_York", label: "(GMT -05:00) Eastern Standard Time ( America/New_York )"},
    {value: "America/Panama", label: "(GMT -05:00) Eastern Standard Time ( America/Panama )"},
    {value: "America/Port-au-Prince", label: "(GMT -05:00) Eastern Standard Time ( America/Port-au-Prince )"},
    {value: "America/Rio_Branco", label: "(GMT -05:00) Acre Standard Time ( America/Rio_Branco )"},
    {value: "America/Toronto", label: "(GMT -05:00) Eastern Standard Time ( America/Toronto )"},
    {value: "Pacific/Easter", label: "(GMT -05:00) Easter Island Summer Time ( Pacific/Easter )"},
    {value: "America/Barbados", label: "(GMT -04:00) Atlantic Standard Time ( America/Barbados )"},
    {value: "America/Boa_Vista", label: "(GMT -04:00) Amazon Standard Time ( America/Boa_Vista )"},
    {value: "America/Campo_Grande", label: "(GMT -04:00) Amazon Standard Time ( America/Campo_Grande )"},
    {value: "America/Caracas", label: "(GMT -04:00) Venezuela Time ( America/Caracas )"},
    {value: "America/Cuiaba", label: "(GMT -04:00) Amazon Standard Time ( America/Cuiaba )"},
    {value: "America/Glace_Bay", label: "(GMT -04:00) Atlantic Standard Time ( America/Glace_Bay )"},
    {value: "America/Goose_Bay", label: "(GMT -04:00) Atlantic Standard Time ( America/Goose_Bay )"},
    {value: "America/Guyana", label: "(GMT -04:00) Guyana Time ( America/Guyana )"},
    {value: "America/Halifax", label: "(GMT -04:00) Atlantic Standard Time ( America/Halifax )"},
    {value: "America/La_Paz", label: "(GMT -04:00) Bolivia Time ( America/La_Paz )"},
    {value: "America/Manaus", label: "(GMT -04:00) Amazon Standard Time ( America/Manaus )"},
    {value: "America/Martinique", label: "(GMT -04:00) Atlantic Standard Time ( America/Martinique )"},
    {value: "America/Moncton", label: "(GMT -04:00) Atlantic Standard Time ( America/Moncton )"},
    {value: "America/Porto_Velho", label: "(GMT -04:00) Amazon Standard Time ( America/Porto_Velho )"},
    {value: "America/Puerto_Rico", label: "(GMT -04:00) Atlantic Standard Time ( America/Puerto_Rico )"},
    {value: "America/Santo_Domingo", label: "(GMT -04:00) Atlantic Standard Time ( America/Santo_Domingo )"},
    {value: "America/Thule", label: "(GMT -04:00) Atlantic Standard Time ( America/Thule )"},
    {value: "Atlantic/Bermuda", label: "(GMT -04:00) Atlantic Standard Time ( Atlantic/Bermuda )"},
    // {value: "SystemV/AST4ADT", label: "(GMT -04:00) Atlantic Standard Time ( SystemV/AST4ADT )"},
    // {value: "PRT", label: "(GMT -04:00) Atlantic Standard Time ( PRT )"},
    {value: "America/St_Johns", label: "(GMT -03:30) Newfoundland Standard Time ( America/St_Johns )"},
    {value: "America/Araguaina", label: "(GMT -03:00) Brasilia Standard Time ( America/Araguaina )"},
    {value: "America/Argentina/Buenos_Aires", label: "(GMT -03:00) Argentina Standard Time ( America/Argentina/Buenos_Aires )"},
    {value: "America/Argentina/Catamarca", label: "(GMT -03:00) Argentina Standard Time ( America/Argentina/Catamarca )"},
    {value: "America/Argentina/Cordoba", label: "(GMT -03:00) Argentina Standard Time ( America/Argentina/Cordoba )"},
    {value: "America/Argentina/Jujuy", label: "(GMT -03:00) Argentina Standard Time ( America/Argentina/Jujuy )"},
    {value: "America/Argentina/La_Rioja", label: "(GMT -03:00) Argentina Standard Time ( America/Argentina/La_Rioja )"},
    {value: "America/Argentina/Mendoza", label: "(GMT -03:00) Argentina Standard Time ( America/Argentina/Mendoza )"},
    {value: "America/Argentina/Rio_Gallegos", label: "(GMT -03:00) Argentina Standard Time ( America/Argentina/Rio_Gallegos )"},
    {value: "America/Argentina/Salta", label: "(GMT -03:00) Argentina Standard Time ( America/Argentina/Salta )"},
    {value: "America/Argentina/San_Juan", label: "(GMT -03:00) Argentina Standard Time ( America/Argentina/San_Juan )"},
    {value: "America/Argentina/San_Luis", label: "(GMT -03:00) Western Argentina Standard Time ( America/Argentina/San_Luis )"},
    {value: "America/Argentina/Tucuman", label: "(GMT -03:00) Argentina Standard Time ( America/Argentina/Tucuman )"},
    {value: "America/Argentina/Ushuaia", label: "(GMT -03:00) Argentina Standard Time ( America/Argentina/Ushuaia )"},
    {value: "America/Asuncion", label: "(GMT -03:00) Paraguay Summer Time ( America/Asuncion )"},
    {value: "America/Bahia", label: "(GMT -03:00) Brasilia Standard Time ( America/Bahia )"},
    {value: "America/Belem", label: "(GMT -03:00) Brasilia Standard Time ( America/Belem )"},
    {value: "America/Cayenne", label: "(GMT -03:00) French Guiana Time ( America/Cayenne )"},
    {value: "America/Fortaleza", label: "(GMT -03:00) Brasilia Standard Time ( America/Fortaleza )"},
    {value: "America/Maceio", label: "(GMT -03:00) Brasilia Standard Time ( America/Maceio )"},
    {value: "America/Miquelon", label: "(GMT -03:00) St. Pierre &amp; Miquelon Standard Time ( America/Miquelon )"},
    {value: "America/Montevideo", label: "(GMT -03:00) Uruguay Standard Time ( America/Montevideo )"},
    {value: "America/Paramaribo", label: "(GMT -03:00) Suriname Time ( America/Paramaribo )"},
    {value: "America/Punta_Arenas", label: "(GMT -03:00) Punta Arenas Standard Time ( America/Punta_Arenas )"},
    {value: "America/Recife", label: "(GMT -03:00) Brasilia Standard Time ( America/Recife )"},
    {value: "America/Santarem", label: "(GMT -03:00) Brasilia Standard Time ( America/Santarem )"},
    {value: "America/Santiago", label: "(GMT -03:00) Chile Summer Time ( America/Santiago )"},
    {value: "America/Sao_Paulo", label: "(GMT -03:00) Brasilia Standard Time ( America/Sao_Paulo )"},
    {value: "Antarctica/Palmer", label: "(GMT -03:00) Chile Time ( Antarctica/Palmer )"},
    {value: "Antarctica/Rothera", label: "(GMT -03:00) Rothera Time ( Antarctica/Rothera )"},
    {value: "Atlantic/Stanley", label: "(GMT -03:00) Falkland Islands Standard Time ( Atlantic/Stanley )"},
    {value: "America/Noronha", label: "(GMT -02:00) Fernando de Noronha Standard Time ( America/Noronha )"},
    {value: "America/Nuuk", label: "(GMT -02:00) Western Greenland Time ( America/Nuuk )"},
    {value: "Atlantic/South_Georgia", label: "(GMT -02:00) South Georgia Time ( Atlantic/South_Georgia )"},
    {value: "America/Scoresbysund", label: "(GMT -01:00) East Greenland Standard Time ( America/Scoresbysund )"},
    {value: "Atlantic/Azores", label: "(GMT -01:00) Azores Standard Time ( Atlantic/Azores )"},
    {value: "Atlantic/Cape_Verde", label: "(GMT -01:00) Cape Verde Standard Time ( Atlantic/Cape_Verde )"},
    {value: "Africa/Abidjan", label: "(GMT +00:00) Greenwich Mean Time ( Africa/Abidjan )"},
    {value: "Africa/Bissau", label: "(GMT +00:00) Greenwich Mean Time ( Africa/Bissau )"},
    {value: "Africa/Monrovia", label: "(GMT +00:00) Greenwich Mean Time ( Africa/Monrovia )"},
    {value: "Africa/Sao_Tome", label: "(GMT +00:00) West Africa Standard Time ( Africa/Sao_Tome )"},
    {value: "America/Danmarkshavn", label: "(GMT +00:00) Greenwich Mean Time ( America/Danmarkshavn )"},
    {value: "Antarctica/Troll", label: "(GMT +00:00) Greenwich Mean Time ( Antarctica/Troll )"},
    {value: "Atlantic/Canary", label: "(GMT +00:00) Western European Standard Time ( Atlantic/Canary )"},
    {value: "Atlantic/Faroe", label: "(GMT +00:00) Western European Standard Time ( Atlantic/Faroe )"},
    {value: "Atlantic/Madeira", label: "(GMT +00:00) Western European Standard Time ( Atlantic/Madeira )"},
    {value: "Europe/Dublin", label: "(GMT +00:00) Greenwich Mean Time ( Europe/Dublin )"},
    {value: "Europe/Lisbon", label: "(GMT +00:00) Western European Standard Time ( Europe/Lisbon )"},
    {value: "Europe/London", label: "(GMT +00:00) Greenwich Mean Time ( Europe/London )"},
    {value: "GMT", label: "(GMT +00:00) Greenwich Mean Time ( GMT )"},
    {value: "Africa/Algiers", label: "(GMT +01:00) Central European Standard Time ( Africa/Algiers )"},
    {value: "Africa/Casablanca", label: "(GMT +01:00) Western European Summer Time ( Africa/Casablanca )"},
    {value: "Africa/Ceuta", label: "(GMT +01:00) Central European Standard Time ( Africa/Ceuta )"},
    {value: "Africa/El_Aaiun", label: "(GMT +01:00) Western European Summer Time ( Africa/El_Aaiun )"},
    {value: "Africa/Lagos", label: "(GMT +01:00) West Africa Standard Time ( Africa/Lagos )"},
    {value: "Africa/Ndjamena", label: "(GMT +01:00) West Africa Standard Time ( Africa/Ndjamena )"},
    {value: "Africa/Tunis", label: "(GMT +01:00) Central European Standard Time ( Africa/Tunis )"},
    {value: "Europe/Andorra", label: "(GMT +01:00) Central European Standard Time ( Europe/Andorra )"},
    {value: "Europe/Belgrade", label: "(GMT +01:00) Central European Standard Time ( Europe/Belgrade )"},
    {value: "Europe/Berlin", label: "(GMT +01:00) Central European Standard Time ( Europe/Berlin )"},
    {value: "Europe/Brussels", label: "(GMT +01:00) Central European Standard Time ( Europe/Brussels )"},
    {value: "Europe/Budapest", label: "(GMT +01:00) Central European Standard Time ( Europe/Budapest )"},
    {value: "Europe/Gibraltar", label: "(GMT +01:00) Central European Standard Time ( Europe/Gibraltar )"},
    {value: "Europe/Madrid", label: "(GMT +01:00) Central European Standard Time ( Europe/Madrid )"},
    {value: "Europe/Malta", label: "(GMT +01:00) Central European Standard Time ( Europe/Malta )"},
    {value: "Europe/Paris", label: "(GMT +01:00) Central European Standard Time ( Europe/Paris )"},
    {value: "Europe/Prague", label: "(GMT +01:00) Central European Standard Time ( Europe/Prague )"},
    {value: "Europe/Rome", label: "(GMT +01:00) Central European Standard Time ( Europe/Rome )"},
    {value: "Europe/Tirane", label: "(GMT +01:00) Central European Standard Time ( Europe/Tirane )"},
    {value: "Europe/Vienna", label: "(GMT +01:00) Central European Standard Time ( Europe/Vienna )"},
    {value: "Europe/Warsaw", label: "(GMT +01:00) Central European Standard Time ( Europe/Warsaw )"},
    {value: "Europe/Zurich", label: "(GMT +01:00) Central European Standard Time ( Europe/Zurich )"},
    {value: "MET", label: "(GMT +01:00) Middle Europe Time ( MET )"},
    {value: "Africa/Cairo", label: "(GMT +02:00) Eastern European Standard Time ( Africa/Cairo )"},
    {value: "Africa/Johannesburg", label: "(GMT +02:00) South Africa Standard Time ( Africa/Johannesburg )"},
    {value: "Africa/Juba", label: "(GMT +02:00) East Africa Time ( Africa/Juba )"},
    {value: "Africa/Khartoum", label: "(GMT +02:00) Central Africa Time ( Africa/Khartoum )"},
    {value: "Africa/Maputo", label: "(GMT +02:00) Central Africa Time ( Africa/Maputo )"},
    {value: "Africa/Tripoli", label: "(GMT +02:00) Eastern European Standard Time ( Africa/Tripoli )"},
    {value: "Africa/Windhoek", label: "(GMT +02:00) Western African Time ( Africa/Windhoek )"},
    {value: "Asia/Beirut", label: "(GMT +02:00) Eastern European Standard Time ( Asia/Beirut )"},
    {value: "Asia/Famagusta", label: "(GMT +02:00) Eastern European Time ( Asia/Famagusta )"},
    {value: "Asia/Gaza", label: "(GMT +02:00) Eastern European Standard Time ( Asia/Gaza )"},
    {value: "Asia/Hebron", label: "(GMT +02:00) Eastern European Standard Time ( Asia/Hebron )"},
    {value: "Asia/Jerusalem", label: "(GMT +02:00) Israel Standard Time ( Asia/Jerusalem )"},
    {value: "Asia/Nicosia", label: "(GMT +02:00) Eastern European Standard Time ( Asia/Nicosia )"},
    {value: "EET", label: "(GMT +02:00) Eastern European Time ( EET )"},
    {value: "Europe/Athens", label: "(GMT +02:00) Eastern European Standard Time ( Europe/Athens )"},
    {value: "Europe/Bucharest", label: "(GMT +02:00) Eastern European Standard Time ( Europe/Bucharest )"},
    {value: "Europe/Chisinau", label: "(GMT +02:00) Eastern European Standard Time ( Europe/Chisinau )"},
    {value: "Europe/Helsinki", label: "(GMT +02:00) Eastern European Standard Time ( Europe/Helsinki )"},
    {value: "Europe/Kaliningrad", label: "(GMT +02:00) Eastern European Standard Time ( Europe/Kaliningrad )"},
    {value: "Europe/Kyiv", label: "(GMT +02:00) Eastern European Standard Time ( Europe/Kyiv )"},
    {value: "Europe/Riga", label: "(GMT +02:00) Eastern European Standard Time ( Europe/Riga )"},
    {value: "Europe/Sofia", label: "(GMT +02:00) Eastern European Standard Time ( Europe/Sofia )"},
    {value: "Europe/Tallinn", label: "(GMT +02:00) Eastern European Standard Time ( Europe/Tallinn )"},
    {value: "Europe/Vilnius", label: "(GMT +02:00) Eastern European Standard Time ( Europe/Vilnius )"},
    {value: "Africa/Nairobi", label: "(GMT +03:00) East Africa Time ( Africa/Nairobi )"},
    {value: "Asia/Amman", label: "(GMT +03:00) Eastern European Standard Time ( Asia/Amman )"},
    {value: "Asia/Baghdad", label: "(GMT +03:00) Arabian Standard Time ( Asia/Baghdad )"},
    {value: "Asia/Damascus", label: "(GMT +03:00) Eastern European Standard Time ( Asia/Damascus )"},
    {value: "Asia/Qatar", label: "(GMT +03:00) Arabian Standard Time ( Asia/Qatar )"},
    {value: "Asia/Riyadh", label: "(GMT +03:00) Arabian Standard Time ( Asia/Riyadh )"},
    {value: "Europe/Istanbul", label: "(GMT +03:00) Turkey Time ( Europe/Istanbul )"},
    {value: "Europe/Kirov", label: "(GMT +03:00) Moscow Standard Time ( Europe/Kirov )"},
    {value: "Europe/Minsk", label: "(GMT +03:00) Moscow Standard Time ( Europe/Minsk )"},
    {value: "Europe/Moscow", label: "(GMT +03:00) Moscow Standard Time ( Europe/Moscow )"},
    {value: "Europe/Simferopol", label: "(GMT +03:00) Moscow Standard Time ( Europe/Simferopol )"},
    {value: "Europe/Volgograd", label: "(GMT +03:00) Moscow Standard Time ( Europe/Volgograd )"},
    // {value: "EAT", label: "(GMT +03:00) East Africa Time ( EAT )"},
    {value: "Asia/Tehran", label: "(GMT +03:30) Iran Standard Time ( Asia/Tehran )"},
    {value: "Asia/Baku", label: "(GMT +04:00) Azerbaijan Standard Time ( Asia/Baku )"},
    {value: "Asia/Dubai", label: "(GMT +04:00) Gulf Standard Time ( Asia/Dubai )"},
    {value: "Asia/Tbilisi", label: "(GMT +04:00) Georgia Standard Time ( Asia/Tbilisi )"},
    {value: "Asia/Yerevan", label: "(GMT +04:00) Armenia Standard Time ( Asia/Yerevan )"},
    {value: "Europe/Astrakhan", label: "(GMT +04:00) Astrakhan Standard Time ( Europe/Astrakhan )"},
    {value: "Europe/Samara", label: "(GMT +04:00) Samara Standard Time ( Europe/Samara )"},
    {value: "Europe/Saratov", label: "(GMT +04:00) Saratov Standard Time ( Europe/Saratov )"},
    {value: "Europe/Ulyanovsk", label: "(GMT +04:00) Ulyanovsk Standard Time ( Europe/Ulyanovsk )"},
    {value: "Indian/Mauritius", label: "(GMT +04:00) Mauritius Standard Time ( Indian/Mauritius )"},
    {value: "Asia/Kabul", label: "(GMT +04:30) Afghanistan Time ( Asia/Kabul )"},
    {value: "Antarctica/Mawson", label: "(GMT +05:00) Mawson Time ( Antarctica/Mawson )"},
    {value: "Asia/Aqtau", label: "(GMT +05:00) West Kazakhstan Time ( Asia/Aqtau )"},
    {value: "Asia/Aqtobe", label: "(GMT +05:00) West Kazakhstan Time ( Asia/Aqtobe )"},
    {value: "Asia/Ashgabat", label: "(GMT +05:00) Turkmenistan Standard Time ( Asia/Ashgabat )"},
    {value: "Asia/Atyrau", label: "(GMT +05:00) West Kazakhstan Time ( Asia/Atyrau )"},
    {value: "Asia/Dushanbe", label: "(GMT +05:00) Tajikistan Time ( Asia/Dushanbe )"},
    {value: "Asia/Karachi", label: "(GMT +05:00) Pakistan Standard Time ( Asia/Karachi )"},
    {value: "Asia/Oral", label: "(GMT +05:00) West Kazakhstan Time ( Asia/Oral )"},
    {value: "Asia/Qyzylorda", label: "(GMT +05:00) East Kazakhstan Time ( Asia/Qyzylorda )"},
    {value: "Asia/Samarkand", label: "(GMT +05:00) Uzbekistan Standard Time ( Asia/Samarkand )"},
    {value: "Asia/Tashkent", label: "(GMT +05:00) Uzbekistan Standard Time ( Asia/Tashkent )"},
    {value: "Asia/Yekaterinburg", label: "(GMT +05:00) Yekaterinburg Standard Time ( Asia/Yekaterinburg )"},
    {value: "Indian/Maldives", label: "(GMT +05:00) Maldives Time ( Indian/Maldives )"},
    {value: "Asia/Colombo", label: "(GMT +05:30) India Standard Time ( Asia/Colombo )"},
    {value: "Asia/Kolkata", label: "(GMT +05:30) India Standard Time ( Asia/Kolkata )"},
    {value: "Asia/Kathmandu", label: "(GMT +05:45) Nepal Time ( Asia/Kathmandu )"},
    {value: "Asia/Almaty", label: "(GMT +06:00) East Kazakhstan Time ( Asia/Almaty )"},
    {value: "Asia/Bishkek", label: "(GMT +06:00) Kyrgyzstan Time ( Asia/Bishkek )"},
    {value: "Asia/Dhaka", label: "(GMT +06:00) Bangladesh Standard Time ( Asia/Dhaka )"},
    {value: "Asia/Omsk", label: "(GMT +06:00) Omsk Standard Time ( Asia/Omsk )"},
    {value: "Asia/Qostanay", label: "(GMT +06:00) Kostanay Standard Time ( Asia/Qostanay )"},
    {value: "Asia/Thimphu", label: "(GMT +06:00) Bhutan Time ( Asia/Thimphu )"},
    {value: "Asia/Urumqi", label: "(GMT +06:00) Xinjiang Standard Time ( Asia/Urumqi )"},
    {value: "Indian/Chagos", label: "(GMT +06:00) Indian Ocean Time ( Indian/Chagos )"},
    {value: "Asia/Yangon", label: "(GMT +06:30) Myanmar Time ( Asia/Yangon )"},
    {value: "Antarctica/Davis", label: "(GMT +07:00) Davis Time ( Antarctica/Davis )"},
    {value: "Asia/Bangkok", label: "(GMT +07:00) Indochina Time ( Asia/Bangkok )"},
    {value: "Asia/Barnaul", label: "(GMT +07:00) Barnaul Standard Time ( Asia/Barnaul )"},
    {value: "Asia/Ho_Chi_Minh", label: "(GMT +07:00) Indochina Time ( Asia/Ho_Chi_Minh )"},
    {value: "Asia/Hovd", label: "(GMT +07:00) Hovd Standard Time ( Asia/Hovd )"},
    {value: "Asia/Jakarta", label: "(GMT +07:00) Western Indonesia Time ( Asia/Jakarta )"},
    {value: "Asia/Krasnoyarsk", label: "(GMT +07:00) Krasnoyarsk Standard Time ( Asia/Krasnoyarsk )"},
    {value: "Asia/Novokuznetsk", label: "(GMT +07:00) Krasnoyarsk Standard Time ( Asia/Novokuznetsk )"},
    {value: "Asia/Novosibirsk", label: "(GMT +07:00) Novosibirsk Standard Time ( Asia/Novosibirsk )"},
    {value: "Asia/Pontianak", label: "(GMT +07:00) Western Indonesia Time ( Asia/Pontianak )"},
    {value: "Asia/Tomsk", label: "(GMT +07:00) Tomsk Standard Time ( Asia/Tomsk )"},
    {value: "Asia/Choibalsan", label: "(GMT +08:00) Choibalsan Standard Time ( Asia/Choibalsan )"},
    {value: "Asia/Hong_Kong", label: "(GMT +08:00) Hong Kong Standard Time ( Asia/Hong_Kong )"},
    {value: "Asia/Irkutsk", label: "(GMT +08:00) Irkutsk Standard Time ( Asia/Irkutsk )"},
    {value: "Asia/Kuching", label: "(GMT +08:00) Malaysia Time ( Asia/Kuching )"},
    {value: "Asia/Macau", label: "(GMT +08:00) China Standard Time ( Asia/Macau )"},
    {value: "Asia/Makassar", label: "(GMT +08:00) Central Indonesia Time ( Asia/Makassar )"},
    {value: "Asia/Manila", label: "(GMT +08:00) Philippine Standard Time ( Asia/Manila )"},
    {value: "Asia/Shanghai", label: "(GMT +08:00) China Standard Time ( Asia/Shanghai )"},
    {value: "Asia/Singapore", label: "(GMT +08:00) Singapore Standard Time ( Asia/Singapore )"},
    {value: "Asia/Taipei", label: "(GMT +08:00) Taipei Standard Time ( Asia/Taipei )"},
    {value: "Asia/Ulaanbaatar", label: "(GMT +08:00) Ulaanbaatar Standard Time ( Asia/Ulaanbaatar )"},
    {value: "Australia/Perth", label: "(GMT +08:00) Australian Western Standard Time ( Australia/Perth )"},
    {value: "Australia/Eucla", label: "(GMT +08:45) Australian Central Western Standard Time ( Australia/Eucla )"},
    {value: "Asia/Chita", label: "(GMT +09:00) Yakutsk Standard Time ( Asia/Chita )"},
    {value: "Asia/Dili", label: "(GMT +09:00) East Timor Time ( Asia/Dili )"},
    {value: "Asia/Jayapura", label: "(GMT +09:00) Eastern Indonesia Time ( Asia/Jayapura )"},
    {value: "Asia/Khandyga", label: "(GMT +09:00) Yakutsk Standard Time ( Asia/Khandyga )"},
    {value: "Asia/Pyongyang", label: "(GMT +09:00) Pyongyang Time ( Asia/Pyongyang )"},
    {value: "Asia/Seoul", label: "(GMT +09:00) Korean Standard Time ( Asia/Seoul )"},
    {value: "Asia/Tokyo", label: "(GMT +09:00) Japan Standard Time ( Asia/Tokyo )"},
    {value: "Asia/Yakutsk", label: "(GMT +09:00) Yakutsk Standard Time ( Asia/Yakutsk )"},
    {value: "Pacific/Palau", label: "(GMT +09:00) Palau Time ( Pacific/Palau )"},
    {value: "Australia/Darwin", label: "(GMT +09:30) Australian Central Standard Time ( Australia/Darwin )"},
    {value: "Asia/Ust-Nera", label: "(GMT +10:00) Vladivostok Standard Time ( Asia/Ust-Nera )"},
    {value: "Asia/Vladivostok", label: "(GMT +10:00) Vladivostok Standard Time ( Asia/Vladivostok )"},
    {value: "Australia/Brisbane", label: "(GMT +10:00) Australian Eastern Standard Time ( Australia/Brisbane )"},
    {value: "Australia/Lindeman", label: "(GMT +10:00) Australian Eastern Standard Time ( Australia/Lindeman )"},
    {value: "Pacific/Guam", label: "(GMT +10:00) Chamorro Standard Time ( Pacific/Guam )"},
    {value: "Pacific/Port_Moresby", label: "(GMT +10:00) Papua New Guinea Time ( Pacific/Port_Moresby )"},
    {value: "Australia/Adelaide", label: "(GMT +10:30) Australian Central Daylight Time ( Australia/Adelaide )"},
    {value: "Australia/Broken_Hill", label: "(GMT +10:30) Australian Central Daylight Time ( Australia/Broken_Hill )"},
    {value: "Antarctica/Casey", label: "(GMT +11:00) Casey Time ( Antarctica/Casey )"},
    {value: "Antarctica/Macquarie", label: "(GMT +11:00) Australian Eastern Daylight Time (Macquarie) ( Antarctica/Macquarie )"},
    {value: "Asia/Magadan", label: "(GMT +11:00) Magadan Standard Time ( Asia/Magadan )"},
    {value: "Asia/Sakhalin", label: "(GMT +11:00) Sakhalin Standard Time ( Asia/Sakhalin )"},
    {value: "Asia/Srednekolymsk", label: "(GMT +11:00) Srednekolymsk Time ( Asia/Srednekolymsk )"},
    {value: "Australia/Hobart", label: "(GMT +11:00) Australian Eastern Daylight Time ( Australia/Hobart )"},
    {value: "Australia/Lord_Howe", label: "(GMT +11:00) Lord Howe Daylight Time ( Australia/Lord_Howe )"},
    {value: "Australia/Melbourne", label: "(GMT +11:00) Australian Eastern Daylight Time ( Australia/Melbourne )"},
    {value: "Australia/Sydney", label: "(GMT +11:00) Australian Eastern Daylight Time ( Australia/Sydney )"},
    {value: "Pacific/Bougainville", label: "(GMT +11:00) Bougainville Standard Time ( Pacific/Bougainville )"},
    {value: "Pacific/Efate", label: "(GMT +11:00) Vanuatu Standard Time ( Pacific/Efate )"},
    {value: "Pacific/Guadalcanal", label: "(GMT +11:00) Solomon Islands Time ( Pacific/Guadalcanal )"},
    {value: "Pacific/Kosrae", label: "(GMT +11:00) Kosrae Time ( Pacific/Kosrae )"},
    {value: "Pacific/Noumea", label: "(GMT +11:00) New Caledonia Standard Time ( Pacific/Noumea )"},
    {value: "Asia/Anadyr", label: "(GMT +12:00) Anadyr Standard Time ( Asia/Anadyr )"},
    {value: "Asia/Kamchatka", label: "(GMT +12:00) Petropavlovsk-Kamchatski Standard Time ( Asia/Kamchatka )"},
    {value: "Pacific/Fiji", label: "(GMT +12:00) Fiji Standard Time ( Pacific/Fiji )"},
    {value: "Pacific/Kwajalein", label: "(GMT +12:00) Marshall Islands Time ( Pacific/Kwajalein )"},
    {value: "Pacific/Nauru", label: "(GMT +12:00) Nauru Time ( Pacific/Nauru )"},
    {value: "Pacific/Norfolk", label: "(GMT +12:00) Norfolk Summer Time ( Pacific/Norfolk )"},
    {value: "Pacific/Tarawa", label: "(GMT +12:00) Gilbert Islands Time ( Pacific/Tarawa )"},
    {value: "Pacific/Apia", label: "(GMT +13:00) Apia Standard Time ( Pacific/Apia )"},
    {value: "Pacific/Auckland", label: "(GMT +13:00) New Zealand Daylight Time ( Pacific/Auckland )"},
    {value: "Pacific/Fakaofo", label: "(GMT +13:00) Tokelau Time ( Pacific/Fakaofo )"},
    {value: "Pacific/Kanton", label: "(GMT +13:00) Kanton Standard Time ( Pacific/Kanton )"},
    {value: "Pacific/Tongatapu", label: "(GMT +13:00) Tonga Standard Time ( Pacific/Tongatapu )"},
    // {value: "NST", label: "(GMT +13:00) New Zealand Daylight Time ( NST )"},
    {value: "Pacific/Chatham", label: "(GMT +13:45) Chatham Daylight Time ( Pacific/Chatham )"},
    {value: "Pacific/Kiritimati", label: "(GMT +14:00) Line Islands Time ( Pacific/Kiritimati )"}
];

export const MULTILEVEL = new Map([
    [1, 'multilevel_leave'],
    [2, 'multilevel_overTime'],
    [3, 'multilevel_attendance_regularization'],
    [4, 'multilevel_employee_resignation'],
    [5, 'multilevel_compoff'],
    [6, 'multilevel_reimburse_request'],
    [7, 'multilevel_onDuty_request'],
    [8,'multilevel_shift_request'],
    [9,'multilevel_profile_request'],
    [10,'multilevel_encashment'],
    [11,'multilevel_holiday'],
    [14,'multilevel_expense'],
    [15,'multilevel_taxRegime'],
    [16,'multilevel_budget'],
    [17,'multilevel_asset'],
    [19,'multilevel_bonus_deduction'],
]);

export const MLM = {
    'multilevel_leave': 1,
    'multilevel_overTime': 2,
    'multilevel_attendance_regularization': 3,
    'multilevel_employee_resignation': 4,
    'multilevel_compoff': 5,
    'multilevel_reimburse_request': 6,
    'multilevel_onDuty_request': 7,
    'multilevel_shift_request' : 8,
    'multilevel_profile_request' : 9,
    'multilevel_encashment' : 10,
    'multilevel_holiday' : 11,
    'multilevel_expense' : 14,
    'multilevel_taxRegime' : 15,
    'multilevel_budget' : 16,
    'multilevel_asset' : 17,
    'multilevel_bonus_deduction' : 19,
};

export const uacActions = ["create", "update", "remove", "delete", "read", "approve", "reject", "assign","bulkAdd", "bulkUpdate", "comment", "viewAllTask", "revoke", "markAsComplete"]

export const CURRENCY_LOCALE = {
    "AED": { symbol: "د.إ", language: "ar-AE", name: "UAE Dirham" },
    "AFN": { symbol: "؋", language: "fa-AF", name: "Afghan Afghani" },
    "ALL": { symbol: "L", language: "sq-AL", name: "Albanian Lek" },
    "AMD": { symbol: "֏", language: "hy-AM", name: "Armenian Dram" },
    "ANG": { symbol: "ƒ", language: "nl-AN", name: "Netherlands Antillean Guilder" },
    "AOA": { symbol: "Kz", language: "pt-AO", name: "Angolan Kwanza" },
    "ARS": { symbol: "$", language: "es-AR", name: "Argentine Peso" },
    "AUD": { symbol: "$", language: "en-AU", name: "Australian Dollar" },
    "AWG": { symbol: "ƒ", language: "nl-AW", name: "Aruban Florin" },
    "AZN": { symbol: "₼", language: "az-AZ", name: "Azerbaijani Manat" },
    "BAM": { symbol: "KM", language: "bs-BA", name: "Bosnian Convertible Mark" },
    "BBD": { symbol: "$", language: "en-BB", name: "Barbadian Dollar" },
    "BDT": { symbol: "৳", language: "bn-BD", name: "Bangladeshi Taka" },
    "BGN": { symbol: "лв", language: "bg-BG", name: "Bulgarian Lev" },
    "BHD": { symbol: ".د.ب", language: "ar-BH", name: "Bahraini Dinar" },
    "BIF": { symbol: "FBu", language: "fr-BI", name: "Burundian Franc" },
    "BMD": { symbol: "$", language: "en-BM", name: "Bermudian Dollar" },
    "BND": { symbol: "$", language: "ms-BN", name: "Brunei Dollar" },
    "BOB": { symbol: "Bs.", language: "es-BO", name: "Bolivian Boliviano" },
    "BRL": { symbol: "R$", language: "pt-BR", name: "Brazilian Real" },
    "BSD": { symbol: "$", language: "en-BS", name: "Bahamian Dollar" },
    "BTN": { symbol: "Nu.", language: "dz-BT", name: "Bhutanese Ngultrum" },
    "BWP": { symbol: "P", language: "en-BW", name: "Botswanan Pula" },
    "BYN": { symbol: "Br", language: "be-BY", name: "Belarusian Ruble" },
    "BZD": { symbol: "$", language: "en-BZ", name: "Belize Dollar" },
    "CAD": { symbol: "$", language: "en-CA", name: "Canadian Dollar" },
    "CDF": { symbol: "FC", language: "fr-CD", name: "Congolese Franc" },
    "CHF": { symbol: "CHF", language: "de-CH", name: "Swiss Franc" },
    "CLP": { symbol: "$", language: "es-CL", name: "Chilean Peso" },
    "CNY": { symbol: "¥", language: "zh-CN", name: "Chinese Yuan" },
    "COP": { symbol: "$", language: "es-CO", name: "Colombian Peso" },
    "CRC": { symbol: "₡", language: "es-CR", name: "Costa Rican Colón" },
    "CUC": { symbol: "$", language: "es-CU", name: "Cuban Convertible Peso" },
    "CUP": { symbol: "$", language: "es-CU", name: "Cuban Peso" },
    "CVE": { symbol: "$", language: "pt-CV", name: "Cape Verdean Escudo" },
    "CZK": { symbol: "Kč", language: "cs-CZ", name: "Czech Koruna" },
    "DJF": { symbol: "Fdj", language: "fr-DJ", name: "Djiboutian Franc" },
    "DKK": { symbol: "kr", language: "da-DK", name: "Danish Krone" },
    "DOP": { symbol: "$", language: "es-DO", name: "Dominican Peso" },
    "DZD": { symbol: "د.ج", language: "ar-DZ", name: "Algerian Dinar" },
    "EGP": { symbol: "£", language: "ar-EG", name: "Egyptian Pound" },
    "ERN": { symbol: "Nfk", language: "ti-ER", name: "Eritrean Nakfa" },
    "ETB": { symbol: "Br", language: "am-ET", name: "Ethiopian Birr" },
    "EUR": { symbol: "€", language: "de-DE", name: "Euro" },
    "FJD": { symbol: "$", language: "en-FJ", name: "Fijian Dollar" },
    "FKP": { symbol: "£", language: "en-FK", name: "Falkland Islands Pound" },
    "FOK": { symbol: "kr", language: "fo-FO", name: "Faroese Króna" },
    "GBP": { symbol: "£", language: "en-GB", name: "British Pound" },
    "GEL": { symbol: "₾", language: "ka-GE", name: "Georgian Lari" },
    "GGP": { symbol: "£", language: "en-GG", name: "Guernsey Pound" },
    "GHS": { symbol: "₵", language: "en-GH", name: "Ghanaian Cedi" },
    "GIP": { symbol: "£", language: "en-GI", name: "Gibraltar Pound" },
    "GMD": { symbol: "D", language: "en-GM", name: "Gambian Dalasi" },
    "GNF": { symbol: "FG", language: "fr-GN", name: "Guinean Franc" },
    "GTQ": { symbol: "Q", language: "es-GT", name: "Guatemalan Quetzal" },
    "GYD": { symbol: "$", language: "en-GY", name: "Guyanaese Dollar" },
    "HKD": { symbol: "$", language: "en-HK", name: "Hong Kong Dollar" },
    "HNL": { symbol: "L", language: "es-HN", name: "Honduran Lempira" },
    "HRK": { symbol: "kn", language: "hr-HR", name: "Croatian Kuna" },
    "HTG": { symbol: "G", language: "fr-HT", name: "Haitian Gourde" },
    "HUF": { symbol: "Ft", language: "hu-HU", name: "Hungarian Forint" },
    "IDR": { symbol: "Rp", language: "id-ID", name: "Indonesian Rupiah" },
    "ILS": { symbol: "₪", language: "he-IL", name: "Israeli Shekel" },
    "IMP": { symbol: "£", language: "en-IM", name: "Isle of Man Pound" },
    "INR": { symbol: "₹", language: "hi-IN", name: "Indian Rupee" },
    "IQD": { symbol: "ع.د", language: "ar-IQ", name: "Iraqi Dinar" },
    "IRR": { symbol: "﷼", language: "fa-IR", name: "Iranian Rial" },
    "ISK": { symbol: "kr", language: "is-IS", name: "Icelandic Króna" },
    "JEP": { symbol: "£", language: "en-JE", name: "Jersey Pound" },
    "JMD": { symbol: "$", language: "en-JM", name: "Jamaican Dollar" },
    "JOD": { symbol: "د.ا", language: "ar-JO", name: "Jordanian Dinar" },
    "JPY": { symbol: "¥", language: "ja-JP", name: "Japanese Yen" },
    "KES": { symbol: "Sh", language: "en-KE", name: "Kenyan Shilling" },
    "KGS": { symbol: "лв", language: "ky-KG", name: "Kyrgystani Som" },
    "KHR": { symbol: "៛", language: "km-KH", name: "Cambodian Riel" },
    "KID": { symbol: "$", language: "en-KI", name: "Kiribati Dollar" },
    "KMF": { symbol: "CF", language: "fr-KM", name: "Comorian Franc" },
    "KRW": { symbol: "₩", language: "ko-KR", name: "South Korean Won" },
    "KPW": { symbol: "₩", language: "ko-KP", name: "North Korean Won" },
    "KWD": { symbol: "د.ك", language: "ar-KW", name: "Kuwaiti Dinar" },
    "KYD": { symbol: "$", language: "en-KY", name: "Cayman Islands Dollar" },
    "KZT": { symbol: "〒", language: "kk-KZ", name: "Kazakhstani Tenge" },
    "LAK": { symbol: "₭", language: "lo-LA", name: "Laotian Kip" },
    "LBP": { symbol: "ل.ل", language: "ar-LB", name: "Lebanese Pound" },
    "LKR": { symbol: "Rs", language: "si-LK", name: "Sri Lankan Rupee" },
    "LRD": { symbol: "$", language: "en-LR", name: "Liberian Dollar" },
    "LSL": { symbol: "L", language: "en-LS", name: "Lesotho Loti" },
    "LYD": { symbol: "د.ل", language: "ar-LY", name: "Libyan Dinar" },
    "MAD": { symbol: "د.م.", language: "ar-MA", name: "Moroccan Dirham" },
    "MDL": { symbol: "lei", language: "ro-MD", name: "Moldovan Leu" },
    "MGA": { symbol: "Ar", language: "mg-MG", name: "Malagasy Ariary" },
    "MKD": { symbol: "ден", language: "mk-MK", name: "Macedonian Denar" },
    "MMK": { symbol: "Ks", language: "my-MM", name: "Burmese Kyat" },
    "MNT": { symbol: "₮", language: "mn-MN", name: "Mongolian Tugrik" },
    "MOP": { symbol: "MOP$", language: "zh-MO", name: "Macanese Pataca" },
    "MRO": { symbol: "UM", language: "ar-MR", name: "Mauritanian Ouguiya" },
    "MRU": { symbol: "UM", language: "ar-MR", name: "Mauritanian Ouguiya" },
    "MUR": { symbol: "₨", language: "en-MU", name: "Mauritian Rupee" },
    "MVR": { symbol: "Rf", language: "dv-MV", name: "Maldivian Rufiyaa" },
    "MWK": { symbol: "MK", language: "ny-MW", name: "Malawian Kwacha" },
    "MXN": { symbol: "$", language: "es-MX", name: "Mexican Peso" },
    "MYR": { symbol: "RM", language: "ms-MY", name: "Malaysian Ringgit" },
    "MZN": { symbol: "MT", language: "pt-MZ", name: "Mozambican Metical" },
    "NAD": { symbol: "$", language: "en-NA", name: "Namibian Dollar" },
    "NGN": { symbol: "₦", language: "en-NG", name: "Nigerian Naira" },
    "NIO": { symbol: "C$", language: "es-NI", name: "Nicaraguan Córdoba" },
    "NOK": { symbol: "kr", language: "no-NO", name: "Norwegian Krone" },
    "NPR": { symbol: "Rs", language: "ne-NP", name: "Nepalese Rupee" },
    "NZD": { symbol: "$", language: "en-NZ", name: "New Zealand Dollar" },
    "OMR": { symbol: "ر.ع.", language: "ar-OM", name: "Omani Rial" },
    "PAB": { symbol: "B/.", language: "es-PA", name: "Panamanian Balboa" },
    "PEN": { symbol: "S/", language: "es-PE", name: "Peruvian Nuevo Sol" },
    "PGK": { symbol: "K", language: "en-PG", name: "Papua New Guinean Kina" },
    "PHP": { symbol: "₱", language: "fil-PH", name: "Philippine Peso" },
    "PKR": { symbol: "Rs", language: "ur-PK", name: "Pakistani Rupee" },
    "PLN": { symbol: "zł", language: "pl-PL", name: "Polish Zloty" },
    "PYG": { symbol: "₲", language: "es-PY", name: "Paraguayan Guarani" },
    "QAR": { symbol: "ر.ق", language: "ar-QA", name: "Qatari Rial" },
    "RON": { symbol: "lei", language: "ro-RO", name: "Romanian Leu" },
    "RSD": { symbol: "дин", language: "sr-RS", name: "Serbian Dinar" },
    "RUB": { symbol: "₽", language: "ru-RU", name: "Russian Ruble" },
    "RWF": { symbol: "FRw", language: "rw-RW", name: "Rwandan Franc" },
    "SAR": { symbol: "ر.س", language: "ar-SA", name: "Saudi Riyal" },
    "SBD": { symbol: "$", language: "en-SB", name: "Solomon Islands Dollar" },
    "SCR": { symbol: "₨", language: "fr-SC", name: "Seychellois Rupee" },
    "SDG": { symbol: "ج.س.", language: "ar-SD", name: "Sudanese Pound" },
    "SEK": { symbol: "kr", language: "sv-SE", name: "Swedish Krona" },
    "SGD": { symbol: "$", language: "en-SG", name: "Singapore Dollar" },
    "SHP": { symbol: "£", language: "en-SH", name: "Saint Helena Pound" },
    "SLL": { symbol: "Le", language: "en-SL", name: "Sierra Leonean Leone" },
    "SOS": { symbol: "Sh", language: "so-SO", name: "Somali Shilling" },
    "SRD": { symbol: "$", language: "nl-SR", name: "Surinamese Dollar" },
    "SSP": { symbol: "£", language: "en-SS", name: "South Sudanese Pound" },
    "STN": { symbol: "Db", language: "pt-ST", name: "São Tomé and Príncipe Dobra" },
    "STD": { symbol: "Db", language: "pt-ST", name: "São Tomé and Príncipe Dobra" },
    "SYP": { symbol: "ل.س", language: "ar-SY", name: "Syrian Pound" },
    "SZL": { symbol: "E", language: "en-SZ", name: "Swazi Lilangeni" },
    "THB": { symbol: "฿", language: "th-TH", name: "Thai Baht" },
    "TJS": { symbol: "SM", language: "tg-TJ", name: "Tajikistani Somoni" },
    "TMT": { symbol: "T", language: "tk-TM", name: "Turkmenistani Manat" },
    "TND": { symbol: "د.ت", language: "ar-TN", name: "Tunisian Dinar" },
    "TOP": { symbol: "T$", language: "en-TO", name: "Tongan Paʻanga" },
    "TRY": { symbol: "₺", language: "tr-TR", name: "Turkish Lira" },
    "TTD": { symbol: "$", language: "en-TT", name: "Trinidad and Tobago Dollar" },
    "TVD": { symbol: "$", language: "en-TV", name: "Tuvaluan Dollar" },
    "TWD": { symbol: "NT$", language: "zh-TW", name: "New Taiwan Dollar" },
    "TZS": { symbol: "TSh", language: "sw-TZ", name: "Tanzanian Shilling" },
    "UAH": { symbol: "₴", language: "uk-UA", name: "Ukrainian Hryvnia" },
    "UGX": { symbol: "USh", language: "en-UG", name: "Ugandan Shilling" },
    "USD": { symbol: "$", language: "en-US", name: "United States Dollar" },
    "UYU": { symbol: "$", language: "es-UY", name: "Uruguayan Peso" },
    "UZS": { symbol: "лв", language: "uz-UZ", name: "Uzbekistani Som" },
    "VES": { symbol: "Bs.S.", language: "es-VE", name: "Venezuelan Sovereign Bolívar" },
    "VND": { symbol: "₫", language: "vi-VN", name: "Vietnamese Dong" },
    "VUV": { symbol: "VT", language: "bi-VU", name: "Vanuatu Vatu" },
    "WST": { symbol: "T", language: "sm-WS", name: "Samoan Tala" },
    "XAF": { symbol: "FCFA", language: "fr-CM", name: "CFA Franc BEAC" },
    "XAG": { symbol: "XAG", language: "", name: "Silver Ounce" },
    "XAU": { symbol: "XAU", language: "", name: "Gold Ounce" },
    "XCD": { symbol: "$", language: "en-CB", name: "East Caribbean Dollar" },
    "XDR": { symbol: "XDR", language: "", name: "Special Drawing Rights" },
    "XOF": { symbol: "CFA", language: "fr-BJ", name: "CFA Franc BCEAO" },
    "XPF": { symbol: "CFPF", language: "fr-PF", name: "CFP Franc" },
    "YER": { symbol: "ر.ي", language: "ar-YE", name: "Yemeni Rial" },
    "ZAR": { symbol: "R", language: "en-ZA", name: "South African Rand" },
    "ZMW": { symbol: "ZK", language: "en-ZM", name: "Zambian Kwacha" },
    "ZWL": { symbol: "$", language: "en-ZW", name: "Zimbabwean Dollar" }
}

export const EMAIL_TEMPLATE = {
    PLACEHOLDER: [
        {
            "key": "userDetails.employeeId",
            "title": "Employee Id"
        },
        {
            "key": "usersInfo.firstName",
            "title": "First Name"
        },
        {
            "key": "usersInfo.middleName",
            "title": "Middle Name"
        },
        {
            "key": "usersInfo.lastName",
            "title": "Last Name"
        },
        {
            "key": "jobInfo.jobTitle",
            "title": "Job Title"
        },
        {
            "key": "jobInfo.department",
            "title": "Department"
        },
        {
            "key": "jobInfo.location",
            "title": "Job Location"
        },
        {
            "key": "compInfo.company",
            "title": "Company Name"
        },
        {
            "key": "compInfo.address1",
            "title": "Company Address"
        },
        {
            "key": "compInfo.city",
            "title": "City"
        },
        {
            "key": "compInfo.state",
            "title": "State"
        },
        {
            "key": "compInfo.country",
            "title": "Country"
        },
        {
            "key": "compInfo.zip",
            "title": "Pin Code"
        },
        {
            "key": "compInfo.primaryPhone",
            "title": "Company Phone Number"
        },
        {
            "key": "compInfo.email",
            "title": "Company Email Address"
        },
        {
            "key": "compInfo.owner",
            "title": "Owner Full Name"
        },
        {
            "key" : "letterName",
            "replaceKey" : "_.documentName",
            "title" : "Letter Name",
        },
        {
            "replaceKey" : "_.senderName",
            "key" : "senderNames",
            "title" : "Sender Name",
        },
        {
            "replaceKey" : "_.senderDepartment",
            "key": "senderDepartment",
            "title" : "Sender Department",
        },
        {
            "replaceKey" : "_.senderDesignation",
            "key": "senderDesignation",
            "title" : "Sender Designation",
        },
        {
            "replaceKey" : "_.senderLocation",
            "key" : "senderLocation",
            "title" : "Sender Location",
        },
    ]
}

export const TRAVEL_EXPENSE = {
    DURATION: [
        {value: 1, label: 'Daily'},
        {value: 2, label: 'Weekly'},
        {value: 3, label: 'Monthly'},
    ],
    VEHICLE_TYPE: [
        {value: 1, label: 'Bike'},
        {value: 2, label: 'Car'},
        {value: 3, label: 'Other'},
    ],
    RESTRICTION_TYPE: [
        {value: 1, label: 'Kilometer'},
        {value: 2, label: 'Amount'},
    ],
}

export const ASSETS_ACTION_TYPE = {
    1: 'ASSIGN',
    2: 'RECOVER',
    3: 'UNAVAILABLE',
    4: 'AVAILABLE',
    5: 'CONDITION',
    ASSIGN: 1,
    RECOVER: 2,
    UNAVAILABLE: 3,
    AVAILABLE: 4,
    CONDITION: 5,
}

export const COMMAND_LIST = [
    {label: "ADD USER" , value:  1, isActive:  true, note: 'Use this command to add a new user to the ESSL device.'},
    {label: "UPDATE USER" , value:  2, isActive: true, note: 'This command allows you to update the name of an existing user on the ESSL device.'},
    {label: "ALL USER ATTENDANCE" , value:  3, isActive: true, note: 'With this command, you can retrieve attendance data for all users over the past 31 days.'},
    {label: "CHECK" , value:  4, isActive: false},
    {label: "FETCH USER" , value:  5, isActive: false},
    {label: "UPLOAD USER" , value:  6, isActive: false},
    {label: "CLEAR LOG" , value:  7, isActive: false},
    {label: "CLEAR DATA" , value:  8, isActive: false},
    {label: "DELETE USER" , value:  9, isActive: true, note: 'Utilize this command to remove an existing user from the ESSL device.'},
    {label: "UPLOAD FINGER PRINT" , value:  10, isActive: false},
    {label: "ALL USER ATTENDANCE" , value:  11, isActive: false, note: ''},
    {label: "REBOOT DEVICE" , value:  12, isActive: true, note: 'This command restarts the ESSL device.'},
    {label: "RESET DEVICE SETTINGS" , value:  13, isActive: true, note: 'Use this command to reset all settings on the ESSL device to their default values.'},
    {label: "SINGLE USER ATTENDANCE" , value:  14, isActive: true, note: 'This command provides attendance data for a specific user over the past 31 days.'},

]

export const PAYROLL_TYPE = [
    {label: "Regular Payroll", value: 1},
    {label: "Import Payroll", value: 2},
]
export const CUSTOM_FIELD = {
	/**
	 * SUPER CLOUD LINK: https://cloud.superworks.net/oo/r/12KY6vCohaH9vsi3OsZ3nkNGM5YnH0Ny
	 * Constant bind with backend manage with routing : START */
    SECTION : {
        personalInfo: 1,
        jobInfo: 2,
        documents: 3,
        [ROUTES.empConfigPersonal] : 1,
        [ROUTES.empConfigJob] : 2,
        [ROUTES.empConfigDocuments] : 3,
    },
    SUB_SECTION : {
        // PersonalInfo
        BASIC_INFO : 1,
        FAMILY_INFO : 2,
        CONTACT_SOCIAL : 3,
        BANK_INFO : 4,
        ADDRESS : 5,
        EDUCATION : 6,
        PREVIOUS_EMPLOYER : 7,
	    [ROUTES.empConfigBasicInfo] : 1,
	    [ROUTES.empConfigFamilyInfo] : 2,
	    [ROUTES.empConfigContactSocial] : 3,
	    [ROUTES.empConfigBankInfo] : 4,
	    [ROUTES.empConfigAddress] : 5,
	    [ROUTES.empConfigEducation] : 6,
	    [ROUTES.empConfigPreviousEmployer] : 7,
        "11" : [ROUTES.empConfigBasicInfo], // section 1, subsection 1  join section sub section for key match
        "12" : [ROUTES.empConfigFamilyInfo],
        "13" : [ROUTES.empConfigContactSocial],
        "14" : [ROUTES.empConfigBankInfo],
        "15" : [ROUTES.empConfigAddress],
        "16" : [ROUTES.empConfigEducation],
        "17" : [ROUTES.empConfigPreviousEmployer],

        //jobInfo
        JOB_INFORMATION : 1,
        AGREEMENT : 2,
        COMPENSATION : 3,
        EMPLOYEE_RESIGNATION : 4,
        INTERNSHIP_PROBATION : 5,
        ORG_STRUCTURE : 6,
	    [ROUTES.empConfigJobInformation] : 1,
	    [ROUTES.empConfigAgreement] : 2,
	    [ROUTES.empConfigCompensation] : 3,
	    [ROUTES.empConfigEmployeeResignation] : 4,
	    [ROUTES.empConfigInternshipProbation] : 5,
	    [ROUTES.empConfigOrgStructure] : 6,
        "21" : [ROUTES.empConfigJobInformation], // section 2, subsection 1
        "22" : [ROUTES.empConfigAgreement],  // section 2, subsection 2
        "23" : [ROUTES.empConfigCompensation],
        "24" : [ROUTES.empConfigEmployeeResignation],
        "25" : [ROUTES.empConfigInternshipProbation],
        "26" : [ROUTES.empConfigOrgStructure],
        // documents
        DOCUMENTS_OTHER: 1,
        [ROUTES.empConfigDocumentsOther]: 1,
    },
    CHILD_SECTION : {
        // family-info
        FAMILY_DETAIL : 1,
        FAMILY_NOMINEE : 2,
        FAMILY_DEPENDENT : 3,
	    [ROUTES.empConfigFamilyDetail] : 1,
	    [ROUTES.empConfigFamilyNominee] : 2,
	    [ROUTES.empConfigFamilyDependent] : 3,
        ///'contact-social'
        CONTACT : 1,
        SOCIAL : 2,
	    [ROUTES.empConfigContact] : 1,
	    [ROUTES.empConfigSocial] : 2,
	    // address
        CURRENT_ADDRESS : 1,
        PERMANENT_ADDRESS : 2,
	    [ROUTES.empConfigCurrentAddress] : 1,
	    [ROUTES.empConfigPermanentAddress] : 2,
	    //empConfigPreviousEmployer
        PREVIOUS_EMPLOYER_EXPERIENCE : 1,
        PREVIOUS_EMPLOYER_FRESHER : 2,
	    [ROUTES.empConfigPreviousEmployerExperience] : 1,
	    [ROUTES.empConfigPreviousEmployerFresher] : 2,
    },

	/** Constant bind with backend manage with routing : END */

	/**
     * Options Type
     * */
    OPTIONS_TYPE: {
        MASTER: 1,
        CUSTOM: 2
    },
    /**
    * Master Settings
     * */
    MASTER_SETTING: {
         1 : {url: `settings/location-type/location`},
         2 : {url: `settings/location-type/sub-location`},
         3 : {url: `settings/employee-fields/job-title`},
         4 : {url: `settings/employee-fields/department`},
         5 : {url: `settings/employee-fields/sub-department`},
         6 : {url: `settings/employee-fields/category`},
         7 : {url: `settings/employee-fields/status`},
        //  8 : {url: ``}, // not used
         9 : {url: `settings/employee-fields/documents`},
         10 : {url: `settings/employee-fields/degree`},
         11 : {url: `settings/employee-fields/relationship`},
         12 : {url: `settings/employee-fields/letter-type`},
         13 : {url: `settings/sub-company`},
         14 : {url: `settings/employee-exit/reasons`},
         15 : {url: `settings/org-structure/business-unit`},
         16 : {url: `settings/org-structure/cost-center`},
         17 : {url: `settings/org-structure/grade`},
         18 : {url: `settings/org-structure/bands`},
         19 : {url: `settings/org-structure/segment`},
         20 : {url: `settings/org-structure/hub`},
         21 : {url: `settings/org-structure/territory`},
         22 : {url: `settings/org-structure/region`},
         23 : {url: `settings/org-structure/work-area`},
    },

    VALIDATION_TYPES : {
        MIN_LENGTH: 1,
        MAX_LENGTH: 2,
        REGEX_PATTERN: 3,
        ALLOWED_CHARS: 4,
        DISALLOWED_CHARS: 5,
        MUST_CONTAIN: 6,
        CANNOT_CONTAIN: 7,
        CASE_SENSITIVE: 8,
        MIN_VALUE: 9,
        MAX_VALUE: 10,
        MUST_BE_INTEGER: 11,
        MUST_BE_POSITIVE: 12,
        MUST_BE_NEGATIVE: 13,
        MULTIPLE_OF: 14,
        MUST_BE_VALID_EMAIL: 15,
        MIN_DATE: 16,
        MAX_DATE: 17,
        MUST_BE_FUTURE: 18,
        MUST_BE_PAST: 19,
        OPTIONS: 20,
        MUST_SELECT_ONE: 21,
        MIN_SELECTIONS: 22,
        MAX_SELECTIONS: 23,
        FILE_TYPES: 24,
        MAX_SIZE: 25,
        MIN_SIZE: 26,
        ALLOWED_EXTENSIONS: 27
    }
}

export const PROFILE_SECTION = {
    basicInfo: 'basicInfo',
    familyInfo: 'familyInfo',
    nomineeInfo: 'nomineeInfo',
    dependentInfo: 'dependentInfo',
    contactInfo: 'contactInfo',
    social: 'social',
    bankInfo: 'bankInfo',
    currentAddress: 'currentAddress',
    permanentAddress: 'permanentAddress',
    education: 'education',
    previousEmployee: 'previousEmployee',
    workExperience: 'workExperience',
    jobInfo: 'jobInfo',
    agreementInfo: 'agreementInfo',
    compensationInfo: 'compensationInfo',
    employeeResignation: 'employeeResignation',
    internProbInfo: 'intenProbInfo',
    orgStructureInfo: 'orgStructureInfo',
    personalIdentifications: 'personalIdentifications',
}

export const CUSTOM_FIELD_TYPE = {
    TEXT: 1,
    TEXT_AREA: 2,
    EMAIL: 3,
    NUMBER: 4,
    DATE: 5,
    SELECT: 6,
    RADIO: 7,
    CHECKBOX: 8,
    FILE: 9,
    TOGGLE: 10,
    NUMBER_WITH_FILE: 11,
    TEXT_WITH_FILE: 12,
    MULTI_SELECT: 13,
    CONTACT:  14,

    1: "TEXT",
    2: "TEXT_AREA",
    3: "EMAIL",
    4: "NUMBER",
    5: "DATE",
    6: "SELECT",
    7: "RADIO",
    8: "CHECKBOX",
    9: "FILE",
	10: "TOGGLE",
	11: "NUMBER_WITH_FILE",
	12: "TEXT_WITH_FILE",
	13: "MULTI_SELECT",
	14: "CONTACT",

    ARRAY_LIST: [
        {
            value: 1,
            label: 'Single Line Text',
            icon: <Icon.HTMLEditor fill={COLOR.u_icon_bg} size={14} className="" />
        },
        {
            value: 2,
            label: 'Multi Line Text',
            icon: <Icon.Multiline fill={COLOR.u_icon_bg} size={14} className="" />
        },
        {
            value: 3,
            label: 'Email',
            icon: <Icon.Mail fill={COLOR.u_icon_bg} size={14} className="" />
        },
        {
            value: 4,
            label: 'Number',
            icon: <Icon.NumberList fill={COLOR.u_icon_bg} size={14} className="" />
        },
        {
            value: 5,
            label: 'Date',
            icon: <Icon.Calendar fill={COLOR.u_icon_bg} size={14} className="" />
        },
        {
            value: 6,
            label: 'Dropdown',
            icon: <Icon.ListData fill={COLOR.u_icon_bg} size={14} className="" />
        },
        // {
        //     value: 7,
        //     label: 'Yes/No',
        //     icon: <Icon.YesNo fill={COLOR.u_icon_bg} size={14} className="" />
        // },
        // {
        //     value: 8,
        //     label: 'Single Choice',
        //     icon: <Icon.CheckMark fill={COLOR.u_icon_bg} size={14} className="" />
        // },
        // {
        //     value: 9,
        //     label: 'Attachment',
        //     icon: <Icon.Attachment fill={COLOR.u_icon_bg} size={14} className="" />
        // },
        {
            value: 10,
            label: 'Toggle',
            icon: <Icon.YesNo fill={COLOR.u_icon_bg} size={14} className="" />
        },
        // {
        //     value: 11,
        //     label: 'Number with Attachment',
        //     icon: <Icon.Attachment fill={COLOR.u_icon_bg} size={14} className="" />
        // },
        // {
        //     value: 12,
        //     label: 'Text with Attachment',
        //     icon: <Icon.Attachment fill={COLOR.u_icon_bg} size={14} className="" />
        // },
        // {
        //     value: 13,
        //     label: 'Multi Select',
        //     icon: <Icon.MultiSelect fill={COLOR.u_icon_bg} size={14} className="" />
        // },
        {
            value: 14,
            label: 'Contact',
            icon: <Icon.Contact fill={COLOR.u_icon_bg} size={14} className="" />
        },

    ],

};

export const D_FIELDS = {
    /*========================> Section 1 start - Personal <================================== */
    //------------- Sub section 1- basic info ----------------------
    companyId_basic: "companyId_4987b3",
    legalEntityCompanyId_basic: "legalEntityCompanyId_1d2ae8",
    employeeId_basic: "employeeId_d600be",
    uniqueId_basic: "uniqueId_22ae14",
    firstName_basic: "firstName_ef6d24",
    middleName_basic: "middleName_85f962",
    lastName_basic: "lastName_16a1f6",
    dob_basic: "dob_e065c5",
    joiningDate_basic: "joiningDate_b0260f",
    previousJoiningDate_basic: "previousJoiningDate_fy77bd",
    gender_basic: "gender_c395f5",
    maritalStatus_basic: "maritalStatus_8a30c8",
    bloodGroup_basic: "bloodGroup_91e9d9",
    ledgerCode_basic: "ledgerCode_feb98a",
    isPhysicalHandicap_basic: "isPhysicalHandicap_c183bf",
    displayName_basic: "displayName_8d8fcd",
    bornPlace_basic: "bornPlace_fc769d",
    nationality_basic: "nationality_fe0450",

    // //------------- Sub section 2-  childsubsection - 1 Family info ----------------------
    // familyRole_family: "familyRole_2dc084",
    // name_family: "name_4e13a5",
    // gender_family: "gender_05ae86",
    // dob_family: "dob_3b59b9",
    // occupation_family: "occupation_23bba4",
    // mobileNumber_family: "mobileNumber_cd69c5",
    // aadharNumber_family: "aadharNumber_2cf1ff",

    // //------------- Sub section 2-  childsubsection - 2- Nominee info ----------------------
    // nomineeName_nominee: "nomineeName_24fa44",
    // familyRole_nominee: "familyRole_623442",
    // nomineeFor_nominee: "nomineeFor_a029fa",
    // percentageShare_nominee: "percentageShare_4d22a5",
    // isMinor_nominee: "isMinor_f0ab01",
    // note_nominee: "note_8606ec",

    // //------------- Sub section 2-  childsubsection - 3- Dependent info ----------------------
    // dependentName_dependent: "dependentName_0e93c0",
    // familyRole_dependent: "familyRole_b6b3bd",

    // //------------- Sub section 3-   childsubsection - 1 Contacts-----------------------
    // email_contact: "email_cd8a28",
    // alternativeEmail_contact: "alternativeEmail_7cc716",
    // employeeCode_contact: "employeeCode_ad5cd1",
    // phoneNumber_contact: "phoneNumber_d75060",
    // homePhone_contact: "homePhone_26ca0f",
    // password_contact: "password_f8f3e4",
    // aftrp_contact: "aftrp_a508bc",

    // //------------- Sub section 3-   childsubsection - 2 Socials-----------------------
    // linkedIn_social: "linkedIn_4375a7",
    // twitter_social: "twitter_005a11",
    // skype_social: "skype_b088da",
    // instagram_social: "instagram_3d0f47",

    // //------------- Sub section 4- bank info ----------------------
    // countryType_bank: "countryType_cbec2b",
    // accHolderName_bank: "accHolderName_dac717",
    // bankId_bank: "bankId_5259cc",
    // branch_bank: "branch_922077",
    // accountNo_bank: "accountNo_394ca5",
    // iban_bank: "iban_b6af64",
    // ifsc_bank: "ifsc_7536bc",
    // swiftCode_bank: "swiftCode_104862",
    // attachments_bank: "attachments_e95ea5",
    // accountType_bank: "accountType_e97f12",

    // //------------- Sub section 5- Address  childSubsection: -1 current address ----------------------
    // address1_addressInfo: "address1_67fe7f",
    // address2_addressInfo: "address2_9972d1",
    // city_addressInfo: "city_9d4a2a",
    // country_addressInfo: "country_f644fc",
    // province_addressInfo: "province_357158",
    // zip_addressInfo: "zip_177fd9",

    // //------------- Sub section 5- Address  childSubsection: -2 permanent address ----------------------
    // permanentAddress1: "permanentAddress1_91f34c",
    // permanentAddress2: "permanentAddress2_81e87b",
    // permanentCity: "permanentCity_0e457e",
    // permanentCountry: "permanentCountry_2dee80",
    // permanentProvince: "permanentProvince_4e2945",
    // permanentZip: "permanentZip_c41afc",

    // //------------- Sub section 6- Education  ----------------------

    // //------------- Sub section 6- Education  ----------------------
    // degreeType_education: "degreeType_dde6d9",
    // university_education: "university_08fa28",
    // specialization_education: "specialization_d45754",
    // start_education: "start_e83ce5",
    // end_education: "end_e11d57",

    // //------------- Sub section 7- Previous Employer  ----------------------
    // workExperience_employer: "workExperience_62004c",
    // totalExperienceMM_employer: "totalExperienceMM_5e9907",
    // totalExperienceYY_employer: "totalExperienceYY_a4d034",
    // companyName_employer: "companyName_06a293",
    // department_employer: "department_856cba",
    // jobTitle_employer: "jobTitle_4b01bb",
    // start_employer: "start_26208c",
    // end_employer: "end_0d497e",

    /*===================================> Section 1 End - Personal <============================================ */


    // /*===================================> Section 2 Start - Job <============================================ */
    // //------------- Sub section 1- Job Info  ----------------------
    // joiningDate_b0260f: "joiningDate_b0260f",
    // location_c69114: "location_c69114",
    // jobTitle_b64839: "jobTitle_b64839",
    // department_ea077e: "department_ea077e",
    // employeeStatus_a12609: "employeeStatus_a12609",
    // subLocation_862370: "subLocation_862370",
    // category_dbe92f: "category_dbe92f",
    // subDepartment_baa778: "subDepartment_baa778",
    // reportTo_6366a0: "reportTo_6366a0",
    // lineManager_0042f4: "lineManager_0042f4",
    // comments_7fca27: "comments_7fca27",


    // //------------- Sub section 2- Agreement  ----------------------
    // start_a26568: "start_a26568",
    // end_29d3fd: "end_29d3fd",
    // period_51485e: "period_51485e",
    // notifyPeriod_503d6f: "notifyPeriod_503d6f",
    // comments_949a87: "comments_949a87",


    // //------------- Sub section 3- Compensation  ----------------------
    // start_2bd053: "start_2bd053",
    // end_cda740: "end_cda740",
    // period_b5a4d6: "period_b5a4d6",
    // newSalary_dee7c9: "newSalary_dee7c9",
    // frequency_fb47ea: "frequency_fb47ea",
    // noticePeriod_109b51: "noticePeriod_109b51",
    // notifyPeriod_8a1d73: "notifyPeriod_8a1d73",
    // salaryMode_130a43: "salaryMode_130a43",
    // description_6fa310: "description_6fa310",
    // compensationNewSalaryIsLeaveBonusBenefit_7cbbb6: "compensationNewSalaryIsLeaveBonusBenefit_7cbbb6",
    // compensationApplyBonus_4455ed: "compensationApplyBonus_4455ed",


    // //------------- Sub section 4- Employee Resignation   ----------------------
    // type_ee8d84: "type_ee8d84",
    // reason_0125b2: "reason_0125b2",
    // start_5e5083: "start_5e5083",
    // end_0ba015: "end_0ba015",
    // note_4ae92e: "note_4ae92e",
    // rehire_5c1e96: "rehire_5c1e96",


    // //------------- Sub section 5- Internship/probation ----------------------
    // start_e1a203: "start_e1a203",
    // end_a453d0: "end_a453d0",
    // length_68d91b: "length_68d91b",
    // // { section: 2, subSection: 5, type: 6, name: "Employment Status", fieldName: "Employment Status", isActive: true, isRequired: false, isAddEmpForm: false, sortOrder:4},
    // // { section: 2, subSection: 5, type: 6, name: "Reduce/Extended", fieldName: "Reduce/Extended", isActive: true, isRequired: false, isAddEmpForm: false, sortOrder:5},
    // //

    // //------------- Sub section 6- Org Structure ----------------------
    // businessUnit_caa8aa: "businessUnit_caa8aa",
    // costCenter_c8b6af: "costCenter_c8b6af",
    // grade_7c65fc: "grade_7c65fc",
    // bands_634c80: "bands_634c80",
    // segment_1b01a1: "segment_1b01a1",
    // hub_c05020: "hub_c05020",
    // territory_ca2b9d: "territory_ca2b9d",
    // region_10c7f8: "region_10c7f8",
    // workArea_895762: "workArea_895762",

    // /*===================================> Section 2 End - Job <=============================================*/


    // /*===================================> Section 3 Start - Documents <============================================ */
    // //------------- Sub section 1- Personal Identifications ----------------------
    // aadharNumber_04114c: "aadharNumber_04114c",
    // panNumber_72113f: "panNumber_72113f",

}

export const CUSTOM_FIELD_VALIDATION = {
    TEXT: [CUSTOM_FIELD.VALIDATION_TYPES.MIN_LENGTH, CUSTOM_FIELD.VALIDATION_TYPES.MAX_LENGTH],
    TEXT_AREA: [CUSTOM_FIELD.VALIDATION_TYPES.MIN_LENGTH, CUSTOM_FIELD.VALIDATION_TYPES.MAX_LENGTH],
    EMAIL: [CUSTOM_FIELD.VALIDATION_TYPES.MUST_BE_VALID_EMAIL],
    NUMBER: [CUSTOM_FIELD.VALIDATION_TYPES.MIN_VALUE, CUSTOM_FIELD.VALIDATION_TYPES.MAX_VALUE],
    DATE: [CUSTOM_FIELD.VALIDATION_TYPES.MUST_BE_FUTURE, CUSTOM_FIELD.VALIDATION_TYPES.MUST_BE_PAST],
    // SELECT: [],
    // RADIO: [],
    // CHECKBOX: [],
    // FILE: [],
}

export const ON_ACTION = {
    OPTION_CHANGE: 1,
    SHOW: 2,
    HIDE: 3,
    DISABLE: 4,
    CALCULATE: 5,
    GROUP_TOGGLE: 6,// show hid kind off
    API_CALLING: 7, //
    VALIDATION_CHANGE: 8,
    CLEAR_VALUE: 9,
    VALUE_CHANGE: 10,
    VALUE_TEST:11, // for regex and handlin case
}

export const OPERATORS = {
    EQUALS: 'equals',
    NOT_EQUALS: 'notEquals',
    INCLUDES: 'includes',
    NOT_INCLUDES: 'notIncludes',
    GREATER_THAN: 'gt',
    LESS_THAN: 'lt',
    GREATER_EQUAL: 'gte',
    LESS_EQUAL: 'lte',
    CONTAINS: 'contains',
    EMPTY: 'empty',
    NOT_EMPTY: 'notEmpty',
    DATE_BEFORE: 'dateBefore',
    DATE_AFTER: 'dateAfter',
    IS_TRUTHY: 'isTruthy',         // ✅ New
    IS_NOT_TRUTHY: 'isNotTruthy', // ✅ New
};

export const SYNC_TYPE = {
    onLoadBackendSync: 1,
    onChangeBackendSync: 2,
    localSync: 3,
}

export const EFFECTS = {
    onChange: 'onChangeEffect',
    onPageLoad: 'onPageLoadEffect',
    onBlur: 'onBlur',
    onKeyUp: 'onKeyUp',
};

export const COMPARE_KEY = {
    options: "options",
    value: "value", // By Default Comare value

}


export const PROFILE_UAC = {
    basicInfo: "basicInfo",
    familyInfo: "familyInfo",
    contactSocialLinks: "contactSocialLinks",
    address: "address",
    education: "education",
    previousEmployer: "previousEmployer",
    emergencyContact: "emergencyContact",
    jobInfo: "jobInfo",
    orgStructure: "orgStructure",
    agreementInfo: "agreementInfo",
    compensationInfo: "compensationInfo",
    employeeResignation: "employeeResignation",
    employeeHistory: "employeeHistory",
    internshipProbation: "internshipProbation",
    bankInfo: "bankInfo",
    healthBenefit: "healthBenefit",
    vaccinationStatus: "vaccinationStatus",
    setting: "setting",
    personalDocument: "personalDocument",
    officialDocument: "officialDocument",
    otherDocument: "otherDocument",
    profileUpdateRequests: "profileUpdateRequests",
    fullFinalSettlement: "fullFinalSettlement",
    timelineFeedback: "timelineFeedback",
    statutoryComponent: "statutoryComponent",
    changePassword: "changePassword",
    changePin: "changePin",
    myProfilePhoto: "myProfilePhoto",
    myProfileCompletionReport: "myProfileCompletionReport",
    assetScanner: "assetScanner",
    myAssetRequest: "myAssetRequest",
    subCompany: "subCompany",
    employeeId: "employeeId",
    uniqueId: "uniqueId",
    joiningDate: "joiningDate",
    dateOfBirth: "dateOfBirth",
    workEmail: "workEmail",
    personalEmail: "personalEmail",
    phoneNumber: "phoneNumber",
    userName: "userName",
    documents: "documents",
    previousExperience: "previousExperience",
    employeeProfilePhoto: "employeeProfilePhoto",
}

export const DIFF_KEY = {
    basicInfo: 1,
    jobInfo: 2,
    addEmployee: 10,
    preboarding : 11,
    profileJobInfo: 12,
    profileBasicInfo: 13,
}

export const CONTEXT_KEY = {
    preboardingData: "preboardingData",
    jobInfoData: "jobInfoData",
    basicInfoData: "basicInfoData",
}
// OT- Pay Codes
export const OT_PAY_UNIT = [
    {label: "Hourly", value: 1},
    {label: "Daily", value: 2},
    {label: "Monthly", value: 3},
    {label: "Fixed", value: 4},
]
